// Board Exam - Restorative and Specialty Care
// Complete file with all 5 topics and questions

export const questions = {
  "1. Dental Implants and Implant Care": [
    {
      id: 23100,
      question: "What is the primary advantage of dental implants over traditional fixed bridges?",
      options: [
        "They require less time for placement and healing",
        "They are more conservative to existing tooth structure",
        "They eliminate the need for professional maintenance",
        "They provide better aesthetic outcomes in all cases"
      ],
      correct: "B"
    },
    {
      id: 23101,
      question: "Which component of a dental implant is defined as the apparent direct attachment of osseous tissue without intervening fibrous connective tissue?",
      options: [
        "Abutment",
        "Prosthesis",
        "Osseointegration",
        "Healing collar"
      ],
      correct: "C"
    },
    {
      id: 23102,
      question: "According to the chapter, which of the following is a generally accepted contraindication to dental implant placement?",
      options: [
        "Age over 65 years",
        "Previous tooth extraction",
        "Smoking more than 10 cigarettes per day",
        "Mild hypertension"
      ],
      correct: "C"
    },
    {
      id: 23103,
      question: "What is the typical healing period recommended after implant placement before the restorative process begins?",
      options: [
        "1 to 2 months",
        "3 to 6 months",
        "6 to 9 months",
        "9 to 12 months"
      ],
      correct: "B"
    },
    {
      id: 23104,
      question: "Which diagnostic imaging technique provides three-dimensional visualization for dental implant planning?",
      options: [
        "Bitewing radiographs",
        "Panoramic radiographs",
        "Cone-beam computed tomography",
        "Periapical films"
      ],
      correct: "C"
    },
    {
      id: 23105,
      question: "What is the purpose of a surgical guide during implant placement?",
      options: [
        "To measure bone density during surgery",
        "To transfer planned information for precise implant placement",
        "To prevent infection during the surgical procedure",
        "To reduce patient discomfort during drilling"
      ],
      correct: "B"
    },
    {
      id: 23106,
      question: "Which term describes the site preparation for dental implant placement?",
      options: [
        "Osseointegration",
        "Osteotomy",
        "Osteoplasty",
        "Ostectomy"
      ],
      correct: "B"
    },
    {
      id: 23107,
      question: "What is the primary function of a healing abutment?",
      options: [
        "To provide temporary chewing function",
        "To allow formation of a mucosal collar around the abutment",
        "To prevent bone resorption during healing",
        "To measure the depth of implant placement"
      ],
      correct: "B"
    },
    {
      id: 23108,
      question: "Which prosthetic design factor is most important for allowing appropriate daily oral biofilm removal?",
      options: [
        "Shade matching",
        "Material hardness",
        "Emergence profile and interproximal space",
        "Crown height"
      ],
      correct: "C"
    },
    {
      id: 23109,
      question: "What material are dental implants traditionally made from?",
      options: [
        "Stainless steel or chrome alloy",
        "Commercially pure titanium or titanium alloy",
        "Ceramic or zirconia only",
        "Gold alloy or platinum"
      ],
      correct: "B"
    },
    {
      id: 23110,
      question: "What is the significance of the \"microgap\" at the implant-abutment interface?",
      options: [
        "It prevents bacterial colonization",
        "It is large enough to allow bacterial colonization",
        "It improves osseointegration",
        "It reduces mechanical stress"
      ],
      correct: "B"
    },
    {
      id: 23111,
      question: "Which design modification appears to result in slightly less peri-implant bone loss?",
      options: [
        "External hex connection",
        "Tissue-level placement",
        "Platform-switching",
        "Parallel-walled design"
      ],
      correct: "C"
    },
    {
      id: 23112,
      question: "What is the main advantage of a screw-retained crown over a cement-retained crown?",
      options: [
        "Better aesthetic outcome",
        "Easier to fabricate",
        "Retrievability and lack of cement",
        "Lower cost"
      ],
      correct: "C"
    },
    {
      id: 23113,
      question: "Which type of cement is recommended for implant restorations due to its radiopacity and ease of removal?",
      options: [
        "Resin cement",
        "Glass ionomer cement",
        "Zinc-containing cement",
        "Polycarboxylate cement"
      ],
      correct: "C"
    },
    {
      id: 23114,
      question: "Why might dark abutment materials lead to aesthetic concerns?",
      options: [
        "They cause faster biofilm accumulation",
        "They may show through thin tissue if bone loss occurs",
        "They corrode more quickly than other materials",
        "They prevent proper osseointegration"
      ],
      correct: "B"
    },
    {
      id: 23115,
      question: "What is the main advantage of a removable implant-supported prosthesis?",
      options: [
        "Lower initial cost",
        "Better aesthetic outcomes",
        "Ability to remove for cleaning and tissue access",
        "Longer lifespan than fixed prostheses"
      ],
      correct: "C"
    },
    {
      id: 23116,
      question: "What design consideration is critical for fixed prostheses in edentulous patients?",
      options: [
        "Maximum ridge-lap for aesthetics",
        "Convex intaglio surface with hygiene access",
        "Minimal space between tissue and prosthesis",
        "Heavy metal framework for durability"
      ],
      correct: "B"
    },
    {
      id: 23117,
      question: "Which team member is responsible for long-term implant maintenance and evaluation?",
      options: [
        "The surgeon only",
        "The patient only",
        "The restorative team including the dental hygienist",
        "The dental laboratory technician"
      ],
      correct: "C"
    },
    {
      id: 23118,
      question: "What is the key difference between peri-implant tissue and natural tooth tissue?",
      options: [
        "Peri-implant tissue has more blood supply",
        "Peri-implant tissue has Sharpey fibers",
        "Peri-implant tissue lacks connective tissue attachment",
        "Peri-implant tissue is always keratinized"
      ],
      correct: "C"
    },
    {
      id: 23119,
      question: "Why does keratinized mucosa around implants appear different from nonkeratinized mucosa?",
      options: [
        "Keratinized tissue appears redder even when healthy",
        "Nonkeratinized tissue appears redder even when healthy",
        "Keratinized tissue bleeds more easily",
        "There is no visual difference"
      ],
      correct: "B"
    },
    {
      id: 23120,
      question: "What force should be used when probing dental implants?",
      options: [
        "Heavy force (50 N)",
        "Light force (25 N)",
        "Moderate force (35 N)",
        "No specific force recommendation"
      ],
      correct: "B"
    },
    {
      id: 23121,
      question: "When should the initial probing of a dental implant be performed?",
      options: [
        "Immediately after implant placement",
        "During the healing period",
        "Once the final restoration has been placed",
        "Only if problems are suspected"
      ],
      correct: "C"
    },
    {
      id: 23122,
      question: "Why is a baseline probing depth essential for dental implants?",
      options: [
        "Implants may have greater than 3 mm depths initially",
        "To determine if osseointegration occurred",
        "To measure the implant length",
        "To assess abutment stability"
      ],
      correct: "A"
    },
    {
      id: 23123,
      question: "What indicates that an implant is no longer integrated?",
      options: [
        "Probing depth greater than 3 mm",
        "Bleeding on probing",
        "Mobility of the implant",
        "Presence of biofilm"
      ],
      correct: "C"
    },
    {
      id: 23124,
      question: "How much initial bone remodeling is considered within normal limits during the first year?",
      options: [
        "0.5 mm",
        "1 mm",
        "2 mm",
        "3 mm"
      ],
      correct: "B"
    },
    {
      id: 23125,
      question: "What is a limitation of conventional radiographs for assessing implants?",
      options: [
        "They cannot show the implant at all",
        "They have limited use in assessing buccal and lingual changes",
        "They are too expensive",
        "They expose patients to excessive radiation"
      ],
      correct: "B"
    },
    {
      id: 23126,
      question: "Which mechanical complication might be identified during implant maintenance?",
      options: [
        "Peri-implantitis",
        "Mucositis",
        "Loose or fractured screws",
        "Bleeding on probing"
      ],
      correct: "C"
    },
    {
      id: 23127,
      question: "What iatrogenic complication is associated with increased risk of peri-implant bone loss?",
      options: [
        "Over-torquing the implant",
        "Excess cement",
        "Insufficient anesthesia",
        "Prolonged surgery time"
      ],
      correct: "B"
    },
    {
      id: 23128,
      question: "What is peri-implant mucositis defined as?",
      options: [
        "Irreversible bone loss around an implant",
        "A reversible inflammatory reaction in the mucosa",
        "Complete implant failure",
        "Infection requiring antibiotic therapy"
      ],
      correct: "B"
    },
    {
      id: 23129,
      question: "Which condition must be present to diagnose peri-implant mucositis?",
      options: [
        "Suppuration",
        "Mobility",
        "Bleeding on probing",
        "Radiographic bone loss"
      ],
      correct: "C"
    },
    {
      id: 23130,
      question: "What is peri-implantitis associated with?",
      options: [
        "Reversible inflammation without bone loss",
        "Loss of bone around a functioning implant",
        "Soft tissue overgrowth",
        "Abutment fracture"
      ],
      correct: "B"
    },
    {
      id: 23131,
      question: "According to the 2017 World Workshop, what probing depth is used to diagnose peri-implantitis in the absence of previous data?",
      options: [
        "≥3 mm",
        "≥4 mm",
        "≥5 mm",
        "≥6 mm"
      ],
      correct: "D"
    },
    {
      id: 23132,
      question: "What is the reported prevalence of peri-implantitis according to the systematic review cited?",
      options: [
        "8.5%",
        "12.5%",
        "18.5%",
        "25.5%"
      ],
      correct: "C"
    },
    {
      id: 23133,
      question: "Which is NOT listed as a risk factor for peri-implant disease?",
      options: [
        "Poor oral hygiene",
        "History of periodontal disease",
        "Patient age",
        "Smoking"
      ],
      correct: "C"
    },
    {
      id: 23134,
      question: "Why must patients understand that implants require maintenance?",
      options: [
        "To ensure warranty coverage",
        "Because implants are not problem-free despite being artificial",
        "To prevent aesthetic complications only",
        "Because all implants eventually fail"
      ],
      correct: "B"
    },
    {
      id: 23135,
      question: "What type of toothbrush is especially important for implant patients?",
      options: [
        "Hard bristled",
        "Medium bristled",
        "Soft bristled",
        "Any type is acceptable"
      ],
      correct: "C"
    },
    {
      id: 23136,
      question: "Why should patients with removable implant prostheses remove them while sleeping?",
      options: [
        "To prevent implant damage",
        "To allow tissue rest and health",
        "To prevent accidental swallowing",
        "To improve sleep quality"
      ],
      correct: "B"
    },
    {
      id: 23137,
      question: "What motion should be used when flossing around implant abutments?",
      options: [
        "Up and down motion",
        "Circular motion",
        "Shoe-shining motion",
        "Side-to-side only"
      ],
      correct: "C"
    },
    {
      id: 23138,
      question: "Why are nylon-coated interdental brushes required for implants?",
      options: [
        "They are softer on gingival tissue",
        "To avoid alteration of the abutment surface",
        "They last longer than metal",
        "They are less expensive"
      ],
      correct: "B"
    },
    {
      id: 23139,
      question: "What characteristic should toothpaste have for implant patients?",
      options: [
        "High fluoride content",
        "Whitening properties",
        "Low abrasiveness",
        "High abrasiveness for better cleaning"
      ],
      correct: "C"
    },
    {
      id: 23140,
      question: "What is a concern about using chlorhexidine to decontaminate diseased implants?",
      options: [
        "It causes immediate implant failure",
        "It may be adsorbed on titanium and prevent bone cell reattachment",
        "It is too expensive for routine use",
        "It has no effect on implant biofilm"
      ],
      correct: "B"
    },
    {
      id: 23141,
      question: "How long can chlorhexidine gluconate reduce oral bacteria after use?",
      options: [
        "Up to 2 hours",
        "Up to 5 hours",
        "Up to 8 hours",
        "Up to 12 hours"
      ],
      correct: "B"
    },
    {
      id: 23142,
      question: "What happens if chlorhexidine is used as a rinse for more than a month?",
      options: [
        "It loses effectiveness",
        "It may cause staining",
        "It causes tissue damage",
        "It prevents osseointegration"
      ],
      correct: "B"
    },
    {
      id: 23143,
      question: "What is the effect of not enrolling in maintenance programs on peri-implantitis incidence?",
      options: [
        "No difference",
        "Slightly higher incidence",
        "Higher incidence",
        "Lower incidence"
      ],
      correct: "C"
    },
    {
      id: 23144,
      question: "How much did regular maintenance reduce implant failure in the retrospective review of 1020 implants?",
      options: [
        "50%",
        "70%",
        "90%",
        "100%"
      ],
      correct: "C"
    },
    {
      id: 23145,
      question: "What is the recommended minimum frequency for professional examination of implants?",
      options: [
        "Every 3 months",
        "Every 6 months",
        "Every 9 months",
        "Every 12 months"
      ],
      correct: "B"
    },
    {
      id: 23146,
      question: "What provides the titanium implant with chemical stability and biocompatibility?",
      options: [
        "The rough surface texture",
        "The titanium dioxide layer",
        "The implant threads",
        "The abutment connection"
      ],
      correct: "B"
    },
    {
      id: 23147,
      question: "How thick does the titanium dioxide layer become after 4 years?",
      options: [
        "5 nm",
        "10 nm",
        "25 nm",
        "50 nm"
      ],
      correct: "C"
    },
    {
      id: 23148,
      question: "Why should scratching or gouging the titanium surface be avoided?",
      options: [
        "It weakens the implant structure",
        "It creates areas retentive to biofilm and disrupts the protective layer",
        "It causes immediate implant failure",
        "It prevents the prosthesis from fitting"
      ],
      correct: "B"
    },
    {
      id: 23149,
      question: "Which air polishing powder is shown to be safe and effective for implant biofilm removal?",
      options: [
        "Sodium bicarbonate",
        "Calcium carbonate",
        "Erythritol or glycine powder",
        "Aluminum oxide"
      ],
      correct: "C"
    },
    {
      id: 23150,
      question: "What is the advantage of air polishing for implant maintenance?",
      options: [
        "It removes calculus effectively",
        "It reaches areas difficult to access with instruments",
        "It is less expensive than other methods",
        "It whitens the implant surface"
      ],
      correct: "B"
    },
    {
      id: 23151,
      question: "According to systematic review, which instruments are the instruments of choice for implants?",
      options: [
        "Stainless steel curets",
        "Nonmetal instruments",
        "Ultrasonic scalers",
        "Rotating burs"
      ],
      correct: "B"
    },
    {
      id: 23152,
      question: "What problem is associated with plastic instruments on implant surfaces?",
      options: [
        "They are too aggressive",
        "They leave behind debris that may interfere with osteoblast attachment",
        "They cannot remove biofilm",
        "They cause excessive bleeding"
      ],
      correct: "B"
    },
    {
      id: 23153,
      question: "Why might titanium curets be preferred over plastic curets?",
      options: [
        "They are less expensive",
        "They produce minimal surface alteration and avoid debris accumulation",
        "They work faster",
        "They are easier to sharpen"
      ],
      correct: "B"
    },
    {
      id: 23154,
      question: "Which instruments are strongly contraindicated for use on dental implants?",
      options: [
        "Titanium curets",
        "Plastic scalers",
        "Stainless steel curets and metal ultrasonic tips",
        "Graphite-filled curets"
      ],
      correct: "C"
    },
    {
      id: 23155,
      question: "What concern exists regarding sonic and ultrasonic implant tips?",
      options: [
        "They may affect osteoblast cell viability",
        "They are too expensive",
        "They cannot access subgingival areas",
        "They cause patient discomfort"
      ],
      correct: "A"
    },
    {
      id: 23156,
      question: "What causes the progression from mucositis to peri-implantitis?",
      options: [
        "The progression timeline is clearly defined",
        "The progression is difficult to determine",
        "It always occurs within 6 months",
        "It never progresses if biofilm is removed"
      ],
      correct: "B"
    },
    {
      id: 23157,
      question: "Can peri-implant mucositis be successfully treated nonsurgically?",
      options: [
        "No, it always requires surgery",
        "Only in the first month after diagnosis",
        "Yes, it is reversible with biofilm removal",
        "Only with antibiotics"
      ],
      correct: "C"
    },
    {
      id: 23158,
      question: "What is the efficacy of nonsurgical treatment alone for peri-implantitis?",
      options: [
        "Highly effective",
        "Moderately effective",
        "Limited efficacy",
        "No efficacy"
      ],
      correct: "C"
    },
    {
      id: 23159,
      question: "What should be under control before considering surgical therapy for peri-implantitis?",
      options: [
        "Patient anxiety",
        "Local and systemic factors like poor oral hygiene and smoking",
        "Insurance coverage",
        "Weather conditions"
      ],
      correct: "B"
    },
    {
      id: 23160,
      question: "What does surgical therapy for peri-implantitis include?",
      options: [
        "Implant removal only",
        "Granulation tissue removal and surface cleaning",
        "Antibiotic injection only",
        "Soft tissue grafting only"
      ],
      correct: "B"
    },
    {
      id: 23161,
      question: "What was the recurrence rate in some peri-implantitis treatment studies?",
      options: [
        "Up to 25%",
        "Up to 50%",
        "Up to 75%",
        "Up to 100%"
      ],
      correct: "D"
    },
    {
      id: 23162,
      question: "What type of disease is peri-implantitis considered to be?",
      options: [
        "Acute infectious disease",
        "Chronic disease",
        "Self-limiting disease",
        "Congenital disease"
      ],
      correct: "B"
    },
    {
      id: 23163,
      question: "Which factor should NOT influence implant instrument selection?",
      options: [
        "Instrument rigidity and design",
        "Prosthetic appliance design",
        "Cost of the instrument",
        "Calculus tenacity"
      ],
      correct: "C"
    },
    {
      id: 23164,
      question: "What is the role of the dental hygienist in the implant treatment team?",
      options: [
        "Surgical placement only",
        "Prosthesis fabrication only",
        "Long-term maintenance and evaluation",
        "Financial counseling only"
      ],
      correct: "C"
    },
    {
      id: 23165,
      question: "During which phase should patients be informed of implant risk factors?",
      options: [
        "Only after implant failure",
        "From the planning phase throughout treatment",
        "Only during the restorative phase",
        "Only at annual examinations"
      ],
      correct: "B"
    },
    {
      id: 23166,
      question: "What should be done if a patient cannot access any area of an implant prosthesis?",
      options: [
        "Nothing, it is normal",
        "Oral hygiene instruction and/or prosthesis modification",
        "Immediate implant removal",
        "Prescribe antibiotics"
      ],
      correct: "B"
    },
    {
      id: 23167,
      question: "How often should oral hygiene instruction be provided during implant treatment?",
      options: [
        "Only once before surgery",
        "Only after the prosthesis is placed",
        "Before, throughout, and after prosthetic placement",
        "Only when problems occur"
      ],
      correct: "C"
    },
    {
      id: 23168,
      question: "What determines whether a fixed implant prosthesis should be removed during maintenance?",
      options: [
        "It must be removed at every visit",
        "Individual assessment based on cleaning ability and oral hygiene",
        "It should never be removed",
        "Only the patient\'s preference"
      ],
      correct: "B"
    },
    {
      id: 23169,
      question: "What should be considered when old screws are removed from implant restorations?",
      options: [
        "They must be reused to save cost",
        "Replacing them with new screws should be considered",
        "They should be sterilized and reused",
        "The implant must be replaced"
      ],
      correct: "B"
    },
    {
      id: 23170,
      question: "What might a loose feeling in a crown or overdenture indicate?",
      options: [
        "Normal settling",
        "Loose abutment screw, O-ring, clip, or fractured components",
        "Successful osseointegration",
        "Optimal fit"
      ],
      correct: "B"
    },
    {
      id: 23171,
      question: "Why might an occlusal guard be recommended for implant patients?",
      options: [
        "To improve aesthetics",
        "To prevent porcelain fractures from excessive forces",
        "To speed up osseointegration",
        "To reduce cost of maintenance"
      ],
      correct: "B"
    },
    {
      id: 23172,
      question: "What type of fiber arrangement is present around implants?",
      options: [
        "Sharpey fibers",
        "Circular fibers only",
        "Periodontal ligament fibers",
        "All types found around natural teeth"
      ],
      correct: "B"
    },
    {
      id: 23173,
      question: "How does blood supply differ around implants compared to natural teeth?",
      options: [
        "Implants have more blood supply",
        "Implants have the same blood supply",
        "Implants have decreased blood supply due to lack of periodontal ligament",
        "Blood supply is not important for implants"
      ],
      correct: "C"
    },
    {
      id: 23174,
      question: "What can indicate inflammation in peri-implant tissue besides color?",
      options: [
        "Implant mobility only",
        "Swelling, contour of tissue margin, and bleeding on probing",
        "Radiographic changes only",
        "Patient symptoms only"
      ],
      correct: "B"
    },
    {
      id: 23175,
      question: "Why has there been historical controversy about probing implants?",
      options: [
        "Concerns about breaking epithelial attachment or scratching titanium",
        "It is too painful for patients",
        "It is too time-consuming",
        "It provides no useful information"
      ],
      correct: "A"
    },
    {
      id: 23176,
      question: "What do studies show about probing implants with proper technique?",
      options: [
        "It always causes harm",
        "No evidence suggests harm to surfaces or prognosis",
        "It should only be done annually",
        "It causes immediate bone loss"
      ],
      correct: "B"
    },
    {
      id: 23177,
      question: "Why is consistency in probing technique important?",
      options: [
        "To reduce cost",
        "For validity in interpreting changes in probing depths",
        "To speed up the appointment",
        "To satisfy insurance requirements"
      ],
      correct: "B"
    },
    {
      id: 23178,
      question: "When should radiographs be available during implant probing?",
      options: [
        "They are not necessary",
        "Only if bone loss is suspected",
        "During probing because implant diameter varies",
        "Only at the first visit"
      ],
      correct: "C"
    },
    {
      id: 23179,
      question: "When is the first radiograph of an implant typically taken?",
      options: [
        "Only after the prosthesis is placed",
        "At implant fixture placement",
        "Only if problems occur",
        "Never, radiographs are not needed"
      ],
      correct: "B"
    },
    {
      id: 23180,
      question: "What role does the restorative dentist have in implant prosthesis removal?",
      options: [
        "No role, the hygienist decides",
        "Determining if the prosthesis needs to be removed",
        "Only removing failed implants",
        "Only cosmetic adjustments"
      ],
      correct: "B"
    },
    {
      id: 23181,
      question: "Which type of connection became the standard before internal connections?",
      options: [
        "Ball attachment",
        "Morse taper",
        "External hex",
        "Tri-channel"
      ],
      correct: "C"
    },
    {
      id: 23182,
      question: "Why are internal connection implants favored over external hex?",
      options: [
        "Lower cost",
        "Decreased screw loosening and better force distribution",
        "Easier to place",
        "Better aesthetics only"
      ],
      correct: "B"
    },
    {
      id: 23183,
      question: "What allows orthodontic repositioning but cannot be altered once integrated?",
      options: [
        "Natural teeth can be moved; implants cannot",
        "Implants can be moved; natural teeth cannot",
        "Both can be moved equally",
        "Neither can be moved"
      ],
      correct: "A"
    },
    {
      id: 23184,
      question: "What is the objective of virtual implant treatment planning?",
      options: [
        "To reduce the cost of treatment",
        "To determine implant position relative to planned prosthesis and anatomy",
        "To eliminate the need for surgery",
        "To shorten treatment time"
      ],
      correct: "B"
    },
    {
      id: 23185,
      question: "What does insertion torque help determine?",
      options: [
        "The final cost of treatment",
        "The ability to place a temporary restoration or healing time needed",
        "The implant manufacturer",
        "The patient\'s pain level"
      ],
      correct: "B"
    },
    {
      id: 23186,
      question: "What physiologic process occurs during the 3-6 month healing period?",
      options: [
        "Bone resorption",
        "Osseointegration with surrounding bone",
        "Soft tissue keratinization only",
        "Implant surface degradation"
      ],
      correct: "B"
    },
    {
      id: 23187,
      question: "Why were implants traditionally buried during initial healing?",
      options: [
        "To prevent infection",
        "To allow healing without oral cavity exposure",
        "To improve aesthetics",
        "To reduce cost"
      ],
      correct: "B"
    },
    {
      id: 23188,
      question: "What is now commonly placed at the time of surgery in many cases?",
      options: [
        "The final prosthesis always",
        "A transmucosal abutment or temporary restoration",
        "Nothing, all implants are buried",
        "Bone graft material only"
      ],
      correct: "B"
    },
    {
      id: 23189,
      question: "What is critical during the healing period after stage two surgery?",
      options: [
        "Avoiding all oral hygiene",
        "Wound care and oral hygiene",
        "Eating only soft foods",
        "Taking antibiotics"
      ],
      correct: "B"
    },
    {
      id: 23190,
      question: "What does the healing abutment allow to form?",
      options: [
        "New bone around the implant",
        "A mucosal collar for prosthetic component connection",
        "Keratinized tissue in all cases",
        "A periodontal ligament"
      ],
      correct: "B"
    },
    {
      id: 23191,
      question: "Why is prosthesis design considered critical but not the final step?",
      options: [
        "Because aesthetics is most important",
        "Because maintenance is ongoing and essential for success",
        "Because surgery is more important",
        "Because it costs the most"
      ],
      correct: "B"
    },
    {
      id: 23192,
      question: "What design factors allow appropriate daily oral biofilm removal?",
      options: [
        "Color and shade only",
        "Texture, material, emergence profile, interproximal space, tissue contact",
        "Size and shape only",
        "Cost and durability only"
      ],
      correct: "B"
    }
  ],
  "2. Restorative Dental Care": [
    {
      id: 23200,
      question: "Which state was the first in the United States to legislate educational requirements including restorative and local anesthetic delivery in dental hygiene education?",
      options: [
        "Washington",
        "Alaska",
        "Minnesota",
        "California"
      ],
      correct: "A"
    },
    {
      id: 23201,
      question: "What is the primary goal of restorative therapy?",
      options: [
        "To replace missing teeth only",
        "To restore dentition to health, maintain function, and provide esthetic modification",
        "To prevent all future dental disease",
        "To eliminate the need for oral hygiene"
      ],
      correct: "B"
    },
    {
      id: 23202,
      question: "Which restorative material is considered the longest-lasting?",
      options: [
        "Composite resin",
        "Glass ionomer",
        "Amalgam",
        "Porcelain"
      ],
      correct: "C"
    },
    {
      id: 23203,
      question: "What term describes defects caused by the practitioner\'s placement technique?",
      options: [
        "Pathogenic",
        "Iatrogenic",
        "Cariogenic",
        "Systemic"
      ],
      correct: "B"
    },
    {
      id: 23204,
      question: "Which of the following is a main disadvantage of metallic restorations?",
      options: [
        "Cost",
        "Durability",
        "Esthetics",
        "Strength"
      ],
      correct: "C"
    },
    {
      id: 23205,
      question: "What is the selective reduction of enamel to improve occlusion called?",
      options: [
        "Occlusal adjustment",
        "Enamel reduction",
        "Crown preparation",
        "Cavity preparation"
      ],
      correct: "A"
    },
    {
      id: 23206,
      question: "Which state is unique in requiring competence in restorative procedures for initial dental hygiene licensure?",
      options: [
        "Alaska",
        "Minnesota",
        "Washington",
        "Oregon"
      ],
      correct: "C"
    },
    {
      id: 23207,
      question: "What type of restoration is placed and formed directly in a cavity preparation?",
      options: [
        "Indirect restoration",
        "Direct restoration",
        "Laboratory restoration",
        "Cast restoration"
      ],
      correct: "B"
    },
    {
      id: 23208,
      question: "Which classification system is used to describe the type and location of dental caries and restorations?",
      options: [
        "Miller\'s Classification",
        "Black\'s Classification",
        "ADA Classification",
        "Both B and C"
      ],
      correct: "D"
    },
    {
      id: 23209,
      question: "What is the first step in GV Black cavity preparation?",
      options: [
        "Obtain resistance form",
        "Remove caries",
        "Establish outline form",
        "Finish enamel"
      ],
      correct: "C"
    },
    {
      id: 23210,
      question: "What is the primary purpose of dental isolation?",
      options: [
        "Patient comfort only",
        "Moisture control, accessibility, and protection",
        "To prevent gagging",
        "To reduce appointment time"
      ],
      correct: "B"
    },
    {
      id: 23211,
      question: "Which isolation method is universally accepted as the standard?",
      options: [
        "Cotton rolls",
        "Dry angles",
        "Dental dam",
        "Isolite system"
      ],
      correct: "C"
    },
    {
      id: 23212,
      question: "What percentage of the amalgam mixture does mercury comprise?",
      options: [
        "25%",
        "50%",
        "75%",
        "90%"
      ],
      correct: "B"
    },
    {
      id: 23213,
      question: "Which matrix system is most typically used for Class II amalgam restorations?",
      options: [
        "Sectional matrix",
        "Mylar strip",
        "Tofflemire retainer and bands",
        "Cervical matrix"
      ],
      correct: "C"
    },
    {
      id: 23214,
      question: "What is the main advantage of a screw-retained crown over a cement-retained crown?",
      options: [
        "Lower cost",
        "Better esthetics",
        "Retrievability and lack of cement",
        "Faster placement"
      ],
      correct: "C"
    },
    {
      id: 23215,
      question: "Which type of cement is recommended for implant restorations due to radiopacity?",
      options: [
        "Resin cement",
        "Zinc-containing cement",
        "Glass ionomer",
        "Polycarboxylate"
      ],
      correct: "B"
    },
    {
      id: 23216,
      question: "What force should be used when condensing amalgam?",
      options: [
        "Light pressure",
        "No pressure",
        "Firm pressure",
        "Variable pressure"
      ],
      correct: "C"
    },
    {
      id: 23217,
      question: "How long should amalgam restorations be allowed to set before finishing or polishing?",
      options: [
        "Immediately",
        "6 hours",
        "At least 24 hours",
        "1 week"
      ],
      correct: "C"
    },
    {
      id: 23218,
      question: "What is the typical maximum increment thickness for composite placement?",
      options: [
        "1 mm",
        "2 mm",
        "3 mm",
        "5 mm"
      ],
      correct: "B"
    },
    {
      id: 23219,
      question: "Which bonding concept allows for minimally invasive dentistry?",
      options: [
        "Chemical bonding",
        "Mechanical retention",
        "Micromechanical or enamel bonding",
        "Friction fit"
      ],
      correct: "C"
    },
    {
      id: 23220,
      question: "What is the term for the bond between dentin and composite material?",
      options: [
        "Enamel bonding",
        "Chemical adhesion",
        "Hybridization bonding",
        "Mechanical retention"
      ],
      correct: "C"
    },
    {
      id: 23221,
      question: "What wavelength range does the curing light use?",
      options: [
        "Red wavelength",
        "Blue wavelength",
        "Green wavelength",
        "Ultraviolet wavelength"
      ],
      correct: "B"
    },
    {
      id: 23222,
      question: "What is the minimum recommended light intensity for adequate curing?",
      options: [
        "200 mW/cm²",
        "300 mW/cm²",
        "400 mW/cm² or higher",
        "600 mW/cm²"
      ],
      correct: "C"
    },
    {
      id: 23223,
      question: "What is the purpose of wedges in matrix systems?",
      options: [
        "To hold the retainer in place",
        "To displace gingival papilla and support the matrix band",
        "To measure the cavity depth",
        "To prevent bleeding"
      ],
      correct: "B"
    },
    {
      id: 23224,
      question: "Which matrix system creates interproximal pressure for composite restorations?",
      options: [
        "Tofflemire system",
        "Sectional pressure matrix system",
        "Mylar strip",
        "T-band system"
      ],
      correct: "B"
    },
    {
      id: 23225,
      question: "What material is used as a base in cavity preparations?",
      options: [
        "Bonding resin only",
        "Glass ionomer cements or zinc phosphate cement",
        "Composite resin",
        "Amalgam"
      ],
      correct: "B"
    },
    {
      id: 23226,
      question: "What is the primary function of cavity liners?",
      options: [
        "To provide structural support",
        "To be applied as a thin coating to seal dentinal tubules",
        "To replace lost tooth structure",
        "To improve esthetics"
      ],
      correct: "B"
    },
    {
      id: 23227,
      question: "What does the smear layer consist of?",
      options: [
        "Saliva and bacteria only",
        "Microscopic tooth particles, biofilm, and debris",
        "Enamel crystals only",
        "Blood and tissue fluid"
      ],
      correct: "B"
    },
    {
      id: 23228,
      question: "What is created when the smear layer is removed and bonding agent applied?",
      options: [
        "Enamel layer",
        "Dentin layer",
        "Hybrid layer",
        "Composite layer"
      ],
      correct: "C"
    },
    {
      id: 23229,
      question: "How does acid etching prepare enamel for bonding?",
      options: [
        "It smooths the surface",
        "It roughens the surface",
        "It seals the surface",
        "It whitens the surface"
      ],
      correct: "B"
    },
    {
      id: 23230,
      question: "What appearance indicates properly etched enamel?",
      options: [
        "Shiny appearance",
        "Frosty appearance",
        "Yellow appearance",
        "Transparent appearance"
      ],
      correct: "B"
    },
    {
      id: 23231,
      question: "Which component of composite provides strength and wear resistance?",
      options: [
        "Resin matrix only",
        "Filler particles",
        "Bonding agent",
        "Catalyst"
      ],
      correct: "B"
    },
    {
      id: 23232,
      question: "What is bisphenol-A (BPA) associated with in dental composites?",
      options: [
        "Improved strength",
        "Better esthetics",
        "Potential systemic diseases",
        "Increased longevity"
      ],
      correct: "C"
    },
    {
      id: 23233,
      question: "Which finishing instrument is best for concave surfaces in composite restorations?",
      options: [
        "Flame-shaped bur",
        "Egg or football-shaped bur",
        "Flat disc",
        "Round cup"
      ],
      correct: "B"
    },
    {
      id: 23234,
      question: "What is the purpose of bulk fill composites?",
      options: [
        "To reduce cost",
        "To allow placement in single increments up to 5 mm",
        "To improve esthetics",
        "To eliminate the need for bonding"
      ],
      correct: "B"
    },
    {
      id: 23235,
      question: "What type of material is resin-modified glass ionomer (RMGI)?",
      options: [
        "Metal alloy",
        "Ceramic",
        "Glass ionomer modified with resin",
        "Pure composite resin"
      ],
      correct: "C"
    },
    {
      id: 23236,
      question: "What is a major benefit of glass ionomer materials?",
      options: [
        "Superior strength",
        "Release of fluoride ions",
        "Fastest setting time",
        "Lowest cost"
      ],
      correct: "B"
    },
    {
      id: 23237,
      question: "Which preparation is primarily indicated for RMGI restorations?",
      options: [
        "Class I only",
        "Root caries and Class V lesions",
        "Class IV only",
        "Full crown preparations"
      ],
      correct: "B"
    },
    {
      id: 23238,
      question: "What can cause degradation of resin-modified glass ionomer over time?",
      options: [
        "Temperature changes only",
        "Chemical erosion through fluoride exposure",
        "Mechanical wear only",
        "Light exposure only"
      ],
      correct: "B"
    },
    {
      id: 23239,
      question: "How long should bleaching be stopped before restorative treatment involving bonding agents?",
      options: [
        "1-2 days",
        "1-2 weeks",
        "1-2 months",
        "Bleaching does not affect bonding"
      ],
      correct: "B"
    },
    {
      id: 23240,
      question: "What is the first step in finishing composite restorations?",
      options: [
        "Polishing",
        "Removal of flash and smoothing margins",
        "Checking occlusion",
        "Applying sealant"
      ],
      correct: "B"
    },
    {
      id: 23241,
      question: "Which abrasive is commonly used in polishing pastes for composites?",
      options: [
        "Pumice only",
        "Tin oxide only",
        "Aluminum oxide or diamond particles",
        "Sodium bicarbonate"
      ],
      correct: "C"
    },
    {
      id: 23242,
      question: "What type of crown is primarily used for primary teeth with extensive caries?",
      options: [
        "Gold crowns",
        "Porcelain crowns",
        "Stainless steel crowns",
        "Composite crowns"
      ],
      correct: "C"
    },
    {
      id: 23243,
      question: "What is the purpose of gingival retraction cord?",
      options: [
        "To stop bleeding only",
        "To expand the gingival sulcus for impression material",
        "To anesthetize tissue",
        "To remove calculus"
      ],
      correct: "B"
    },
    {
      id: 23244,
      question: "How should retraction cord be placed in the sulcus?",
      options: [
        "Forced apically with heavy pressure",
        "Gently rolled into place below the gingival margin",
        "Pulled tightly around the tooth",
        "Placed only on the facial surface"
      ],
      correct: "B"
    },
    {
      id: 23245,
      question: "What is the primary purpose of temporary restorations?",
      options: [
        "To replace permanent restorations",
        "To provide comfort and protection while waiting for permanent restoration",
        "To improve oral hygiene",
        "To prevent all tooth movement"
      ],
      correct: "B"
    },
    {
      id: 23246,
      question: "Which material readily restores intermediate-size cavities requiring durable temporary restoration?",
      options: [
        "Composite resin",
        "Glass ionomer",
        "Reinforced zinc oxide with eugenol (ZOE)",
        "Amalgam"
      ],
      correct: "C"
    },
    {
      id: 23247,
      question: "Why is ZOE not recommended when a bonded restoration is to be placed?",
      options: [
        "It is too weak",
        "Eugenol oil affects bond strength",
        "It is too expensive",
        "It dissolves too quickly"
      ],
      correct: "B"
    },
    {
      id: 23248,
      question: "What is the consistency of properly mixed reinforced ZOE?",
      options: [
        "Watery",
        "Thick and claylike",
        "Powder-like",
        "Gel-like"
      ],
      correct: "B"
    },
    {
      id: 23249,
      question: "What is a luting agent?",
      options: [
        "A cleaning solution",
        "A cement that fills the space between restoration and tooth",
        "A polishing compound",
        "An etching gel"
      ],
      correct: "B"
    },
    {
      id: 23250,
      question: "Which luting agent chemically adheres to the tooth surface?",
      options: [
        "Zinc phosphate",
        "Temporary cement",
        "Glass ionomer cement",
        "Wax"
      ],
      correct: "C"
    },
    {
      id: 23251,
      question: "What type of cement has the greatest bond strength?",
      options: [
        "Zinc phosphate",
        "Glass ionomer",
        "Resin cements",
        "Temporary cements"
      ],
      correct: "C"
    },
    {
      id: 23252,
      question: "What should be avoided when using temporary cement for bonded restorations?",
      options: [
        "Glass ionomer",
        "Zinc phosphate",
        "Materials containing eugenol",
        "Resin cement"
      ],
      correct: "C"
    },
    {
      id: 23253,
      question: "What must be documented in the patient record after restorative treatment?",
      options: [
        "Tooth number only",
        "Tooth number, surfaces, materials used, and patient education",
        "Patient name only",
        "Date only"
      ],
      correct: "B"
    },
    {
      id: 23254,
      question: "What is the purpose of finishing and polishing restorations?",
      options: [
        "To improve appearance only",
        "To produce a restoration that can be cleaned easily",
        "To increase cost",
        "To extend appointment time"
      ],
      correct: "B"
    },
    {
      id: 23255,
      question: "Which tool is used to mix amalgam capsules?",
      options: [
        "Amalgam well",
        "Triturator",
        "Condenser",
        "Carver"
      ],
      correct: "B"
    },
    {
      id: 23256,
      question: "What instrument is used to pack and adapt amalgam into the cavity?",
      options: [
        "Amalgam carrier",
        "Condenser",
        "Carver",
        "Burnisher"
      ],
      correct: "B"
    },
    {
      id: 23257,
      question: "What is the purpose of burnishing amalgam?",
      options: [
        "To remove excess",
        "To grossly shape and create a smooth finish",
        "To check occlusion",
        "To dry the material"
      ],
      correct: "B"
    },
    {
      id: 23258,
      question: "When should the matrix band be removed during amalgam placement?",
      options: [
        "Before condensation",
        "After carving is complete",
        "After condensation and initial carving",
        "Before placement begins"
      ],
      correct: "C"
    },
    {
      id: 23259,
      question: "What should be done if occlusal high spots are detected on amalgam?",
      options: [
        "Leave them alone",
        "Carve away marking spots",
        "Replace entire restoration",
        "Wait until next appointment"
      ],
      correct: "B"
    },
    {
      id: 23260,
      question: "How long should patients avoid chewing on a new amalgam restoration?",
      options: [
        "1 hour",
        "6 hours",
        "24 hours",
        "1 week"
      ],
      correct: "C"
    },
    {
      id: 23261,
      question: "What color-coded grits are rubber cups and points for amalgam polishing?",
      options: [
        "Red, blue, yellow",
        "Brown, green, yellow-banded green",
        "Black, white, gray",
        "Orange, purple, pink"
      ],
      correct: "B"
    },
    {
      id: 23262,
      question: "Which grit is most abrasive for amalgam polishing?",
      options: [
        "Yellow-banded green",
        "Green",
        "Brown",
        "White"
      ],
      correct: "C"
    },
    {
      id: 23263,
      question: "What is the purpose of using water during amalgam polishing?",
      options: [
        "To improve visibility",
        "To minimize heat generation",
        "To speed up the process",
        "To improve shine"
      ],
      correct: "B"
    },
    {
      id: 23264,
      question: "What must be done before moving from finishing to polishing composite?",
      options: [
        "Take a radiograph",
        "Evaluate that flash is removed and anatomy reproduced",
        "Replace the matrix",
        "Apply more composite"
      ],
      correct: "B"
    },
    {
      id: 23265,
      question: "What should the final polished composite restoration look like?",
      options: [
        "Rough with visible scratches",
        "Smooth, scratch-free with shiny appearance",
        "Matte finish",
        "Slightly rough texture"
      ],
      correct: "B"
    },
    {
      id: 23266,
      question: "Which populations did the FDA recommend avoiding amalgam placement in 2020?",
      options: [
        "Adults only",
        "Pregnant women, nursing mothers, children under 6, and those with kidney disease",
        "Elderly patients only",
        "Teenagers only"
      ],
      correct: "B"
    },
    {
      id: 23267,
      question: "What is mercury hygiene?",
      options: [
        "Cleaning mercury spills",
        "Care exercised to prevent bodily harm from mercury ingestion or inhalation",
        "A brand of dental product",
        "A sterilization technique"
      ],
      correct: "B"
    },
    {
      id: 23268,
      question: "Where should amalgam be handled when placing restorations?",
      options: [
        "Over carpet",
        "Over a deep tray",
        "Over the patient",
        "Over the sink"
      ],
      correct: "B"
    },
    {
      id: 23269,
      question: "What is required in many states regarding amalgam waste?",
      options: [
        "Direct disposal in trash",
        "Installation of amalgam separators",
        "Burning amalgam waste",
        "No special requirements"
      ],
      correct: "B"
    },
    {
      id: 23270,
      question: "What provides the best control during amalgam placement for patient safety?",
      options: [
        "Cotton rolls",
        "Dental dam isolation",
        "Suction only",
        "Patient cooperation"
      ],
      correct: "B"
    },
    {
      id: 23271,
      question: "What comprises the matrix of dental composite resin?",
      options: [
        "Metal particles",
        "Polymer, usually bis-GMA",
        "Glass only",
        "Ceramic crystals"
      ],
      correct: "B"
    },
    {
      id: 23272,
      question: "What activates polymerization in light-cure composites?",
      options: [
        "Chemical reaction only",
        "Light energy",
        "Heat",
        "Pressure"
      ],
      correct: "B"
    },
    {
      id: 23273,
      question: "What is added to composite to make it visible on radiographs?",
      options: [
        "Fluoride",
        "Radiopaque fillers like barium",
        "Titanium",
        "Silver"
      ],
      correct: "B"
    },
    {
      id: 23274,
      question: "Why is isolation critical for composite restorations?",
      options: [
        "For patient comfort",
        "Composites are negatively affected by blood, saliva, and moisture",
        "To reduce appointment time",
        "To improve visibility only"
      ],
      correct: "B"
    },
    {
      id: 23275,
      question: "What happens during polymerization shrinkage of composite?",
      options: [
        "Material expands",
        "Material contracts during curing",
        "No dimensional change",
        "Material becomes liquid"
      ],
      correct: "B"
    },
    {
      id: 23276,
      question: "How is incremental placement beneficial for composite restorations?",
      options: [
        "Saves time",
        "Reduces gaps and voids from polymerization shrinkage",
        "Uses less material",
        "Improves color"
      ],
      correct: "B"
    },
    {
      id: 23277,
      question: "What technique does Bioclear use for composite placement?",
      options: [
        "Dry placement",
        "Injection molding with heated composite",
        "Cold condensation",
        "Spray application"
      ],
      correct: "B"
    },
    {
      id: 23278,
      question: "What is the Clark Class II preparation designed to do?",
      options: [
        "Remove more tooth structure",
        "Maximize enamel surfaces with beveled margins for bonding",
        "Minimize bonding area",
        "Eliminate the need for matrix"
      ],
      correct: "B"
    },
    {
      id: 23279,
      question: "What does CAD-CAM stand for?",
      options: [
        "Computer-aided design and computer-aided manufacture",
        "Cavity and dental-crown assessment method",
        "Calcium and dental material",
        "Clinical assessment and dental management"
      ],
      correct: "A"
    },
    {
      id: 23280,
      question: "Which indirect restoration technique uses a digital image of the tooth?",
      options: [
        "Lost wax technique",
        "CAD-CAM",
        "Hand carving",
        "Impression only"
      ],
      correct: "B"
    },
    {
      id: 23281,
      question: "What is the advantage of an all-porcelain crown?",
      options: [
        "Superior strength",
        "Lifelike appearance",
        "Lower cost",
        "Faster fabrication"
      ],
      correct: "B"
    },
    {
      id: 23282,
      question: "What is the disadvantage of all-porcelain crowns compared to PFMs?",
      options: [
        "Poor esthetics",
        "Strength",
        "High cost",
        "Poor fit"
      ],
      correct: "B"
    },
    {
      id: 23283,
      question: "Which preparation requires a matrix for restoration?",
      options: [
        "Class I only",
        "Classes II, III, and IV",
        "Class V only",
        "Class VI only"
      ],
      correct: "B"
    },
    {
      id: 23284,
      question: "What is the purpose of a wedge placed from the largest embrasure?",
      options: [
        "To damage tissue",
        "To allow more complete wedge placement",
        "To make placement faster",
        "To reduce material use"
      ],
      correct: "B"
    },
    {
      id: 23285,
      question: "What do sectional matrix bands typically come shaped as?",
      options: [
        "Flat rectangles only",
        "Anatomically shaped for proper contours",
        "Circles",
        "Triangles"
      ],
      correct: "B"
    },
    {
      id: 23286,
      question: "What do the silicone-covered tines and ring of sectional systems do?",
      options: [
        "Hold the band only",
        "Apply pressure for tooth separation during composite placement",
        "Measure cavity depth",
        "Remove excess material"
      ],
      correct: "B"
    },
    {
      id: 23287,
      question: "When can sectional matrix systems NOT be used?",
      options: [
        "For Class II restorations",
        "Without a proximal contact",
        "For composite restorations",
        "For small cavities"
      ],
      correct: "B"
    },
    {
      id: 23288,
      question: "What type of matrix is typically used for Class III and IV composite restorations?",
      options: [
        "Tofflemire bands",
        "Sectional bands",
        "Mylar matrix bands",
        "Metal bands"
      ],
      correct: "C"
    },
    {
      id: 23289,
      question: "What are specialty matrix systems available for?",
      options: [
        "Class I restorations only",
        "Class V composite restorations",
        "Amalgam only",
        "Crowns only"
      ],
      correct: "B"
    },
    {
      id: 23290,
      question: "Why are nylon-coated interdental brushes required for implants?",
      options: [
        "They last longer",
        "To avoid alteration of the abutment surface",
        "They are cheaper",
        "They clean better"
      ],
      correct: "B"
    },
    {
      id: 23291,
      question: "What should interdental brushes be discarded when?",
      options: [
        "After one use",
        "When nylon coating has worn to metal wire",
        "After one week",
        "Never"
      ],
      correct: "B"
    },
    {
      id: 23292,
      question: "Where are wedges generally placed for ideal adaptation?",
      options: [
        "Smallest embrasure",
        "Largest embrasure, typically lingual",
        "Facial only",
        "Occlusal surface"
      ],
      correct: "B"
    },
    {
      id: 23293,
      question: "What do wooden wedges provide that plastic wedges may not?",
      options: [
        "Better color",
        "Slight tooth separation for positive proximal contact",
        "Easier placement",
        "Lower cost"
      ],
      correct: "B"
    },
    {
      id: 23294,
      question: "What is the purpose of a base material?",
      options: [
        "To color the restoration",
        "To protect pulp and provide support beneath restorations",
        "To etch enamel",
        "To polish restorations"
      ],
      correct: "B"
    },
    {
      id: 23295,
      question: "What consistency are base materials mixed to?",
      options: [
        "Watery",
        "Thick consistency",
        "Powder form",
        "Gel-like"
      ],
      correct: "B"
    },
    {
      id: 23296,
      question: "Why are glass ionomer cements popular as base materials?",
      options: [
        "Lowest cost",
        "Release fluoride and bond directly to dentin",
        "Fastest setting",
        "Best color match"
      ],
      correct: "B"
    },
    {
      id: 23297,
      question: "When must glass ionomer bases and liners be placed?",
      options: [
        "After bonding agent",
        "Prior to dentin sealers to allow bonding to dentin",
        "After composite placement",
        "Never"
      ],
      correct: "B"
    },
    {
      id: 23298,
      question: "What do cavity sealers seal?",
      options: [
        "The restoration margins",
        "Dentinal tubules",
        "Enamel surface",
        "Metal restorations"
      ],
      correct: "B"
    },
    {
      id: 23299,
      question: "How are dentinal tubules sealed?",
      options: [
        "With amalgam",
        "Using bonding resins or liners",
        "With cotton",
        "With air only"
      ],
      correct: "B"
    },
    {
      id: 23300,
      question: "What is the hybrid layer?",
      options: [
        "Two restorations on one tooth",
        "Bond formed between restorative material and tooth structure",
        "Multiple layers of composite",
        "Combined base materials"
      ],
      correct: "B"
    },
    {
      id: 23301,
      question: "What can cavity sealers be used under?",
      options: [
        "Composite restorations only",
        "Both amalgam and composite restorations",
        "Amalgam only",
        "Neither amalgam nor composite"
      ],
      correct: "B"
    },
    {
      id: 23302,
      question: "What is margination?",
      options: [
        "Checking margins",
        "Procedure for removal of excessive restorative material from margins",
        "Placing margins",
        "Measuring margins"
      ],
      correct: "B"
    },
    {
      id: 23303,
      question: "What creates the embrasure spaces?",
      options: [
        "Cavity preparation only",
        "Proper matrix placement and restorative technique",
        "Natural tooth anatomy only",
        "Polishing"
      ],
      correct: "B"
    },
    {
      id: 23304,
      question: "What are cavosurface margins?",
      options: [
        "Internal cavity walls",
        "Margins where cavity meets tooth surface (occlusal, gingival, buccal, lingual)",
        "Pulpal floor",
        "Axial walls"
      ],
      correct: "B"
    },
    {
      id: 23305,
      question: "Why is knowledge of embrasure spaces important for dental hygienists?",
      options: [
        "For esthetic reasons only",
        "To communicate location needing repair or margination",
        "To determine pay",
        "To select instruments"
      ],
      correct: "B"
    },
    {
      id: 23306,
      question: "What percentage of mercury can be released during amalgam removal?",
      options: [
        "None",
        "Temporary increase in mercury vapor exposure",
        "Permanent increase",
        "Decrease"
      ],
      correct: "B"
    },
    {
      id: 23307,
      question: "What did Alaska first use for dental care in underserved areas?",
      options: [
        "Expanded function dental assistants only",
        "Dental Hygiene Therapist and Dental Health Aid Therapist",
        "Only dentists",
        "Dental students"
      ],
      correct: "B"
    },
    {
      id: 23308,
      question: "What was Minnesota the first state to create?",
      options: [
        "Dental hygiene program",
        "Advanced Dental Therapist with dual licensure",
        "Dental school",
        "Board exam"
      ],
      correct: "B"
    }
  ],
  "3. Orthodontic Care": [
    {
      id: 23300,
      question: "At what age does the American Association of Orthodontists recommend a child be examined by an orthodontist?",
      options: [
        "7 years",
        "5 years",
        "10 years",
        "12 years"
      ],
      correct: "A"
    },
    {
      id: 23301,
      question: "What is the definition of malocclusion?",
      options: [
        "A bacterial infection of the gums",
        "Any deviation from the normal relationship of the maxillary arch or teeth to the mandibular arch or teeth",
        "Excessive tooth decay in children",
        "A genetic disorder affecting bone"
      ],
      correct: "B"
    },
    {
      id: 23302,
      question: "Which of the following is NOT a goal of orthodontic treatment?",
      options: [
        "Establish periodontal health",
        "Improve facial aesthetics",
        "Eliminate all primary teeth",
        "Promote long-term stability"
      ],
      correct: "C"
    },
    {
      id: 23303,
      question: "What type of malocclusion occurs when the buccal cusps of maxillary teeth are lingual to the buccal cusps of mandibular teeth?",
      options: [
        "Overbite malformation",
        "Posterior crossbite",
        "Anterior open bite",
        "Midline diastema"
      ],
      correct: "B"
    },
    {
      id: 23304,
      question: "Which planes can malocclusion occur in?",
      options: [
        "Only the sagittal plane",
        "Only the transverse plane",
        "Sagittal, transverse, or occlusal planes",
        "Only the occlusal plane"
      ],
      correct: "C"
    },
    {
      id: 23305,
      question: "What are the two origins of malocclusion?",
      options: [
        "Genetic discrepancies and environmental factors",
        "Diet and oral hygiene",
        "Genetic discrepancies and trauma/parafunctional habits",
        "Bacterial infection and bone loss"
      ],
      correct: "C"
    },
    {
      id: 23306,
      question: "Which medication may produce gingival hyperplasia that can slow tooth movement?",
      options: [
        "Antibiotics",
        "Phenytoin",
        "Aspirin",
        "Ibuprofen"
      ],
      correct: "B"
    },
    {
      id: 23307,
      question: "What condition is described as separation of the lips by more than 3 to 4 mm when at rest?",
      options: [
        "Lip protrusion",
        "Lip incompetence",
        "Labial separation",
        "Mentalis dysfunction"
      ],
      correct: "B"
    },
    {
      id: 23308,
      question: "How many zones of equal height are created when evaluating vertical facial dimensions?",
      options: [
        "Two zones",
        "Four zones",
        "Three zones",
        "Five zones"
      ],
      correct: "C"
    },
    {
      id: 23309,
      question: "Which radiograph is used to assess facial and jaw proportions and skeletal relationships?",
      options: [
        "Panoramic radiograph",
        "Bitewing radiograph",
        "Lateral cephalometric radiograph",
        "Periapical radiograph"
      ],
      correct: "C"
    },
    {
      id: 23310,
      question: "What does CBCT stand for?",
      options: [
        "Complete Bone Computed Technology",
        "Cone beam computed tomography",
        "Cranial Bone CT scan",
        "Cephalometric Bone CT"
      ],
      correct: "B"
    },
    {
      id: 23311,
      question: "What are the three developmental ages assessed in orthodontic treatment planning?",
      options: [
        "Skeletal, chronologic, and dental age",
        "Physical, mental, and emotional age",
        "Primary, mixed, and permanent age",
        "Infant, child, and adolescent age"
      ],
      correct: "A"
    },
    {
      id: 23312,
      question: "Which type of orthodontic treatment is recommended to correct certain dental malocclusions that develop early?",
      options: [
        "Comprehensive treatment",
        "Phase II treatment",
        "Phase I or interceptive orthodontics",
        "Retention phase"
      ],
      correct: "C"
    },
    {
      id: 23313,
      question: "What is the primary mechanism by which teeth move during orthodontic treatment?",
      options: [
        "Muscle pressure alone",
        "Light sustained force causing bone resorption on pressure side and formation on tension side",
        "Heavy force breaking down bone",
        "Surgical repositioning"
      ],
      correct: "B"
    },
    {
      id: 23314,
      question: "How long must force be applied to a tooth per day to affect tooth position?",
      options: [
        "2 hours",
        "4 hours",
        "At least 6 hours",
        "12 hours"
      ],
      correct: "C"
    },
    {
      id: 23315,
      question: "What does the periodontal ligament (PDL) consist of?",
      options: [
        "Only blood vessels",
        "Only nerve fibers",
        "Collagenous fibers, mesenchymal cells, fibroblasts, osteoblasts, nerve fibers, blood vessels, and tissue fluids",
        "Only bone tissue"
      ],
      correct: "C"
    },
    {
      id: 23316,
      question: "What is frontal resorption?",
      options: [
        "Decay of front teeth",
        "Osteoclasts removing bone on the pressure side during tooth movement",
        "Gum recession on anterior teeth",
        "Root absorption in incisors"
      ],
      correct: "B"
    },
    {
      id: 23317,
      question: "How often are orthodontic appointments typically scheduled?",
      options: [
        "Every week",
        "Every 2 weeks",
        "Every 4 to 6 weeks",
        "Every 3 months"
      ],
      correct: "C"
    },
    {
      id: 23318,
      question: "What is the average duration of comprehensive orthodontic treatment?",
      options: [
        "6 months",
        "12 months",
        "About 24 months",
        "36 months"
      ],
      correct: "C"
    },
    {
      id: 23319,
      question: "What type of appliance is held in place by brackets bonded to the tooth?",
      options: [
        "Retainer",
        "Headgear",
        "Archwire",
        "Palate expander"
      ],
      correct: "C"
    },
    {
      id: 23320,
      question: "What are ligatures made of?",
      options: [
        "Ceramic only",
        "Gold or silver",
        "Wire or elastic",
        "Plastic only"
      ],
      correct: "C"
    },
    {
      id: 23321,
      question: "What is the advantage of self-ligating brackets?",
      options: [
        "They are less expensive",
        "They reduce friction and require no additional ligature",
        "They are more visible",
        "They work faster than traditional brackets"
      ],
      correct: "B"
    },
    {
      id: 23322,
      question: "Where are bands usually placed?",
      options: [
        "On all teeth",
        "Only on incisors",
        "Usually on molars",
        "Only on canines"
      ],
      correct: "C"
    },
    {
      id: 23323,
      question: "What does a buccal tube hold?",
      options: [
        "Food particles",
        "The end of a lip bumper, headgear, or other appliance",
        "Saliva during treatment",
        "Temporary filling material"
      ],
      correct: "B"
    },
    {
      id: 23324,
      question: "What is the purpose of a temporary anchorage device?",
      options: [
        "To hold teeth in place after treatment",
        "To correct mild to moderate anterior open bite and vertical excess problems",
        "To clean between teeth",
        "To measure jaw position"
      ],
      correct: "B"
    },
    {
      id: 23325,
      question: "What does a Nance Holding Appliance do?",
      options: [
        "Expands the palate",
        "Holds upper molars in place to stabilize their position",
        "Moves lower teeth forward",
        "Corrects crossbite"
      ],
      correct: "B"
    },
    {
      id: 23326,
      question: "How does a palate expander widen the maxilla?",
      options: [
        "By surgical intervention",
        "By stretching the soft cartilage of the palate over months",
        "By removing teeth",
        "By reshaping bone surgically"
      ],
      correct: "B"
    },
    {
      id: 23327,
      question: "What is the purpose of a Herbst appliance?",
      options: [
        "To restrict mandibular growth",
        "To help the jaw develop in a forward direction",
        "To expand the palate",
        "To correct tongue thrust"
      ],
      correct: "B"
    },
    {
      id: 23328,
      question: "What is a Bluegrass, Crib, or Tongue Guard Appliance used for?",
      options: [
        "To expand the arch",
        "To block tongue thrust or arrest thumbsucking habit",
        "To move molars distally",
        "To close diastemas"
      ],
      correct: "B"
    },
    {
      id: 23329,
      question: "What type of appliance is used for Class II correction with excess maxillary growth?",
      options: [
        "Chin cup",
        "Reverse headgear",
        "Headgear",
        "Palate expander"
      ],
      correct: "C"
    },
    {
      id: 23330,
      question: "What does a reverse headgear or protraction facemask do?",
      options: [
        "Restricts mandibular growth",
        "Accelerates maxillary growth for Class III correction",
        "Corrects Class II malocclusion",
        "Expands the palate"
      ],
      correct: "B"
    },
    {
      id: 23331,
      question: "What does a chin cup do?",
      options: [
        "Accelerates maxillary growth",
        "Expands the palate",
        "Restricts mandibular growth",
        "Corrects anterior open bite"
      ],
      correct: "C"
    },
    {
      id: 23332,
      question: "What are elastic separators used for?",
      options: [
        "To clean teeth",
        "To create mesial-distal spaces for band placement",
        "To whiten teeth",
        "To hold archwires"
      ],
      correct: "B"
    },
    {
      id: 23333,
      question: "What does a band and loop space maintainer do?",
      options: [
        "Expands the arch",
        "Prevents space closure after premature tooth loss",
        "Moves teeth forward",
        "Corrects crossbite"
      ],
      correct: "B"
    },
    {
      id: 23334,
      question: "What is the purpose of a lip bumper?",
      options: [
        "To expand the maxilla",
        "To gain mandibular anterior space and move molars distally",
        "To correct Class III malocclusion",
        "To hold upper molars"
      ],
      correct: "B"
    },
    {
      id: 23335,
      question: "What type of retainer consists of a stainless steel wire bonded to lingual surfaces?",
      options: [
        "Hawley retainer",
        "Essix retainer",
        "Lingual retainer",
        "Vacuum-formed retainer"
      ],
      correct: "C"
    },
    {
      id: 23336,
      question: "What material is a Hawley appliance retainer made from?",
      options: [
        "Only metal wire",
        "Thin acrylic palatal component with clasps and labial wire",
        "Ceramic material",
        "Clear plastic only"
      ],
      correct: "B"
    },
    {
      id: 23337,
      question: "What is an Essix retainer?",
      options: [
        "A metal wire retainer",
        "A removable acrylic retainer",
        "A thin plastic retainer that fully covers all maxillary teeth",
        "A permanent fixed retainer"
      ],
      correct: "C"
    },
    {
      id: 23338,
      question: "How thick are plastic tray aligners?",
      options: [
        "1 to 2 mm",
        "0.25 to 0.3 mm",
        "3 to 4 mm",
        "0.5 to 1 mm"
      ],
      correct: "B"
    },
    {
      id: 23339,
      question: "How long should plastic tray aligners be worn per day?",
      options: [
        "8 hours",
        "12 hours",
        "About 20 hours",
        "24 hours continuously"
      ],
      correct: "C"
    },
    {
      id: 23340,
      question: "When should a permanent tooth erupt according to root development?",
      options: [
        "When half its root is completed",
        "When one-fourth of root is completed",
        "When three-fourths of its root is completed",
        "When the complete root is formed"
      ],
      correct: "C"
    },
    {
      id: 23341,
      question: "Which teeth are most likely to be congenitally missing?",
      options: [
        "Central incisors and first molars",
        "Mandibular second premolars and maxillary lateral incisors",
        "Canines and third molars",
        "All premolars equally"
      ],
      correct: "B"
    },
    {
      id: 23342,
      question: "When is loss of a primary tooth considered premature?",
      options: [
        "1 year before permanent tooth eruption",
        "3 months before permanent tooth eruption",
        "6 months before the permanent tooth is expected to erupt",
        "2 years before permanent tooth eruption"
      ],
      correct: "C"
    },
    {
      id: 23343,
      question: "What are primate spaces?",
      options: [
        "Gaps caused by tooth decay",
        "Naturally occurring spacing between primary teeth",
        "Spaces created by orthodontic treatment",
        "Pathological spaces from gum disease"
      ],
      correct: "B"
    },
    {
      id: 23344,
      question: "Where are primate spaces located in the maxilla?",
      options: [
        "Between central and lateral incisors",
        "Between first and second molars",
        "Between lateral incisors and canines",
        "Between canines and first molars"
      ],
      correct: "C"
    },
    {
      id: 23345,
      question: "What is leeway space?",
      options: [
        "Space between central incisors",
        "Additional space created because permanent premolars are smaller than primary molars",
        "Space for wisdom teeth",
        "Space created by tooth extraction"
      ],
      correct: "B"
    },
    {
      id: 23346,
      question: "What is the average leeway space in the mandibular arch?",
      options: [
        "2 mm",
        "3 mm",
        "5 mm",
        "7 mm"
      ],
      correct: "C"
    },
    {
      id: 23347,
      question: "What happens to a midline diastema of 2 mm or less by age 16?",
      options: [
        "It always requires treatment",
        "It typically closes without intervention",
        "It always gets larger",
        "It requires immediate surgery"
      ],
      correct: "B"
    },
    {
      id: 23348,
      question: "What can cause a midline diastema larger than 2-3 mm?",
      options: [
        "Normal growth only",
        "Supernumerary tooth, missing laterals, or low frenum attachment",
        "Excessive brushing",
        "Vitamin deficiency"
      ],
      correct: "B"
    },
    {
      id: 23349,
      question: "Why do permanent mandibular incisors sometimes erupt lingual to primary incisors?",
      options: [
        "Due to abnormal development",
        "Because permanent tooth buds develop lingual to primary teeth",
        "Due to tongue position",
        "Because of early loss of primary teeth"
      ],
      correct: "B"
    },
    {
      id: 23350,
      question: "Which teeth are most likely to be impacted after third molars?",
      options: [
        "Central incisors",
        "First premolars",
        "Maxillary canines",
        "Second premolars"
      ],
      correct: "C"
    },
    {
      id: 23351,
      question: "What is serial extraction?",
      options: [
        "Removing all primary teeth at once",
        "Extracting select teeth at planned times to reduce crowding during transition to permanent dentition",
        "Removing only wisdom teeth",
        "Emergency extraction of infected teeth"
      ],
      correct: "B"
    },
    {
      id: 23352,
      question: "What is the goal of orthodontic expansion?",
      options: [
        "To narrow the maxilla",
        "To widen the maxilla",
        "To shorten the mandible",
        "To lengthen the maxilla"
      ],
      correct: "B"
    },
    {
      id: 23353,
      question: "What is orthopedic expansion?",
      options: [
        "Surgical jaw expansion",
        "Expanding by tipping teeth only",
        "Expanding underlying skeletal structures without tipping teeth",
        "Temporary expansion that relapses"
      ],
      correct: "C"
    },
    {
      id: 23354,
      question: "When is skeletal expansion most effective?",
      options: [
        "After age 25",
        "Prior to palatal skeletal fusion in early intervention",
        "Only in adults",
        "After all permanent teeth erupt"
      ],
      correct: "B"
    },
    {
      id: 23355,
      question: "What forces are most effective in determining tooth position according to equilibrium theory?",
      options: [
        "Heavy chewing forces",
        "Light forces of tongue, cheeks, and lips while at rest",
        "Orthodontic appliance forces only",
        "Muscle forces during swallowing"
      ],
      correct: "B"
    },
    {
      id: 23356,
      question: "What causes apical root resorption during orthodontic treatment?",
      options: [
        "Poor oral hygiene",
        "Portions of cementum or dentin breaking away at root apex",
        "Bacterial infection",
        "Vitamin deficiency"
      ],
      correct: "B"
    },
    {
      id: 23357,
      question: "Which teeth are most frequently affected by apical root resorption?",
      options: [
        "Molars",
        "Premolars",
        "Maxillary and mandibular incisors",
        "Third molars"
      ],
      correct: "C"
    },
    {
      id: 23358,
      question: "What happens to tooth mobility during orthodontic treatment?",
      options: [
        "It decreases significantly",
        "It remains unchanged",
        "Increased mobility is expected",
        "Teeth become permanently loose"
      ],
      correct: "C"
    },
    {
      id: 23359,
      question: "What causes pain after orthodontic adjustments?",
      options: [
        "Infection in the pulp",
        "Development of ischemic areas within the PDL and mild pulpitis",
        "Bracket irritation only",
        "Allergic reaction to metal"
      ],
      correct: "B"
    },
    {
      id: 23360,
      question: "How can painful symptoms be relieved after light force application?",
      options: [
        "By removing the appliance",
        "By taking antibiotics",
        "By having the patient chew gum during first 8 hours",
        "By avoiding all food"
      ],
      correct: "C"
    },
    {
      id: 23361,
      question: "What risk increases when the arch is expanded by labial movement of teeth?",
      options: [
        "Tooth decay",
        "Gingival recession",
        "Tooth fracture",
        "TMJ disorders"
      ],
      correct: "B"
    },
    {
      id: 23362,
      question: "What is the most common cause of acute mucosal reaction to orthodontic treatment?",
      options: [
        "Stainless steel",
        "Nickel hypersensitivity or allergy",
        "Ceramic brackets",
        "Plastic aligners"
      ],
      correct: "B"
    },
    {
      id: 23363,
      question: "What is a white spot lesion (WSL)?",
      options: [
        "A cosmetic enhancement",
        "Early caries occurring under orthodontic bands and brackets",
        "Normal tooth development",
        "A type of fluorosis"
      ],
      correct: "B"
    },
    {
      id: 23364,
      question: "What should NOT be used to probe an intact WSL surface?",
      options: [
        "Dental mirror",
        "Cotton swab",
        "Sharp explorer",
        "Air syringe"
      ],
      correct: "C"
    },
    {
      id: 23365,
      question: "Can properly applied orthodontic forces cause loss of pulpal vitality?",
      options: [
        "Yes, it always occurs",
        "No, never",
        "Occasionally with poor control",
        "Only in children"
      ],
      correct: "C"
    },
    {
      id: 23366,
      question: "Why is retention necessary after orthodontic treatment?",
      options: [
        "Only for cosmetic reasons",
        "Gingival fibers contribute to relapse, tissues need reorganization time",
        "To continue tooth movement",
        "It is not actually necessary"
      ],
      correct: "B"
    },
    {
      id: 23367,
      question: "How long does reorganization of the periodontium take after treatment?",
      options: [
        "1 week",
        "1 month",
        "3 to 4 months",
        "1 year"
      ],
      correct: "C"
    },
    {
      id: 23368,
      question: "How long should retainers be worn full-time after treatment?",
      options: [
        "1 week",
        "1 month",
        "First 3 to 4 months",
        "Forever"
      ],
      correct: "C"
    },
    {
      id: 23369,
      question: "What is fibrotomy?",
      options: [
        "Removal of all gum tissue",
        "Periodontal surgical procedure to incise gingival fibers",
        "Extraction of teeth",
        "Bone grafting procedure"
      ],
      correct: "B"
    },
    {
      id: 23370,
      question: "What can orthodontics help improve for periodontal treatment?",
      options: [
        "Only tooth color",
        "Hard and soft tissue volume, height, and osseous contours",
        "Only root length",
        "Bacterial resistance"
      ],
      correct: "B"
    },
    {
      id: 23371,
      question: "What is autogenous transplantation?",
      options: [
        "Implant placement",
        "Surgical repositioning of one tooth from one position to another within same person",
        "Crown placement",
        "Bridge fabrication"
      ],
      correct: "B"
    },
    {
      id: 23372,
      question: "What teeth are most commonly autotransplanted?",
      options: [
        "Central incisors",
        "Wisdom teeth to replace hopeless molars",
        "Canines",
        "All teeth equally"
      ],
      correct: "B"
    },
    {
      id: 23373,
      question: "What does OMT stand for in orthodontic care?",
      options: [
        "Oral Maxillary Treatment",
        "Orthodontic Molar Therapy",
        "Orofacial myofunctional therapy",
        "Oral Medicine Techniques"
      ],
      correct: "C"
    },
    {
      id: 23374,
      question: "What can orofacial myofunctional disorders affect?",
      options: [
        "Only speech",
        "Palatal formation, dental occlusion, facial development, breathing, sleeping, speech, and swallowing",
        "Only breathing",
        "Only tooth alignment"
      ],
      correct: "B"
    },
    {
      id: 23375,
      question: "At what caries risk level are patients with fixed orthodontic appliances?",
      options: [
        "Low risk",
        "No increased risk",
        "Moderate to high risk",
        "Only high if they have cavities"
      ],
      correct: "C"
    },
    {
      id: 23376,
      question: "What is recommended for caries prevention during orthodontic treatment?",
      options: [
        "No special measures needed",
        "Twice-daily topical fluoride dentifrice and rinse",
        "Only annual fluoride treatments",
        "Avoiding all fluoride"
      ],
      correct: "B"
    },
    {
      id: 23377,
      question: "What advantage does stabilized stannous fluoride dentifrice have over sodium fluoride?",
      options: [
        "It tastes better",
        "It is less expensive",
        "Stannous ion serves as antimicrobial with antigingivitis effect",
        "It whitens teeth better"
      ],
      correct: "C"
    },
    {
      id: 23378,
      question: "What fluoride varnish concentration is recommended for caries risk patients?",
      options: [
        "1.0% fluoride varnish",
        "5.0% fluoride varnish",
        "2.26% fluoride varnish",
        "0.5% fluoride varnish"
      ],
      correct: "C"
    },
    {
      id: 23379,
      question: "What daily fluoride concentration toothpaste may be recommended to prevent WSLs?",
      options: [
        "1000 ppm",
        "2500 ppm",
        "5000 ppm",
        "10000 ppm"
      ],
      correct: "C"
    },
    {
      id: 23380,
      question: "When should tooth whitening be performed for orthodontic patients?",
      options: [
        "During active treatment",
        "Before treatment begins",
        "After completion of orthodontic treatment",
        "Whitening is not recommended"
      ],
      correct: "C"
    },
    {
      id: 23381,
      question: "What should be minimized during orthodontic treatment to reduce caries risk?",
      options: [
        "Fluoride use",
        "Tooth brushing",
        "Sugar and sticky carbohydrate intake",
        "Water consumption"
      ],
      correct: "C"
    },
    {
      id: 23382,
      question: "What type of toothbrush is recommended for orthodontic patients?",
      options: [
        "Only manual brushes",
        "No brushing recommended",
        "Electric toothbrush with orthodontic head",
        "Extra-soft baby toothbrush"
      ],
      correct: "C"
    },
    {
      id: 23383,
      question: "How long should orthodontic patients brush their teeth?",
      options: [
        "30 seconds",
        "1 minute",
        "2 minutes",
        "5 minutes"
      ],
      correct: "C"
    },
    {
      id: 23384,
      question: "What direction should the water jet irrigating stream be directed?",
      options: [
        "Into the gingival sulcus",
        "Perpendicular to the long axis of the tooth",
        "At a 45-degree angle upward",
        "Parallel to the tooth surface"
      ],
      correct: "B"
    },
    {
      id: 23385,
      question: "What is the most difficult area for orthodontic patients to keep clean?",
      options: [
        "Occlusal surfaces",
        "Lingual surfaces",
        "From the bracket to the gingival margin",
        "Incisal edges"
      ],
      correct: "C"
    },
    {
      id: 23386,
      question: "What percentage of gingival bleeding reduction was demonstrated with stannous fluoride?",
      options: [
        "25%",
        "35%",
        "51%",
        "75%"
      ],
      correct: "C"
    },
    {
      id: 23387,
      question: "What can help ameliorate white spot lesions after they occur?",
      options: [
        "Bleaching treatments",
        "Monthly fluoride varnish and CPP-ACP",
        "Antibiotics",
        "No treatment available"
      ],
      correct: "B"
    },
    {
      id: 23388,
      question: "How often should orthodontic patients see the dental hygienist?",
      options: [
        "Once per year only",
        "Only when treatment is complete",
        "Regularly throughout orthodontic therapy, possibly more frequently if self-care is difficult",
        "Never during treatment"
      ],
      correct: "C"
    },
    {
      id: 23389,
      question: "What happens several hours after an orthodontic appliance is activated?",
      options: [
        "Teeth become numb",
        "Patient may feel mild aching and sensitivity to pressure",
        "Teeth turn white",
        "Nothing noticeable occurs"
      ],
      correct: "B"
    },
    {
      id: 23390,
      question: "How long does post-adjustment pain typically last?",
      options: [
        "24 hours",
        "2 to 4 days",
        "1 week",
        "2 weeks"
      ],
      correct: "B"
    },
    {
      id: 23391,
      question: "When is it most comfortable for patients to have dental hygiene appointments relative to orthodontic adjustments?",
      options: [
        "Immediately after adjustments",
        "During adjustments",
        "Before rather than immediately after orthodontic adjustments",
        "Timing does not matter"
      ],
      correct: "C"
    },
    {
      id: 23392,
      question: "What can appliance bond failure lead to?",
      options: [
        "Faster treatment",
        "Caries under the band or bracket",
        "Whiter teeth",
        "Better oral hygiene"
      ],
      correct: "B"
    },
    {
      id: 23393,
      question: "How can appliance bond failure be detected?",
      options: [
        "By x-ray only",
        "By gently rocking each tooth with blunt instrument handles",
        "By the patient\'s report only",
        "It cannot be detected"
      ],
      correct: "B"
    },
    {
      id: 23394,
      question: "What effect does periodontal inflammation have on orthodontic treatment?",
      options: [
        "No effect",
        "Speeds up treatment",
        "Causes teeth to move more slowly",
        "Improves outcomes"
      ],
      correct: "C"
    },
    {
      id: 23395,
      question: "What is the primary etiologic factor in postorthodontic gingival enlargement?",
      options: [
        "Genetic factors",
        "Bacterial biofilm",
        "Metal allergy",
        "Vitamin deficiency"
      ],
      correct: "B"
    },
    {
      id: 23396,
      question: "What is the first line of intervention for severe postorthodontic gingival enlargement?",
      options: [
        "Immediate surgery",
        "Antibiotic therapy",
        "Intensive periodontal therapy targeting bacterial biofilm",
        "Removing all teeth"
      ],
      correct: "C"
    },
    {
      id: 23397,
      question: "What happens after 3 months of good oral hygiene during orthodontic treatment?",
      options: [
        "Treatment can be stopped",
        "Caries risk can stabilize due to host microbial reestablishment",
        "Appliances must be removed",
        "Risk always increases"
      ],
      correct: "B"
    },
    {
      id: 23398,
      question: "What may need to be removed if patients cannot maintain good oral hygiene?",
      options: [
        "Some teeth",
        "The braces, with treatment delayed",
        "Gum tissue",
        "Nothing can be removed"
      ],
      correct: "B"
    },
    {
      id: 23399,
      question: "What is the role of the dental hygienist in orthodontic treatment?",
      options: [
        "To place brackets",
        "To diagnose malocclusion",
        "To aid with compliance, motivation, and maintaining oral health",
        "To adjust wires"
      ],
      correct: "C"
    },
    {
      id: 23400,
      question: "What must the dental hygienist be able to identify for orthodontic referral?",
      options: [
        "Only tooth color changes",
        "Features and patterns of normal vs. abnormal growth and development",
        "Only cavities",
        "Only gum disease"
      ],
      correct: "B"
    },
    {
      id: 23401,
      question: "What should dental hygienists reinforce with orthodontic patients?",
      options: [
        "That treatment is optional",
        "Directions for oral hygiene and care of appliances",
        "That they don\'t need to brush",
        "That diet doesn\'t matter"
      ],
      correct: "B"
    },
    {
      id: 23402,
      question: "According to the ethical principle of nonmaleficence, what must be addressed as priorities?",
      options: [
        "Cosmetic concerns only",
        "Potential periodontal or restorative issues before correcting malocclusions",
        "Speed of treatment",
        "Cost of treatment"
      ],
      correct: "B"
    },
    {
      id: 23403,
      question: "What must be thoroughly documented according to legal requirements?",
      options: [
        "Only payment information",
        "Only the diagnosis",
        "All dental hygiene care, client education, adherence observations, and referrals",
        "Only treatment dates"
      ],
      correct: "C"
    },
    {
      id: 23404,
      question: "What must dental hygienists do if they note relapse after orthodontic treatment?",
      options: [
        "Ignore it",
        "Treat it themselves",
        "Advise patient and refer back to orthodontist",
        "Wait several years"
      ],
      correct: "C"
    },
    {
      id: 23405,
      question: "What happens to biofilm volume and composition when fixed orthodontic appliances are introduced?",
      options: [
        "It decreases significantly",
        "It remains unchanged",
        "Rapid increase occurs",
        "It disappears completely"
      ],
      correct: "C"
    },
    {
      id: 23406,
      question: "What are the two main therapeutic challenges for orthodontic patients?",
      options: [
        "Cost and time",
        "Caries and poor gingival health",
        "Pain and discomfort",
        "Appearance and speech"
      ],
      correct: "B"
    },
    {
      id: 23407,
      question: "What can persistent gingivitis during orthodontic treatment lead to?",
      options: [
        "Tooth whitening",
        "Gingival overgrowth and periodontal breakdown",
        "Faster tooth movement",
        "Better oral health"
      ],
      correct: "B"
    },
    {
      id: 23408,
      question: "What motivational approach is recommended instead of paternalistic teaching?",
      options: [
        "Ignoring the patient",
        "Lecturing extensively",
        "Open-ended questions allowing patients to create solutions",
        "Telling patients exactly what to do"
      ],
      correct: "C"
    },
    {
      id: 23409,
      question: "What should patients be asked to do to assess their perceptions?",
      options: [
        "Nothing specific",
        "Rate their own oral health at each visit",
        "Only listen to the hygienist",
        "Memorize oral hygiene instructions"
      ],
      correct: "B"
    },
    {
      id: 23410,
      question: "What happens if orthodontic treatment planning is beyond dental hygiene scope?",
      options: [
        "Hygienists should do it anyway",
        "Hygienists should refer to orthodontist",
        "No one should do it",
        "Patients should diagnose themselves"
      ],
      correct: "B"
    },
    {
      id: 23411,
      question: "What is recommended for interdental cleaning with fixed appliances?",
      options: [
        "No interdental cleaning",
        "Only toothbrushes",
        "Superfloss, interdental brushes, or water jet with orthodontic tip",
        "Only mouthwash"
      ],
      correct: "C"
    },
    {
      id: 23412,
      question: "What power setting should be used for the orthodontic water jet tip?",
      options: [
        "High power only",
        "Maximum pressure",
        "Low power",
        "Any power setting"
      ],
      correct: "C"
    },
    {
      id: 23413,
      question: "What should parents of young orthodontic patients be taught?",
      options: [
        "That hygiene is not important",
        "To assist with oral hygiene around appliances",
        "To avoid touching the child\'s mouth",
        "To let children manage alone"
      ],
      correct: "B"
    },
    {
      id: 23414,
      question: "What is the minimum retention period recommended after severe malalignment correction?",
      options: [
        "1 month",
        "6 months",
        "At least 12 months",
        "2 years"
      ],
      correct: "C"
    },
    {
      id: 23415,
      question: "What can continue to affect occlusion after orthodontic treatment in growing patients?",
      options: [
        "Nothing changes",
        "Skeletal growth",
        "Only diet",
        "Only hygiene"
      ],
      correct: "B"
    },
    {
      id: 23416,
      question: "What should be used when orthodontic treatment is planned before fixed prosthetic placement?",
      options: [
        "No special appliances",
        "Fixed retainer or space maintainer between abutments",
        "Temporary crowns only",
        "Immediate implants"
      ],
      correct: "B"
    }
  ],
  "4. Dental Prostheses": [
    {
      id: 23400,
      question: "What percentage of adults aged 65 years or older in the United States and Canada are completely edentulous?",
      options: [
        "Approximately 5% of the population",
        "Approximately 20% of the population",
        "Approximately 35% of the population",
        "Approximately 50% of the population"
      ],
      correct: "B"
    },
    {
      id: 23401,
      question: "What is the primary reason for tooth loss before age 35?",
      options: [
        "Periodontal diseases leading to bone loss",
        "Dental caries affecting tooth structure",
        "Oral cancer and related treatments",
        "Traumatic injuries to the dentition"
      ],
      correct: "B"
    },
    {
      id: 23402,
      question: "Which component of a fixed partial denture is the artificial tooth that occupies the edentulous space?",
      options: [
        "The abutment supporting the structure",
        "The retainer securing the prosthesis",
        "The pontic replacing missing teeth",
        "The connector joining the components"
      ],
      correct: "C"
    },
    {
      id: 23403,
      question: "What is the estimated masticatory efficiency of removable partial dentures compared to natural dentition?",
      options: [
        "Approximately 20% of natural dentition",
        "Approximately 40% of natural dentition",
        "Approximately 60% of natural dentition",
        "Approximately 80% of natural dentition"
      ],
      correct: "A"
    },
    {
      id: 23404,
      question: "Which arch typically experiences a greater rate of alveolar ridge resorption?",
      options: [
        "The maxillary arch shows greater resorption",
        "The mandibular arch shows greater resorption",
        "Both arches resorb at equal rates",
        "Neither arch shows significant resorption"
      ],
      correct: "B"
    },
    {
      id: 23405,
      question: "What are benign bony outgrowths on the hard palate called?",
      options: [
        "Mandibular tori on the lingual surface",
        "Exostoses along the alveolar ridge",
        "Palatal tori on the hard palate",
        "Tuberosities on the maxillary bone"
      ],
      correct: "C"
    },
    {
      id: 23406,
      question: "How long should patients remove their dentures for rest during each 24-hour period?",
      options: [
        "For 2 hours to allow tissue recovery",
        "For 4 hours to prevent inflammation",
        "For 8 hours to maintain tissue health",
        "For 12 hours to maximize healing"
      ],
      correct: "C"
    },
    {
      id: 23407,
      question: "What is denture stomatitis commonly referred to as, despite minimal pain?",
      options: [
        "Denture hyperplasia affecting the mucosa",
        "Denture sore mouth causing discomfort",
        "Denture candidiasis with fungal infection",
        "Denture erosion damaging the tissue"
      ],
      correct: "B"
    },
    {
      id: 23408,
      question: "What percentage of edentulous individuals develop denture stomatitis?",
      options: [
        "Between 5% and 15% of the population",
        "Between 20% and 40% of the population",
        "Between 50% and 60% of the population",
        "Between 70% and 80% of the population"
      ],
      correct: "B"
    },
    {
      id: 23409,
      question: "Which organisms typically cause angular cheilitis?",
      options: [
        "Streptococcus species and Lactobacillus bacteria",
        "Staphylococcus aureus and Candida albicans",
        "Bacteroides species and Actinomyces bacteria",
        "Escherichia coli and Pseudomonas aeruginosa"
      ],
      correct: "B"
    },
    {
      id: 23410,
      question: "What is the recommended soaking time for complete dentures in diluted sodium hypochlorite solution?",
      options: [
        "Between 1 and 3 minutes only",
        "Between 5 and 10 minutes maximum",
        "Between 15 and 20 minutes total",
        "Between 30 and 45 minutes minimum"
      ],
      correct: "B"
    },
    {
      id: 23411,
      question: "Which vitamin deficiency can cause angular cheilitis?",
      options: [
        "Vitamin A deficiency affecting epithelium",
        "Vitamin B (riboflavin) deficiency",
        "Vitamin C deficiency impairing healing",
        "Vitamin D deficiency affecting bone"
      ],
      correct: "B"
    },
    {
      id: 23412,
      question: "What type of lesion is denture-induced fibrous hyperplasia classified as?",
      options: [
        "An infectious lesion from microorganisms",
        "A reactive or traumatic lesion",
        "A mixed reactive and infectious lesion",
        "A neoplastic lesion requiring biopsy"
      ],
      correct: "B"
    },
    {
      id: 23413,
      question: "How often should dentures typically be replaced?",
      options: [
        "Every 1 to 2 years for optimal fit",
        "Every 4 to 8 years for proper function",
        "Every 10 to 15 years when necessary",
        "Every 20 to 25 years or never"
      ],
      correct: "B"
    },
    {
      id: 23414,
      question: "What prosthesis closes communication between the nasal and oral cavity?",
      options: [
        "A complete denture for full edentulism",
        "A partial denture for missing teeth",
        "An obturator for palatal defects",
        "An overdenture on implant fixtures"
      ],
      correct: "C"
    },
    {
      id: 23415,
      question: "Which condition is characterized by multiple round-to-ovoid nodules with a cobblestone appearance?",
      options: [
        "Focal hyperkeratosis from chronic friction",
        "Denture stomatitis with generalized redness",
        "Papillary hyperplasia under the denture",
        "Fibrous hyperplasia at denture flanges"
      ],
      correct: "C"
    },
    {
      id: 23416,
      question: "What is the correlation between alveolar bone resorption and duration of edentulism?",
      options: [
        "No correlation exists between these factors",
        "Inverse correlation with less resorption over time",
        "Well-documented positive correlation",
        "Correlation only in patients with osteoporosis"
      ],
      correct: "C"
    },
    {
      id: 23417,
      question: "Which medication type can cause xerostomia in denture-wearing patients?",
      options: [
        "Antibiotics prescribed for bacterial infections",
        "Diuretics, antihypertensives, and antidepressants",
        "Analgesics used for pain management",
        "Anticoagulants for blood clot prevention"
      ],
      correct: "B"
    },
    {
      id: 23418,
      question: "What should patients avoid when cleaning dentures with soft-lining materials?",
      options: [
        "Mild soap and water for daily cleaning",
        "Soft brushes for mechanical cleaning",
        "Oxygenating and hypochlorite-type cleansers",
        "Warm water rinses after each meal"
      ],
      correct: "C"
    },
    {
      id: 23419,
      question: "How many times less can biting and chewing forces be in complete denture wearers?",
      options: [
        "Nearly two times less than natural",
        "Nearly three times less than natural",
        "Nearly five times less than natural",
        "Nearly seven times less than natural"
      ],
      correct: "C"
    },
    {
      id: 23420,
      question: "What type of denture cleanser is recommended for removable partial dentures with metal components?",
      options: [
        "Diluted sodium hypochlorite solutions",
        "Alkaline peroxide solutions in tablets",
        "Concentrated bleach solutions",
        "Household cleaning products"
      ],
      correct: "B"
    },
    {
      id: 23421,
      question: "Which psychologic response is NOT commonly associated with tooth loss?",
      options: [
        "Fear of aging and decreased sexuality",
        "Feelings of insecurity and rejection",
        "Increased self-esteem and confidence",
        "Loss of self-esteem"
      ],
      correct: "C"
    },
    {
      id: 23422,
      question: "What dietary recommendation is best for dehydrated patients?",
      options: [
        "Plain water consumed throughout the day",
        "Vegetable soup retaining water and nutrients",
        "Fruit juices high in sugar content",
        "Caffeinated beverages for fluid intake"
      ],
      correct: "B"
    },
    {
      id: 23423,
      question: "Which prosthesis type is cemented permanently to natural teeth or screwed to implants?",
      options: [
        "Removable complete denture for full arch",
        "Removable partial denture with clasps",
        "Fixed partial denture (bridge)",
        "Implant-supported overdenture with attachments"
      ],
      correct: "C"
    },
    {
      id: 23424,
      question: "What happens to periodontal ligament support area in edentulous individuals?",
      options: [
        "It increases to one-half of natural support",
        "It remains the same as natural dentition",
        "It reduces to one-fourth to one-half",
        "It completely disappears with no support"
      ],
      correct: "C"
    },
    {
      id: 23425,
      question: "Which condition may expose the contents of the mandibular canal?",
      options: [
        "Mild alveolar ridge resorption",
        "Moderate gingival inflammation",
        "Severe mandibular alveolar ridge resorption",
        "Slight periodontal bone loss"
      ],
      correct: "C"
    },
    {
      id: 23426,
      question: "What is the incidence of denture stomatitis in older adults wearing complete maxillary dentures?",
      options: [
        "Up to 25% of denture wearers",
        "Up to 45% of denture wearers",
        "Up to 65% of denture wearers",
        "Up to 85% of denture wearers"
      ],
      correct: "C"
    },
    {
      id: 23427,
      question: "Which tissue change is NOT associated with tooth extraction?",
      options: [
        "Residual alveolar ridge resorption",
        "Oral mucous membrane remodeling",
        "Increased orofacial muscle tone",
        "Loss of orofacial muscle tone"
      ],
      correct: "C"
    },
    {
      id: 23428,
      question: "What should patients do to facilitate speaking with a new dental prosthesis?",
      options: [
        "Avoid speaking for several weeks",
        "Only speak when absolutely necessary",
        "Talk to people often and read aloud",
        "Whisper to reduce denture movement"
      ],
      correct: "C"
    },
    {
      id: 23429,
      question: "Which factor does NOT contribute to xerostomia?",
      options: [
        "Sjögren syndrome affecting salivary glands",
        "Selected nutritional and hormonal deficiencies",
        "Therapeutic radiation to head and neck",
        "Increased age alone without other factors"
      ],
      correct: "D"
    },
    {
      id: 23430,
      question: "What is the Latin origin of the term \"edentulous\"?",
      options: [
        "Edentatus meaning without teeth",
        "Edentalis meaning lacking enamel",
        "Edenticus meaning broken teeth",
        "Edenturus meaning future teeth"
      ],
      correct: "A"
    },
    {
      id: 23431,
      question: "How should patients distribute food while chewing with dentures?",
      options: [
        "Chew only on the right side",
        "Chew only on the left side",
        "Chew only on the anterior teeth",
        "Evenly distribute to both posterior sides"
      ],
      correct: "D"
    },
    {
      id: 23432,
      question: "What is the primary causative organism for chronic candidiasis?",
      options: [
        "Staphylococcus aureus bacteria",
        "Streptococcus mutans bacteria",
        "Candida albicans fungus",
        "Lactobacillus acidophilus bacteria"
      ],
      correct: "C"
    },
    {
      id: 23433,
      question: "Which systemic condition does NOT predispose individuals to Candida infection?",
      options: [
        "Diabetes mellitus affecting immunity",
        "Anemia reducing tissue resistance",
        "Menopause with hormonal changes",
        "Hyperthyroidism increasing metabolism"
      ],
      correct: "D"
    },
    {
      id: 23434,
      question: "What cooking method is recommended to maximize nutritional value of protein-rich foods?",
      options: [
        "Frying in vegetable or olive oil",
        "Broiling or boiling the foods",
        "Deep-frying in saturated fats",
        "Grilling at very high temperatures"
      ],
      correct: "B"
    },
    {
      id: 23435,
      question: "Which of the following is a major risk factor for tooth loss?",
      options: [
        "High socioeconomic status",
        "Frequent professional oral care",
        "Low socioeconomic status",
        "Excellent daily oral hygiene"
      ],
      correct: "C"
    },
    {
      id: 23436,
      question: "What is the recommended frequency for adjusting dentures?",
      options: [
        "Monthly adjustments for optimal fit",
        "Quarterly adjustments every three months",
        "Annual adjustments for maintenance",
        "Adjustments only when broken"
      ],
      correct: "C"
    },
    {
      id: 23437,
      question: "Which denture cleaning method involves electromagnetic waves?",
      options: [
        "Ultrasonic cleaning devices",
        "Chemical soak cleansers",
        "Microwave radiation (in-office)",
        "Alkaline peroxide solutions"
      ],
      correct: "C"
    },
    {
      id: 23438,
      question: "What is the proper direction for cleaning edentulous mucosa with a soft toothbrush?",
      options: [
        "From anterior to posterior direction",
        "From posterior to anterior direction",
        "In circular motions only",
        "In horizontal strokes only"
      ],
      correct: "B"
    },
    {
      id: 23439,
      question: "How many glasses of water should patients drink daily?",
      options: [
        "Four glasses to maintain hydration",
        "Six glasses for adequate function",
        "Eight glasses for essential functions",
        "Ten glasses for optimal health"
      ],
      correct: "C"
    },
    {
      id: 23440,
      question: "Which lesion appears as a white patch and is asymptomatic?",
      options: [
        "Acute ulcers with yellow-white exudates",
        "Denture stomatitis with redness",
        "Focal (frictional) hyperkeratosis",
        "Papillary hyperplasia with nodules"
      ],
      correct: "C"
    },
    {
      id: 23441,
      question: "What is the clinical appearance of denture stomatitis?",
      options: [
        "White patches on buccal mucosa",
        "Generalized redness with velvetlike appearance",
        "Yellow ulcers with red halos",
        "Purple lesions with rough texture"
      ],
      correct: "B"
    },
    {
      id: 23442,
      question: "Which material should NEVER be used on metal-containing prostheses?",
      options: [
        "Mild soap and warm water",
        "Alkaline peroxide tablet solutions",
        "Sodium hypochlorite solutions",
        "Commercial denture paste"
      ],
      correct: "C"
    },
    {
      id: 23443,
      question: "What percentage of the total questions should true/false questions comprise?",
      options: [
        "Approximately 5% of total questions",
        "Approximately 10% of total questions",
        "Approximately 15% of total questions",
        "Approximately 20% of total questions"
      ],
      correct: "B"
    },
    {
      id: 23444,
      question: "Which stage occurs within the first year after tooth extraction?",
      options: [
        "Complete cessation of bone changes",
        "Increased bone density and strength",
        "Major bony changes and ridge resorption",
        "Regeneration of alveolar bone"
      ],
      correct: "C"
    },
    {
      id: 23445,
      question: "What is the proper storage method for dentures when not wearing them?",
      options: [
        "Leave them on the bathroom counter",
        "Store them in hot water only",
        "Place in a container dry or with cleanser",
        "Keep them in direct sunlight"
      ],
      correct: "C"
    },
    {
      id: 23446,
      question: "Which nutrient deficiency contributes to severe mandibular atrophy?",
      options: [
        "High calcium intake from supplements",
        "Adequate vitamin D from sunlight",
        "Calcium-poor diet lacking dairy",
        "Excessive protein from meat"
      ],
      correct: "C"
    },
    {
      id: 23447,
      question: "What is the location where final denture outputs should be placed?",
      options: [
        "In the /home/claude directory",
        "In the /tmp temporary folder",
        "In the /mnt/user-data/outputs directory",
        "In the /mnt/uploads folder"
      ],
      correct: "C"
    },
    {
      id: 23448,
      question: "Which type of prosthesis is supported by retainer clasps around natural teeth?",
      options: [
        "Fixed partial denture or bridge",
        "Removable partial denture",
        "Complete denture for full arch",
        "Implant-supported overdenture"
      ],
      correct: "B"
    },
    {
      id: 23449,
      question: "What dental professional should patients contact for denture repairs?",
      options: [
        "Dental hygienist for all repairs",
        "Pharmacist for adhesive advice",
        "Dentist for proper professional care",
        "Online retailer for home kits"
      ],
      correct: "C"
    },
    {
      id: 23450,
      question: "How should dentures with resilient liners be cleaned?",
      options: [
        "With abrasive powders and hard brush",
        "With hypochlorite solutions overnight",
        "With soft brush and nonabrasive cleanser",
        "With boiling water for sterilization"
      ],
      correct: "C"
    },
    {
      id: 23451,
      question: "What is the purpose of tissue conditioners in dentures?",
      options: [
        "To permanently repair broken dentures",
        "To palliatively treat chronic soreness",
        "To bleach stains from denture teeth",
        "To dissolve calculus deposits"
      ],
      correct: "B"
    },
    {
      id: 23452,
      question: "Which population has the highest prevalence of denture stomatitis?",
      options: [
        "Young males under age 30",
        "Middle-aged males age 40-50",
        "Older females wearing maxillary dentures",
        "Children with primary dentition"
      ],
      correct: "C"
    },
    {
      id: 23453,
      question: "What happens to denture acrylic when abrasive powders are used incorrectly?",
      options: [
        "It becomes harder and more durable",
        "It changes color to yellow tint",
        "It becomes abraded and damaged",
        "It develops antimicrobial properties"
      ],
      correct: "C"
    },
    {
      id: 23454,
      question: "Which food group do older edentulous patients often prefer?",
      options: [
        "High-protein meats and fish",
        "High-fiber vegetables and fruits",
        "Soft diet high in carbohydrates",
        "Raw vegetables and nuts"
      ],
      correct: "C"
    }
  ],
  "5. Tooth Sensitivity": [
    {
      id: 23500,
      question: "What characterizes dentinal hypersensitivity pain?",
      options: [
        "Long-lasting, dull ache from pulpal inflammation",
        "Short, sharp pain from exposed dentin",
        "Continuous throbbing without external stimulus",
        "Intermittent pain unrelated to environmental factors"
      ],
      correct: "B"
    },
    {
      id: 23501,
      question: "Which theory is most widely accepted today to explain dentinal hypersensitivity?",
      options: [
        "The transducer theory of nerve activation",
        "The modulation theory of pain control",
        "The hydrodynamic theory of fluid movement",
        "The gate control theory of transmission"
      ],
      correct: "C"
    },
    {
      id: 23502,
      question: "What percentage of the time does cementum overlap enamel at the CEJ?",
      options: [
        "Approximately 5% to 10% of cases",
        "Approximately 30% of cases observed",
        "Approximately 60% to 65% of cases",
        "Approximately 85% to 90% of cases"
      ],
      correct: "C"
    },
    {
      id: 23503,
      question: "Which nerve fibers are responsible for the sharp pain of dentinal hypersensitivity?",
      options: [
        "C-fibers transmitting dull aching sensations",
        "A-delta fibers with myelinated structure",
        "B-fibers conducting autonomic signals",
        "A-gamma fibers for proprioception"
      ],
      correct: "B"
    },
    {
      id: 23504,
      question: "How far do sensory nerve fibers extend from the pulp toward the dentinoenamel junction?",
      options: [
        "1% to 5% of total distance",
        "10% to 15% of total distance",
        "25% to 30% of total distance",
        "40% to 50% of total distance"
      ],
      correct: "B"
    },
    {
      id: 23505,
      question: "How many more open dentinal tubules does hypersensitive dentin have compared to nonsensitive dentin?",
      options: [
        "Two times as many tubules",
        "Four times as many tubules",
        "Eight times as many tubules",
        "Sixteen times as many tubules"
      ],
      correct: "C"
    },
    {
      id: 23506,
      question: "What is the diameter difference of open tubules in hypersensitive versus nonsensitive dentin?",
      options: [
        "Half the diameter in sensitive tissue",
        "Equal diameter in both tissue types",
        "Twice the diameter in sensitive tissue",
        "Four times the diameter overall"
      ],
      correct: "C"
    },
    {
      id: 23507,
      question: "What is the most common cause of dentinal hypersensitivity?",
      options: [
        "Enamel loss above the CEJ",
        "Gingival recession exposing dentin",
        "Dental caries destroying tooth structure",
        "Occlusal attrition from grinding"
      ],
      correct: "B"
    },
    {
      id: 23508,
      question: "What happens to exposed cementum below the CEJ?",
      options: [
        "It thickens and provides protection",
        "It calcifies and becomes stronger",
        "It becomes nonviable and is lost",
        "It regenerates with proper care"
      ],
      correct: "C"
    },
    {
      id: 23509,
      question: "Which tooth surfaces are most commonly affected by localized gingival recession?",
      options: [
        "Lingual surfaces of molars",
        "Buccal surfaces of canines and premolars",
        "Palatal surfaces of anterior teeth",
        "Occlusal surfaces of posterior teeth"
      ],
      correct: "B"
    },
    {
      id: 23510,
      question: "What is the most common factor associated with gingival recession?",
      options: [
        "Orthodontic tooth movement",
        "Occlusal trauma from bruxism",
        "Bacterial plaque biofilm accumulation",
        "Genetic predisposition factors"
      ],
      correct: "C"
    },
    {
      id: 23511,
      question: "How many times more slowly does enamel abrade compared to dentin during brushing?",
      options: [
        "5 times more slowly",
        "10 times more slowly",
        "25 times more slowly",
        "50 times more slowly"
      ],
      correct: "C"
    },
    {
      id: 23512,
      question: "How many times slower does enamel abrade compared to cementum?",
      options: [
        "10 times slower overall",
        "20 times slower overall",
        "35 times slower overall",
        "50 times slower overall"
      ],
      correct: "C"
    },
    {
      id: 23513,
      question: "What is abfraction?",
      options: [
        "Chemical erosion from acidic foods",
        "Mechanical wear from tooth brushing",
        "Loss of tooth structure from flexion forces",
        "Decay process at the gingival margin"
      ],
      correct: "C"
    },
    {
      id: 23514,
      question: "What is the reported prevalence range of dentinal hypersensitivity?",
      options: [
        "1.2% to 15.6% of the population",
        "4.8% to 62.3% of the population",
        "70.1% to 85.4% of the population",
        "90.2% to 98.7% of the population"
      ],
      correct: "B"
    },
    {
      id: 23515,
      question: "In which age group is dentinal hypersensitivity most common?",
      options: [
        "Children and adolescents under 18",
        "Young adults in their 20s-40s",
        "Middle-aged adults 50s-60s",
        "Elderly adults over 70 years"
      ],
      correct: "B"
    },
    {
      id: 23516,
      question: "Why does dentinal hypersensitivity decrease with age?",
      options: [
        "Increased enamel thickness with aging",
        "Formation of secondary and tertiary dentin",
        "Reduced dietary acid consumption",
        "Improved oral hygiene practices"
      ],
      correct: "B"
    },
    {
      id: 23517,
      question: "What is dentinal sclerosis?",
      options: [
        "Inflammation of the pulp chamber",
        "Reduction of dentinal tubule lumen",
        "Expansion of the pulp space",
        "Softening of the dentin layer"
      ],
      correct: "B"
    },
    {
      id: 23518,
      question: "Which hand tends to clean teeth more vigorously in right-handed individuals?",
      options: [
        "Right hand for right-sided teeth",
        "Left hand for left-sided teeth",
        "Right hand for left-sided teeth",
        "Both hands clean equally"
      ],
      correct: "C"
    },
    {
      id: 23519,
      question: "What must be present for a diagnosis of dentinal hypersensitivity?",
      options: [
        "Radiographic evidence of pulpal inflammation",
        "Clinical signs of dental caries",
        "Exposed dentin at sensitivity site",
        "Evidence of fracture lines"
      ],
      correct: "C"
    },
    {
      id: 23520,
      question: "Which finding helps confirm absence of dental caries?",
      options: [
        "Presence of pulpal inflammation",
        "No pulpal inflammation or apical pathology",
        "Distinct fracture lines visible",
        "Radiolucent areas under restorations"
      ],
      correct: "B"
    },
    {
      id: 23521,
      question: "What is cervical burnout?",
      options: [
        "A pathological radiolucency requiring treatment",
        "Normal radiographic appearance, not pathology",
        "Sign of advanced dental caries",
        "Indicator of pulpal inflammation"
      ],
      correct: "B"
    },
    {
      id: 23522,
      question: "What percentage of sensitivity sufferers don\'t report their pain?",
      options: [
        "Approximately 25% of sufferers",
        "Approximately 50% of sufferers",
        "Approximately 75% of sufferers",
        "Approximately 90% of sufferers"
      ],
      correct: "B"
    },
    {
      id: 23523,
      question: "Which stimulus causes sensitivity in 80% of patients?",
      options: [
        "Heat from hot beverages",
        "Cold from ice or drinks",
        "Touch from toothbrush",
        "Dietary acids from foods"
      ],
      correct: "B"
    },
    {
      id: 23524,
      question: "What is the first line of treatment for dentinal hypersensitivity?",
      options: [
        "Surgical root coverage procedures",
        "Behavior modification and education",
        "Immediate restorative treatment",
        "Laser therapy for tubule occlusion"
      ],
      correct: "B"
    },
    {
      id: 23525,
      question: "Which desensitizing mechanism uses potassium-based compounds?",
      options: [
        "Physical occlusion of tubules",
        "Chemical precipitation of minerals",
        "Nerve depolarization and desensitization",
        "Photobiomodulation with laser"
      ],
      correct: "C"
    },
    {
      id: 23526,
      question: "What is the most common desensitizing agent in over-the-counter dentifrices?",
      options: [
        "Stannous fluoride for tubule occlusion",
        "Potassium nitrate for nerve action",
        "Arginine for physical blocking",
        "Strontium acetate for precipitation"
      ],
      correct: "B"
    },
    {
      id: 23527,
      question: "What concentration of stannous fluoride is used in desensitizing dentifrices?",
      options: [
        "0.1% or 0.154% concentration",
        "0.4% or 0.454% concentration",
        "1.1% or 1.23% concentration",
        "2.0% or 2.26% concentration"
      ],
      correct: "B"
    },
    {
      id: 23528,
      question: "What concentration of arginine is used in desensitizing dentifrices?",
      options: [
        "2.0% arginine with calcium",
        "5.0% arginine with calcium",
        "8.0% arginine with calcium",
        "12.0% arginine with calcium"
      ],
      correct: "C"
    },
    {
      id: 23529,
      question: "How does arginine work to relieve sensitivity?",
      options: [
        "By depolarizing nerve endings",
        "By physically blocking tubules",
        "By chemical precipitation",
        "By laser activation"
      ],
      correct: "B"
    },
    {
      id: 23530,
      question: "What concentration of strontium acetate is used in dentifrices?",
      options: [
        "2% for chemical blockage",
        "5% for chemical blockage",
        "10% for chemical blockage",
        "15% for chemical blockage"
      ],
      correct: "C"
    },
    {
      id: 23531,
      question: "What is a potential side effect of stannous fluoride formulations?",
      options: [
        "Increased tooth sensitivity",
        "Tooth staining",
        "Gingival hyperplasia",
        "Enamel erosion"
      ],
      correct: "B"
    },
    {
      id: 23532,
      question: "What concentration of silver diamine fluoride is used professionally?",
      options: [
        "5% silver diamine fluoride",
        "18% silver diamine fluoride",
        "38% silver diamine fluoride",
        "58% silver diamine fluoride"
      ],
      correct: "C"
    },
    {
      id: 23533,
      question: "What is a major side effect of silver diamine fluoride?",
      options: [
        "It causes severe tooth pain",
        "It stains active caries black",
        "It erodes healthy enamel",
        "It irritates gingival tissue"
      ],
      correct: "B"
    },
    {
      id: 23534,
      question: "What does CPP-ACP stand for?",
      options: [
        "Calcium phosphate peptide-amorphous calcium phosphate",
        "Casein phosphopeptide-amorphous calcium phosphate",
        "Collagen protein peptide-activated calcium phosphate",
        "Composite polymer phosphate-alkaline calcium phosphate"
      ],
      correct: "B"
    },
    {
      id: 23535,
      question: "What concentration of glutaraldehyde is combined with HEMA in Gluma?",
      options: [
        "2% glutaraldehyde with HEMA",
        "5% glutaraldehyde with HEMA",
        "10% glutaraldehyde with HEMA",
        "15% glutaraldehyde with HEMA"
      ],
      correct: "B"
    },
    {
      id: 23536,
      question: "What concentration of HEMA is used in desensitizing primers?",
      options: [
        "10% HEMA in water solution",
        "20% HEMA in water solution",
        "35% HEMA in water solution",
        "50% HEMA in water solution"
      ],
      correct: "C"
    },
    {
      id: 23537,
      question: "How long should resin primer be rubbed on hypersensitive dentin?",
      options: [
        "Approximately 5 seconds",
        "Approximately 10 seconds",
        "Approximately 20 seconds",
        "Approximately 30 seconds"
      ],
      correct: "B"
    },
    {
      id: 23538,
      question: "What surgical procedure is most common for Miller class I and II recession defects?",
      options: [
        "Free gingival graft procedure",
        "Subepithelial connective tissue graft",
        "Guided tissue regeneration",
        "Acellular dermal matrix placement"
      ],
      correct: "B"
    },
    {
      id: 23539,
      question: "What is calcium sodium phosphosilicate also known as?",
      options: [
        "BioMin as the brand name",
        "NovaMin as the brand name",
        "CalciDent as the brand name",
        "DentaGlass as the brand name"
      ],
      correct: "B"
    },
    {
      id: 23540,
      question: "Which layer must be removed before applying desensitizing agents?",
      options: [
        "Enamel layer on tooth surface",
        "Cementum layer over dentin",
        "Hard and soft deposits",
        "Gingival tissue covering root"
      ],
      correct: "C"
    },
    {
      id: 23541,
      question: "What should be done if desensitizing treatment causes considerable discomfort?",
      options: [
        "Continue without anesthesia",
        "Anesthetize teeth before treatment",
        "Postpone treatment indefinitely",
        "Skip mechanical debridement"
      ],
      correct: "B"
    },
    {
      id: 23542,
      question: "In teledentistry for dentinal hypersensitivity, what should always be stressed?",
      options: [
        "Telehealth visits replace in-person visits",
        "Pictures are sufficient for diagnosis",
        "Telehealth doesn\'t replace in-person visits when there\'s pain",
        "Video consultations are always adequate"
      ],
      correct: "C"
    },
    {
      id: 23543,
      question: "What VAS score did the patient report before connective tissue graft surgery?",
      options: [
        "VAS value of 3",
        "VAS value of 5",
        "VAS value of 10",
        "VAS value of 15"
      ],
      correct: "C"
    },
    {
      id: 23544,
      question: "What VAS score did the patient report 6 weeks after connective tissue graft?",
      options: [
        "VAS value of 2",
        "VAS value of 5",
        "VAS value of 8",
        "VAS value of 10"
      ],
      correct: "B"
    },
    {
      id: 23545,
      question: "Which mechanism is debated for how laser treatment works?",
      options: [
        "Chemical precipitation in tubules",
        "Nerve fiber depolarization",
        "Sealing of dentinal tubules",
        "Stimulation of cementum growth"
      ],
      correct: "C"
    },
    {
      id: 23546,
      question: "What type of restorations may be placed for severe hypersensitivity?",
      options: [
        "Gold inlays for posterior teeth",
        "Ceramic veneers for anterior teeth",
        "Restorations to cover exposed dentin",
        "Orthodontic bands for protection"
      ],
      correct: "C"
    },
    {
      id: 23547,
      question: "In extreme cases, what procedures might be necessary for hypersensitivity?",
      options: [
        "Crown lengthening or gingivectomy",
        "Root canal therapy or extraction",
        "Orthodontic repositioning",
        "Periodontal flap surgery"
      ],
      correct: "B"
    },
    {
      id: 23548,
      question: "What can allografts be used for in periodontal plastic surgery?",
      options: [
        "Only for cosmetic enhancement",
        "As donated tissue from cadaver",
        "To replace bone loss only",
        "For orthodontic anchorage"
      ],
      correct: "B"
    },
    {
      id: 23549,
      question: "What are the four mechanisms of action for desensitizing agents?",
      options: [
        "Abrasion, erosion, attrition, abfraction",
        "Cleaning, whitening, freshening, protecting",
        "Physical occlusion, chemical occlusion, nerve desensitization, photobiomodulation",
        "Remineralization, demineralization, calcification, fluoridation"
      ],
      correct: "C"
    },
    {
      id: 23550,
      question: "What does photobiomodulation use for desensitization?",
      options: [
        "Chemical agents for precipitation",
        "Mechanical devices for occlusion",
        "Laser therapy for odontoblast metabolism",
        "Ultrasonic energy for nerve blocking"
      ],
      correct: "C"
    },
    {
      id: 23551,
      question: "Why is sodium fluoride varnish evidence weak for dentinal hypersensitivity?",
      options: [
        "It causes severe adverse effects",
        "Effective for caries but weak for sensitivity",
        "It damages enamel structure",
        "It\'s too expensive for patients"
      ],
      correct: "B"
    },
    {
      id: 23552,
      question: "What is the benefit of chlorhexidine-thymol varnish for older patients?",
      options: [
        "Whitens teeth effectively",
        "Prevents root caries",
        "Strengthens enamel",
        "Reduces gingival inflammation"
      ],
      correct: "B"
    },
    {
      id: 23553,
      question: "When should CPP-ACP prophylaxis paste be used?",
      options: [
        "Only after extractions",
        "Before scaling and root planing",
        "During orthodontic treatment",
        "After crown preparation"
      ],
      correct: "B"
    },
    {
      id: 23554,
      question: "What must traverse from exposed dentin to vital pulp for hypersensitivity?",
      options: [
        "Blood vessels carrying nutrients",
        "Nerve fibers providing sensation",
        "Open dentinal tubule channels",
        "Cementum covering the surface"
      ],
      correct: "C"
    },
    {
      id: 23555,
      question: "What is the primary reason enamel loss leads to sensitivity?",
      options: [
        "It exposes nerves directly",
        "It allows bacteria to enter",
        "It\'s a prerequisite for dentin exposure",
        "It causes pulpal inflammation"
      ],
      correct: "C"
    },
    {
      id: 23556,
      question: "Which type of erosion is caused by acid reflux disease?",
      options: [
        "Extrinsic erosion from environment",
        "Intrinsic erosion from body",
        "Mechanical erosion from brushing",
        "Chemical erosion from toothpaste"
      ],
      correct: "B"
    },
    {
      id: 23557,
      question: "What causes extrinsic erosion?",
      options: [
        "Vomiting from bulimia",
        "Gastric reflux at night",
        "Dietary acidic beverages",
        "Morning sickness"
      ],
      correct: "C"
    },
    {
      id: 23558,
      question: "Why might orthodontic treatment predispose to recession?",
      options: [
        "It removes protective enamel",
        "It moves tooth through buccal plate",
        "It damages the pulp tissue",
        "It causes severe inflammation"
      ],
      correct: "B"
    },
    {
      id: 23559,
      question: "What is fenestrated alveolar bone?",
      options: [
        "Thickened bone with extra density",
        "Normal bone with proper thickness",
        "Thin or absent bone creating defect",
        "Infected bone requiring treatment"
      ],
      correct: "C"
    },
    {
      id: 23560,
      question: "How does poorly contoured restoration cause recession?",
      options: [
        "By being too large",
        "By creating plaque traps",
        "By being too small",
        "By causing occlusal trauma"
      ],
      correct: "B"
    },
    {
      id: 23561,
      question: "Why are smokers at risk for recession?",
      options: [
        "Nicotine causes vasoconstriction",
        "Smoke irritates gingiva",
        "Tar deposits damage tissue",
        "Heat burns the tissue"
      ],
      correct: "A"
    },
    {
      id: 23562,
      question: "How can oral piercings cause recession?",
      options: [
        "By harboring bacteria",
        "By causing allergic reactions",
        "By pulling on gingival tissue",
        "By blocking saliva flow"
      ],
      correct: "C"
    },
    {
      id: 23563,
      question: "What is attrition?",
      options: [
        "Chemical loss from acids",
        "Wear from masticatory forces",
        "Loss from toothbrush abrasion",
        "Damage from trauma"
      ],
      correct: "B"
    },
    {
      id: 23564,
      question: "What causes abrasion of tooth structure?",
      options: [
        "Acidic foods and beverages",
        "Grinding teeth at night",
        "Toothbrush and toothpaste",
        "Periodontal disease"
      ],
      correct: "C"
    },
    {
      id: 23565,
      question: "Why can periodontal therapy cause sensitivity?",
      options: [
        "It introduces bacteria",
        "It damages enamel",
        "It removes protective cementum",
        "It weakens tooth structure"
      ],
      correct: "C"
    },
    {
      id: 23566,
      question: "What is a common side effect of vital tooth bleaching?",
      options: [
        "Permanent enamel damage",
        "Tooth sensitivity",
        "Gingival recession",
        "Pulpal necrosis"
      ],
      correct: "B"
    },
    {
      id: 23567,
      question: "What should patients do to reduce bleaching sensitivity?",
      options: [
        "Use stronger concentrations",
        "Bleach more frequently",
        "Follow manufacturer\'s instructions",
        "Skip fluoride therapy"
      ],
      correct: "C"
    }
  ],
  "1. Dental Implants and Implant Care (Case Study)": [
    {
      id: 23568,
      question: "A 58-year-old female patient presents with a missing mandibular first molar. She has well-controlled type 2 diabetes with an HbA1c of 7.2%. She is a non-smoker and has no history of periodontal disease. She is interested in implant replacement.\n\nWhat is the MOST appropriate initial recommendation for this patient?",
      options: [
        "Decline implant placement due to diabetes and refer for bridge fabrication",
        "Proceed with implant treatment planning including diagnostic imaging and study models",
        "Wait until HbA1c is below 6.0% before considering any implant treatment",
        "Place the implant immediately without additional diagnostic workup",
      ],
      correct: "B"
    },
    {
      id: 23569,
      question: "A 45-year-old male patient presents wanting dental implants. During the health history review, you learn he smokes 15 cigarettes per day, has uncontrolled rheumatoid arthritis, and underwent radiation therapy for head and neck cancer 2 years ago.\n\nHow many absolute or relative contraindications to implant placement does this patient present?",
      options: [
        "This patient has one contraindication that can be easily modified with cessation counseling",
        "This patient has two significant contraindications requiring medical management before proceeding",
        "This patient has three major contraindications that significantly increase implant failure risk",
        "This patient has no contraindications and is an ideal candidate for implants",
      ],
      correct: "C"
    },
    {
      id: 23570,
      question: "A patient is being evaluated for implant placement in the posterior maxilla near the maxillary sinus. Initial periapical radiographs show limited bone height in the area.\n\nWhat imaging modality would be MOST appropriate for surgical planning in this case?",
      options: [
        "Additional periapical radiographs taken at different angles for better visualization",
        "Bitewing radiographs to assess the interproximal bone levels adequately",
        "Panoramic radiograph alone provides sufficient detail for implant planning",
        "Cone-beam computed tomography to assess three-dimensional bone volume and anatomy",
      ],
      correct: "D"
    },
    {
      id: 23571,
      question: "During a maintenance visit, you are examining a single-tooth implant restoration. The radiograph shows the crown appears to be directly connected to the implant without a visible separate abutment piece.\n\nWhat type of restoration is MOST likely present?",
      options: [
        "Cement-retained crown with a custom abutment that mimics tooth preparation",
        "Screw-retained crown where the abutment is fabricated as one piece with crown",
        "Removable crown attached with clips that snap onto the implant platform",
        "Temporary crown that has not yet been replaced with the final restoration",
      ],
      correct: "B"
    },
    {
      id: 23572,
      question: "A patient had a dental implant placed 6 weeks ago. She calls asking when she can have her final crown placed because she has an important event in 2 weeks.\n\nWhat is the MOST appropriate response regarding the typical healing timeline?",
      options: [
        "The crown can be placed now since 6 weeks is adequate for osseointegration",
        "The implant requires 3-6 months of healing before the final restoration is placed",
        "Only 2-3 weeks additional healing time is needed before crown placement",
        "The crown must wait 12 months to ensure complete osseointegration occurs",
      ],
      correct: "B"
    },
    {
      id: 23573,
      question: "You are reviewing a periapical radiograph of a recently placed implant. You notice the abutment appears smaller in diameter than the implant platform, creating a visible step.\n\nWhat does this radiographic appearance MOST likely indicate?",
      options: [
        "The wrong size abutment was selected and needs to be replaced immediately",
        "The abutment is not completely seated and requires adjustment by the dentist",
        "This is a platform-switched design intended to minimize peri-implant bone loss",
        "The implant threads are showing through, indicating the implant is failing",
      ],
      correct: "C"
    },
    {
      id: 23574,
      question: "A patient presents for a 6-month maintenance visit. During the exam, you notice inflammation and increased probing depths around an implant crown placed 8 months ago. Radiographs reveal a radiopaque material in the peri-implant sulcus.\n\nWhat is the MOST likely cause of the peri-implant inflammation?",
      options: [
        "Poor oral hygiene leading to excessive plaque biofilm accumulation around the implant",
        "Excess cement remaining from crown placement contributing to tissue inflammation",
        "Occlusal trauma from premature contacts causing inflammatory response in tissues",
        "Normal tissue remodeling that occurs during the first year after restoration",
      ],
      correct: "B"
    },
    {
      id: 23575,
      question: "A patient asks why their implants require more careful maintenance than natural teeth. You explain the biological differences between teeth and implants.\n\nWhich statement MOST accurately describes a key difference in tissue attachment?",
      options: [
        "Implants have Sharpey's fibers that attach the tissue more firmly than teeth",
        "Implants have the same blood supply as teeth from the periodontal ligament",
        "Implants have only circular collagen fibers and lack connective tissue attachment",
        "Implants have eleven different fiber groups providing superior tissue attachment",
      ],
      correct: "C"
    },
    {
      id: 23576,
      question: "During an implant assessment, you observe that two adjacent implants have different tissue appearances. One has firm, pink, stippled tissue while the other has smooth, red tissue.\n\nWhat does this difference in tissue appearance MOST likely indicate?",
      options: [
        "The red tissue indicates active peri-implantitis requiring immediate surgical intervention",
        "One implant has keratinized mucosa while the other has nonkeratinized mucosa",
        "Both tissues are inflamed but at different stages of disease progression",
        "The smooth tissue indicates inadequate oral hygiene in that specific area",
      ],
      correct: "B"
    },
    {
      id: 23577,
      question: "A patient received their final implant crown 2 weeks ago. They are scheduled for their first maintenance appointment.\n\nWhen is the MOST appropriate time to establish baseline probing depths?",
      options: [
        "Probing should have been done before the crown was placed for comparison",
        "Baseline probing depths should be recorded now at this 2-week appointment",
        "Probing should wait until 3-6 months after crown placement for tissue maturation",
        "Probing is contraindicated for implants to avoid disrupting the fragile attachment",
      ],
      correct: "B"
    },
    {
      id: 23578,
      question: "You are training a new hygienist on implant probing technique. She asks about the appropriate probing force to use on implants.\n\nWhat probing force is recommended for dental implants?",
      options: [
        "Heavy force (35N) is needed to reach the true base of the sulcus",
        "Moderate force (25N) similar to natural teeth probing is appropriate",
        "Light force (25N) should be used to avoid damaging peri-implant tissues",
        "Very light force (15N) prevents any damage to the fragile epithelial seal",
      ],
      correct: "C"
    },
    {
      id: 23579,
      question: "At a 1-year recall, an implant that initially had 3mm probing depths now has 5mm depths with bleeding on probing. The radiograph shows no bone loss compared to baseline.\n\nWhat is the MOST accurate interpretation of these findings?",
      options: [
        "This represents peri-implant health since probing depths can vary significantly with implants",
        "This represents peri-implant mucositis with increased probing depth and bleeding present",
        "This represents peri-implantitis since probing depths have increased by 2mm or more",
        "This represents normal tissue maturation in the first year after implant restoration",
      ],
      correct: "B"
    },
    {
      id: 23580,
      question: "A patient asks why they need annual radiographs of their implants when the implants \"feel fine.\"\n\nWhat is the PRIMARY reason for periodic radiographic assessment of implants?",
      options: [
        "To check for mechanical complications like loose screws that cannot be detected clinically",
        "To monitor for peri-implant bone loss that may occur without patient symptoms",
        "To satisfy insurance requirements for continued coverage of implant maintenance",
        "To document the implant location in case the patient changes dental offices",
      ],
      correct: "B"
    },
    {
      id: 23581,
      question: "A radiograph taken 1 year after implant placement shows approximately 1mm of crestal bone loss compared to the placement radiograph. The implant is clinically stable with healthy tissue.\n\nHow should this radiographic finding be interpreted?",
      options: [
        "This indicates early peri-implantitis and requires immediate surgical intervention",
        "This represents normal physiologic bone remodeling expected in the first year",
        "This suggests the implant is failing and will need to be removed soon",
        "This indicates the patient has poor oral hygiene requiring more frequent maintenance",
      ],
      correct: "B"
    },
    {
      id: 23582,
      question: "During an examination of a mandibular implant-supported overdenture, the patient mentions it feels loose. You notice the overdenture rocks when pressure is applied.\n\nWhat is the MOST likely cause of this mobility?",
      options: [
        "The dental implants have lost osseointegration and are mobile in bone",
        "The retentive elements (O-rings, clips, or Locator caps) are worn and need replacement",
        "The patient has excessive bone loss around the implants causing prosthesis movement",
        "The denture base has fractured and requires fabrication of a new prosthesis",
      ],
      correct: "B"
    },
    {
      id: 23583,
      question: "You are assessing a maxillary implant-supported fixed complete denture. The prosthesis has a concave tissue-contacting surface with no space between the prosthesis and tissue.\n\nWhat is the MOST appropriate recommendation for this prosthesis design?",
      options: [
        "This design is ideal as it provides maximum aesthetic support for facial tissues",
        "This design is acceptable if the patient can remove it daily for cleaning",
        "This design requires modification to allow adequate access for oral hygiene",
        "This design should remain unchanged since fixed prostheses cannot be altered",
      ],
      correct: "C"
    },
    {
      id: 23584,
      question: "A patient presents with bleeding on probing around an implant crown, 4mm probing depths, and visible plaque accumulation. The radiograph shows no bone loss beyond initial remodeling.\n\nWhat is the MOST accurate diagnosis for this clinical presentation?",
      options: [
        "Peri-implant health since probing depths are less than 5mm and mobile implants",
        "Peri-implant mucositis characterized by reversible inflammation without bone loss",
        "Peri-implantitis since bleeding and increased probing depths are both present",
        "Early implant failure requiring immediate removal and site preparation for replacement",
      ],
      correct: "B"
    },
    {
      id: 23585,
      question: "You are examining an implant placed 3 years ago. Compared to last year's exam, probing depths have increased from 3mm to 7mm with suppuration. The radiograph shows 4mm of bone loss beyond initial remodeling compared to the 1-year post-loading radiograph.\n\nWhat is the MOST accurate diagnosis based on these findings?",
      options: [
        "Peri-implant health with normal tissue maturation and slight probing variation",
        "Peri-implant mucositis requiring more frequent maintenance and oral hygiene reinforcement",
        "Peri-implantitis with increased probing depth, suppuration, and progressive bone loss",
        "Reversible inflammation that will resolve with one session of mechanical debridement",
      ],
      correct: "C"
    },
    {
      id: 23586,
      question: "A new patient presents with an implant placed 5 years ago at another office. No previous records are available. You measure 7mm probing depths with bleeding and suppuration. The radiograph shows bone loss 4mm apical to the most coronal portion of the intraosseous implant.\n\nWhat diagnosis can be made WITHOUT previous examination data?",
      options: [
        "Peri-implant health cannot be determined without comparing to baseline measurements",
        "Peri-implant mucositis since bone loss cannot be confirmed without prior radiographs",
        "Peri-implantitis based on probing depths ≥6mm and bone loss ≥3mm criteria",
        "Healthy implant with reduced bone support from initial placement complications",
      ],
      correct: "C"
    },
    {
      id: 23587,
      question: "A patient with implants presents for maintenance. During the health history update, you note he has developed poorly controlled diabetes (HbA1c 9.5%), continues smoking one pack per day, and has visible plaque on his implants and remaining teeth.\n\nHow many modifiable risk factors for peri-implant disease are present?",
      options: [
        "One modifiable risk factor that can be addressed through oral hygiene instruction",
        "Two modifiable risk factors requiring both medical referral and behavior modification",
        "Three modifiable risk factors including glycemic control, smoking cessation, and oral hygiene",
        "No modifiable risk factors since diabetes and smoking cannot be changed",
      ],
      correct: "C"
    },
    {
      id: 23588,
      question: "A patient with four single-tooth implants asks what type of toothbrush they should use. They currently use a medium-bristled manual toothbrush on their natural teeth.\n\nWhat is the MOST appropriate toothbrush recommendation for implant care?",
      options: [
        "Continue using the medium-bristled brush since implants are stronger than natural teeth",
        "Switch to a hard-bristled brush to ensure adequate plaque removal from implants",
        "Use a soft-bristled brush directed at 45° angle to avoid damaging the abutment",
        "Use only power toothbrushes as manual brushing is inadequate for implant maintenance",
      ],
      correct: "C"
    },
    {
      id: 23589,
      question: "A patient has a three-unit implant-supported bridge replacing teeth #3-5. The pontic has adequate space between the tissue and the prosthesis.\n\nWhat is the MOST appropriate interdental cleaning recommendation?",
      options: [
        "Regular dental floss is adequate for cleaning the pontic and implant surfaces",
        "Floss or tape threaders allow access through embrasures to clean the pontic area",
        "No interdental cleaning is needed since the bridge is fixed and cannot trap food",
        "Interdental brushes are contraindicated as they will scratch the implant surfaces",
      ],
      correct: "B"
    },
    {
      id: 23590,
      question: "A patient is using metal-wire interdental brushes to clean between closely spaced implant abutments. During the exam, you notice visible scratches on the titanium abutments.\n\nWhat is the MOST appropriate recommendation to prevent further damage?",
      options: [
        "Continue current technique but use lighter pressure when inserting the brush",
        "Switch to plastic or nylon-coated wire interdental brushes to protect the abutments",
        "Discontinue all interdental brushing and rely solely on dental floss for cleaning",
        "Replace the damaged abutments and resume using metal-wire brushes more carefully",
      ],
      correct: "B"
    },
    {
      id: 23591,
      question: "A patient has a maxillary implant-retained overdenture with Locator attachments. She asks how to care for the prosthesis at home.\n\nWhat home care instructions are MOST appropriate for this patient?",
      options: [
        "The prosthesis should remain in place continuously and be cleaned with a soft brush",
        "Remove the prosthesis twice daily, clean with denture cleaner, and store in solution overnight",
        "The prosthesis only needs rinsing with water since implants don't accumulate plaque",
        "Clean the prosthesis weekly with household bleach to disinfect the attachment housings",
      ],
      correct: "B"
    },
    {
      id: 23592,
      question: "A patient with multiple implants asks if they can continue using their regular whitening toothpaste, which they prefer for stain removal on their natural teeth.\n\nWhat is the MOST appropriate recommendation regarding dentifrice for implants?",
      options: [
        "Whitening toothpastes are ideal for implants as they prevent discoloration of crowns",
        "Any toothpaste is acceptable since abutment materials are harder than natural enamel",
        "Low-abrasive toothpaste with ADA Seal of Acceptance should be used for implants",
        "Baking soda paste provides the best cleaning without damaging implant surfaces",
      ],
      correct: "C"
    },
    {
      id: 23593,
      question: "A patient with peri-implant mucositis was prescribed 0.12% chlorhexidine rinse 3 months ago. You notice resolution of inflammation but also dark staining on their natural teeth.\n\nWhat is the MOST appropriate recommendation regarding chlorhexidine use?",
      options: [
        "Continue daily chlorhexidine rinse indefinitely to prevent mucositis recurrence",
        "Discontinue chlorhexidine since it should only be used short-term as an adjunct",
        "Increase chlorhexidine concentration to 0.2% for better antimicrobial efficacy",
        "Switch to twice-weekly chlorhexidine use as long-term maintenance protocol",
      ],
      correct: "B"
    },
    {
      id: 23594,
      question: "A patient with an implant-supported fixed bridge has limited dexterity due to arthritis. They cannot manipulate traditional floss effectively.\n\nWhat is the MOST appropriate alternative recommendation for interdental cleaning?",
      options: [
        "Discontinue all interdental cleaning since they cannot perform traditional flossing",
        "Water flosser or air flosser can be used as an alternative for patients with dexterity limitations",
        "Schedule monthly professional cleanings instead of recommending any home interdental care",
        "Apply chlorhexidine gel with cotton swabs as the only home care method needed",
      ],
      correct: "B"
    },
    {
      id: 23595,
      question: "A patient with six healthy implants, good oral hygiene, and no history of periodontal disease asks how often they need professional maintenance.\n\nWhat is the MINIMUM recommended professional examination frequency?",
      options: [
        "Professional examination is needed every 3 months for all implant patients",
        "Professional examination is recommended every 4 months to prevent complications",
        "Professional examination should occur at least every 6 months as lifelong regimen",
        "Professional examination is only needed annually once implants are stable",
      ],
      correct: "C"
    },
    {
      id: 23596,
      question: "A patient with implants has poorly controlled diabetes, smokes, and has a history of chronic periodontitis. At today's 6-month visit, you detect peri-implant mucositis on two implants.\n\nWhat maintenance interval is MOST appropriate for this patient?",
      options: [
        "Continue 6-month intervals since this is the standard for all implant patients",
        "Shorten interval to 3-4 months due to risk factors and current inflammation",
        "Extend interval to 9 months since only mucositis is present, not peri-implantitis",
        "Refer immediately for surgical treatment before scheduling any future maintenance",
      ],
      correct: "B"
    },
    {
      id: 23597,
      question: "You are performing implant maintenance on a patient with healthy peri-implant tissues and visible biofilm. There is no calculus present on the implants.\n\nWhat is the MOST appropriate biofilm removal method for this patient?",
      options: [
        "Stainless steel curets should be used to ensure complete biofilm removal",
        "Rubber cup with pumice provides gentle yet effective biofilm removal",
        "Air polishing with glycine or erythritol powder safely removes biofilm",
        "Metal ultrasonic tip with reduced power setting adequately cleans implants",
      ],
      correct: "C"
    },
    {
      id: 23598,
      question: "A patient has an implant-supported fixed denture with limited access beneath the prosthesis. There is visible biofilm accumulation but no calculus.\n\nWhat is the MOST effective method to access and clean this area?",
      options: [
        "Traditional hand instrumentation with extended shank curets can reach under prosthesis",
        "Subgingival air polishing tip with glycine powder can access beneath the prosthesis",
        "Removal of the prosthesis is mandatory before any cleaning can be performed",
        "Oral irrigation with chlorhexidine is the only option when access is limited",
      ],
      correct: "B"
    },
    {
      id: 23599,
      question: "During maintenance, you detect moderate calculus deposits on the smooth collar of an implant abutment. The patient has healthy peri-implant tissues otherwise.\n\nWhat is the MOST appropriate instrument selection for calculus removal?",
      options: [
        "Stainless steel Gracey curets provide the best calculus removal on implants",
        "Titanium curets minimize surface alteration while effectively removing calculus",
        "Plastic curets are always the first choice regardless of calculus tenacity",
        "No instrumentation is needed; air polishing alone will remove the calculus",
      ],
      correct: "B"
    },
    {
      id: 23600,
      question: "A student hygienist asks if she can use the standard metal ultrasonic tip on implants if she uses very light pressure and low power.\n\nWhat is the MOST accurate response regarding metal ultrasonic tips on implants?",
      options: [
        "Metal ultrasonic tips are acceptable on implants if light pressure is used",
        "Metal ultrasonic tips cause severe surface alteration and are contraindicated",
        "Metal ultrasonic tips can be used only on the implant body, not the abutment",
        "Metal ultrasonic tips are preferred over hand instruments for implant scaling",
      ],
      correct: "B"
    },
    {
      id: 23601,
      question: "You are considering ultrasonic instrumentation for implant calculus removal. The office has plastic implant-specific ultrasonic tips available.\n\nWhat consideration is MOST important when deciding whether to use these tips?",
      options: [
        "Plastic tips cause no surface alteration and are always the best choice",
        "Plastic tips may reduce osteoblast viability and leave behind plastic debris",
        "Plastic tips are more effective than hand instruments for implant scaling",
        "Plastic tips can be used with the same power settings as metal tips",
      ],
      correct: "B"
    },
    {
      id: 23602,
      question: "A patient presents for their first maintenance visit after receiving implants at another office. You are planning the debridement procedure.\n\nWhich of the following instruments is absolutely CONTRAINDICATED for implant maintenance?",
      options: [
        "Graphite-filled resin curets with carefully applied moderate lateral pressure",
        "Titanium curets used with the same technique as on natural teeth",
        "Stainless steel scalers or standard metal ultrasonic and sonic tips",
        "Plastic curets when minimal deposits are present on the abutment",
      ],
      correct: "C"
    },
    {
      id: 23603,
      question: "A new hygienist is preparing to polish an implant crown using a rubber cup with standard prophy paste containing abrasive particles.\n\nWhat is the MOST important reason this technique is contraindicated?",
      options: [
        "Prophy paste with abrasive particles can scratch and damage the titanium abutment",
        "Rubber cups cannot adequately reach the critical areas around the implant collar",
        "The rotary motion of the rubber cup may unscrew the abutment from the implant",
        "Prophy paste residue cannot be completely rinsed and will cause inflammation",
      ],
      correct: "A"
    },
    {
      id: 23604,
      question: "During examination, you test for mobility on a single-tooth implant crown by applying pressure with mirror handles on either side. You detect movement.\n\nWhat does implant mobility MOST likely indicate?",
      options: [
        "Normal physiologic movement similar to natural teeth with periodontal ligament",
        "Either a loose/fractured abutment screw or complete loss of osseointegration",
        "Temporary mobility during tissue remodeling that will resolve in several months",
        "Early peri-implantitis that can be reversed with nonsurgical debridement",
      ],
      correct: "B"
    },
    {
      id: 23605,
      question: "A patient with implants reports occasional nighttime grinding. You notice wear facets on the implant crowns and slight mobility of one crown.\n\nWhat is the MOST appropriate recommendation?",
      options: [
        "Implants can withstand grinding forces, so no intervention is needed",
        "Extract and replace the mobile crown with a new implant and restoration",
        "Evaluate for occlusal interference and consider occlusal guard for force protection",
        "Recommend soft diet to reduce functional forces on the implant restorations",
      ],
      correct: "C"
    },
    {
      id: 23606,
      question: "A routine radiograph reveals a radiolucency at the apex of an osseointegrated implant. The implant has no mobility. The patient reports no symptoms. Adjacent to the implant is an endodontically treated tooth.\n\nWhat is the MOST likely source of this radiolucency?",
      options: [
        "The implant is failing and will require removal once mobility develops",
        "This represents early peri-implantitis starting at the apex of the implant",
        "A residual cyst from the adjacent endodontically treated tooth is present",
        "Normal bone remodeling creates this appearance in the first year after placement",
      ],
      correct: "C"
    },
    {
      id: 23607,
      question: "A patient presents with peri-implant mucositis: 4mm probing depths, bleeding on probing, visible plaque, and no radiographic bone loss. The patient demonstrates poor oral hygiene.\n\nWhat is the MOST appropriate treatment plan?",
      options: [
        "Immediate referral to periodontist for surgical intervention to prevent progression",
        "Thorough biofilm removal, oral hygiene instruction, and shortened maintenance interval",
        "Prescribe systemic antibiotics and schedule surgical treatment in 3 months",
        "No treatment is necessary since mucositis is not reversible without surgery",
      ],
      correct: "B"
    },
    {
      id: 23608,
      question: "A patient has peri-implantitis with 7mm probing depths, bleeding, and 3mm bone loss. After nonsurgical mechanical debridement and improved oral hygiene over 6 months, bone loss has progressed.\n\nWhat is the MOST appropriate next step?",
      options: [
        "Continue nonsurgical treatment for another 6 months before considering surgery",
        "Refer for surgical evaluation since nonsurgical treatment has not arrested bone loss",
        "Extract the implant immediately as peri-implantitis cannot be successfully treated",
        "Increase maintenance frequency to monthly visits and prescribe continuous chlorhexidine",
      ],
      correct: "B"
    },
    {
      id: 23609,
      question: "A patient with peri-implantitis is being considered for surgical therapy. They continue smoking one pack per day, have poor oral hygiene, and untreated periodontitis on natural teeth.\n\nWhat should be addressed BEFORE surgical therapy?",
      options: [
        "Proceed directly to implant surgery since delay will worsen the bone loss",
        "Control local and systemic factors: oral hygiene, smoking, and periodontitis treatment",
        "Extract all remaining natural teeth to focus solely on implant treatment",
        "Place the patient on prophylactic antibiotics indefinitely before any surgery",
      ],
      correct: "B"
    },
    {
      id: 23610,
      question: "A patient asks about the success rate of surgical treatment for their peri-implantitis. You review current evidence regarding treatment outcomes.\n\nWhat is the MOST accurate statement about peri-implantitis treatment prognosis?",
      options: [
        "Surgical treatment has 100% success rate with no risk of recurrence",
        "Peri-implantitis is a chronic disease and retreatment may be necessary over time",
        "Once surgically treated, peri-implantitis never recurs if oral hygiene is good",
        "Success rates are so low that extraction is preferable to surgical treatment",
      ],
      correct: "B"
    },
    {
      id: 23611,
      question: "During a maintenance visit, you are evaluating a three-unit implant bridge supported by two implants. The radiograph shows well-maintained bone levels.\n\nWhat components must be assessed during this examination?",
      options: [
        "Only the implants themselves since the prosthesis is permanently cemented",
        "Only the abutments since they are the only components that can fail",
        "The prosthesis, abutments, and implant fixtures for both biologic and mechanical complications",
        "Only the soft tissues since radiographic assessment eliminates need for other evaluation",
      ],
      correct: "C"
    },
    {
      id: 23612,
      question: "You are reviewing radiographs of an implant placed 1 year ago. You notice a radiopaque material in the peri-implant sulcus. The patient has localized inflammation around this implant.\n\nWhat type of cement was MOST likely used if it is visible on the radiograph?",
      options: [
        "Resin cement which is typically radiolucent and difficult to detect",
        "Zinc-containing cement (Temp-bond, ZOE, zinc phosphate) which is radiopaque",
        "Glass ionomer cement which has the same radiodensity as tooth structure",
        "No cement was used; this represents calculus deposits forming on the abutment",
      ],
      correct: "B"
    },
    {
      id: 23613,
      question: "You are performing maintenance on a patient with a maxillary implant-supported fixed denture. The patient demonstrates excellent oral hygiene and can clean all accessible surfaces. Probing and radiographs show healthy stable implants.\n\nWhen should this prosthesis be removed during maintenance visits?",
      options: [
        "The prosthesis must be removed at every visit to ensure complete cleaning",
        "The prosthesis should be removed quarterly to inspect for hidden cement",
        "The restorative dentist decides if removal is needed based on patient's hygiene ability",
        "The prosthesis should never be removed once permanently cemented in place",
      ],
      correct: "C"
    },
    {
      id: 23614,
      question: "A patient with an implant-supported fixed denture has recurring inflammation despite good effort at oral hygiene. You observe the prosthesis has a concave tissue surface with a ridge-lap design.\n\nWhat is the PRIMARY problem with this prosthesis design?",
      options: [
        "The aesthetic appearance is compromised by the ridge-lap configuration",
        "The patient cannot access the concave tissue surface for adequate cleaning",
        "The prosthesis is too heavy and places excessive force on the implants",
        "The material selection is inappropriate for a fixed implant prosthesis",
      ],
      correct: "B"
    },
    {
      id: 23615,
      question: "A patient with a mandibular implant overdenture reports the denture has become loose over the past month. Examination reveals worn Locator caps.\n\nWhat is the MOST appropriate intervention?",
      options: [
        "This indicates implant failure; refer immediately for implant removal",
        "Replace the worn Locator caps to restore retention of the overdenture",
        "Add soft liner to the denture to improve fit without replacing attachments",
        "Inform patient this is normal and no treatment is available or necessary",
      ],
      correct: "B"
    },
    {
      id: 23616,
      question: "During examination of a three-unit implant bridge, you notice a small chip in the porcelain on the pontic. The implants are healthy with no inflammation.\n\nWhat is the MOST appropriate action for this mechanical complication?",
      options: [
        "No action needed since the chip doesn't affect the implants themselves",
        "Immediate extraction of implants and fabrication of new bridge required",
        "Document the fracture and refer to restorative dentist for porcelain repair",
        "Smooth the rough edge with a diamond bur and continue routine maintenance",
      ],
      correct: "C"
    },
    {
      id: 23617,
      question: "You are treating a patient with peri-implantitis. A colleague suggests decontaminating the implant surface with chlorhexidine during debridement.\n\nWhat is an important consideration when using chlorhexidine on diseased implants?",
      options: [
        "Chlorhexidine is the most effective agent and should be used liberally on implants",
        "Chlorhexidine may adsorb to titanium and prevent bone cell reattachment",
        "Chlorhexidine has no antimicrobial effect on implant surfaces unlike on teeth",
        "Chlorhexidine should be applied full-strength directly to the implant body",
      ],
      correct: "B"
    },
    {
      id: 23618,
      question: "You are discussing maintenance frequency with a patient who wants to minimize their visits. They ask if there is evidence supporting regular professional care.\n\nWhat does research show about maintenance frequency and implant outcomes?",
      options: [
        "Maintenance frequency has no impact on implant survival rates over time",
        "Irregular maintenance increases failure by 60% and no maintenance increases failure by 90%",
        "Monthly maintenance is required for all patients to prevent any complications",
        "Maintenance is only needed if the patient reports problems or discomfort",
      ],
      correct: "B"
    },
    {
      id: 23619,
      question: "During presurgical evaluation, you detect active periodontal disease with 6-7mm pockets, bleeding, and suppuration on the patient's remaining natural teeth.\n\nWhat is the MOST appropriate recommendation before implant surgery?",
      options: [
        "Proceed with implant surgery since periodontal disease only affects natural teeth",
        "Active periodontal disease should be treated and controlled before implant placement",
        "Extract all remaining teeth simultaneously with implant placement to save time",
        "Place implants immediately before more teeth are lost to periodontal disease",
      ],
      correct: "B"
    },
    {
      id: 23620,
      question: "A patient who smokes 25 cigarettes daily is interested in dental implants. Current evidence shows smoking >20 cigarettes/day is a contraindication.\n\nWhat is the MOST appropriate initial approach?",
      options: [
        "Refuse implant treatment permanently due to smoking history and high risk",
        "Proceed with implant placement using shorter implants to account for poor healing",
        "Provide smoking cessation counseling and delay treatment until smoking is reduced or stopped",
        "Place the implants immediately before the patient loses more teeth to smoking effects",
      ],
      correct: "C"
    },
    {
      id: 23621,
      question: "A patient had implant surgery 3 days ago. They call asking about oral hygiene instructions for the surgical site.\n\nWhat is the MOST appropriate postsurgical wound care recommendation?",
      options: [
        "Vigorous brushing of surgical site immediately to prevent infection",
        "Use chlorhexidine as prescribed and ultrasoft toothbrush after 1 week",
        "Apply hydrogen peroxide directly to the surgical site three times daily",
        "Rinse vigorously with hot salt water to promote faster healing",
      ],
      correct: "B"
    },
    {
      id: 23622,
      question: "A patient had implants placed 4 months ago. The implants were buried beneath the mucosa. They ask when they can get their crowns.\n\nWhat is the next step before crown fabrication can begin?",
      options: [
        "Crowns can be fabricated immediately since 4 months is adequate healing",
        "Second-stage surgery to uncover implants and place healing abutments is needed",
        "Wait an additional 4-6 months for the implants to become completely stable",
        "Immediate loading with temporary crowns should have been done at placement",
      ],
      correct: "B"
    },
    {
      id: 23623,
      question: "During maintenance, you are trying to determine the abutment material. Through thin tissue, you observe a dark gray appearance showing through the mucosa.\n\nWhat abutment material is MOST likely present?",
      options: [
        "Zirconia abutment which is white ceramic and would not appear dark",
        "Gold-alloy abutment which is highly radiopaque and appears golden",
        "Titanium abutment which is less radiopaque and appears dark through thin tissue",
        "Temporary healing abutment which should have been replaced with final abutment",
      ],
      correct: "C"
    },
    {
      id: 23624,
      question: "A completely edentulous patient wants to know the difference between a removable implant-retained overdenture and a fixed implant prosthesis.\n\nWhat is a key ADVANTAGE of a removable prosthesis over a fixed prosthesis?",
      options: [
        "Removable prostheses never need replacement of retentive elements",
        "Removable prostheses allow patient removal for easier cleaning and tissue access",
        "Removable prostheses provide better aesthetics than fixed prostheses in all cases",
        "Removable prostheses eliminate the need for daily oral hygiene by the patient",
      ],
      correct: "B"
    },
    {
      id: 23625,
      question: "A patient has a mandibular implant-supported overdenture retained by a Dolder bar attachment. During examination, you assess both the bar and the denture.\n\nWhat type of prosthesis support does this represent?",
      options: [
        "Tissue-supported prosthesis that is only retained by the implants",
        "Implant-supported prosthesis with all forces borne by the implants and bar",
        "Hybrid prosthesis with partial support from implants and partial from tissue",
        "Fixed prosthesis that cannot be removed by the patient for cleaning",
      ],
      correct: "B"
    },
    {
      id: 23626,
      question: "A patient asks why the dentist is using computer software and a CBCT scan for implant planning instead of just using regular x-rays.\n\nWhat is the PRIMARY benefit of three-dimensional virtual implant planning?",
      options: [
        "Virtual planning is required by insurance companies for implant coverage",
        "Virtual planning allows visualization of anatomy, bone volume, and planned implant position",
        "Virtual planning eliminates the need for any surgical guide during implant placement",
        "Virtual planning reduces the total cost of implant treatment for the patient",
      ],
      correct: "B"
    },
    {
      id: 23627,
      question: "During implant surgery, the surgeon uses a custom-fabricated surgical guide that fits over the patient's teeth and edentulous ridge.\n\nWhat is the PRIMARY purpose of using a surgical guide?",
      options: [
        "To prevent any surgical complications from occurring during the procedure",
        "To transfer planned implant position and angulation for precise placement",
        "To reduce the surgery time by eliminating the need for local anesthesia",
        "To eliminate the need for any presurgical diagnostic workup or planning",
      ],
      correct: "B"
    },
    {
      id: 23628,
      question: "A radiograph shows a gap between the implant platform and the base of the implant crown. The patient has localized inflammation around this implant.\n\nWhat is the MOST likely cause of the inflammation?",
      options: [
        "Normal tissue response to the type of metal used in the implant body",
        "Inadequate seating of the restoration allowing bacterial colonization of the gap",
        "Excessive force applied during crown placement damaging the bone",
        "Allergic reaction to the cement used to retain the implant crown",
      ],
      correct: "B"
    },
    {
      id: 23629,
      question: "You are reviewing literature on implant-abutment connections. Studies show that microgap location is associated with crestal bone loss patterns.\n\nWhat does platform-switching design aim to accomplish?",
      options: [
        "Increase the size of the microgap to allow better tissue adaptation",
        "Move the microgap toward the center of the implant to minimize bone loss",
        "Eliminate the microgap completely through precision-fit components",
        "Place the microgap at the outer edge of the implant for easier cleaning",
      ],
      correct: "B"
    },
    {
      id: 23630,
      question: "A restorative dentist asks for your input on cement selection for an implant crown in an area with thin tissue and difficult access for excess cement removal.\n\nWhat cement characteristic is MOST important for this situation?",
      options: [
        "Maximum bond strength to prevent any crown loosening over time",
        "Tooth-colored appearance to match the aesthetic shade of natural teeth",
        "Radiopacity and ease of removal (such as zinc-containing cements)",
        "Permanent bonding that never dissolves regardless of oral environment",
      ],
      correct: "C"
    },
    {
      id: 23631,
      question: "A patient asks why the dentist recommended a screw-retained crown rather than a cement-retained crown for their implant.\n\nWhat is the PRIMARY advantage of screw-retained crowns?",
      options: [
        "Screw-retained crowns are less expensive to fabricate than cement-retained crowns",
        "Screw-retained crowns eliminate cement that could contribute to peri-implant inflammation",
        "Screw-retained crowns provide better aesthetics in the anterior region of the mouth",
        "Screw-retained crowns are the only option for all posterior implant restorations",
      ],
      correct: "B"
    },
    {
      id: 23632,
      question: "A patient has a maxillary fixed implant-supported prosthesis. You notice there is no space between the prosthesis and the edentulous ridge, making it impossible to use floss or interdental devices.\n\nWhat is the MOST significant problem with this prosthesis design?",
      options: [
        "The prosthesis will fracture more easily without space beneath it",
        "The prosthesis prevents adequate access for patient oral hygiene",
        "The prosthesis provides inadequate lip support for facial aesthetics",
        "The prosthesis places excessive force on the supporting implants",
      ],
      correct: "B"
    },
    {
      id: 23633,
      question: "A patient with multiple individual implant crowns has difficulty cleaning around the implants with a standard toothbrush. You recommend a specialized brush.\n\nWhat type of brush would be MOST beneficial for this patient?",
      options: [
        "Hard-bristled brush to ensure adequate plaque removal from titanium",
        "End-tuft or single-tuft brush to focus on one implant at a time",
        "Extra-large brush head to clean multiple implants simultaneously",
        "Battery-powered brush which eliminates need for manual dexterity",
      ],
      correct: "B"
    },
    {
      id: 23634,
      question: "You are demonstrating proper flossing technique for a patient with two adjacent single-tooth implant crowns. The embrasure space is adequate for floss passage.\n\nWhat is the correct flossing technique for implant abutments?",
      options: [
        "Snap the floss firmly through the contact to ensure it reaches below the tissue",
        "Place floss around the abutment, crisscross it, and use shoe-shining motion",
        "Avoid flossing implants completely as floss will damage the titanium surface",
        "Use floss only on natural teeth and rely on rinsing for implant cleaning",
      ],
      correct: "B"
    },
    {
      id: 23635,
      question: "A patient with a maxillary fixed implant-supported denture asks about home care. The prosthesis has adequate space for a floss threader to pass beneath.\n\nWhat daily home care should be recommended?",
      options: [
        "Remove the prosthesis nightly and soak in denture cleaner solution",
        "Use floss threaders to clean beneath the prosthesis and around implants daily",
        "Professional cleaning is sufficient; no home care is needed for fixed prostheses",
        "Rinse with water only as brushing might loosen the prosthesis from implants",
      ],
      correct: "B"
    },
    {
      id: 23636,
      question: "A patient asks what material their implant crown is made from. You explain that crown materials are similar to those used for natural teeth.\n\nWhich materials are commonly used for implant crown fabrication?",
      options: [
        "Crown materials include only acrylic resin and composite restorations",
        "Crown materials are similar to tooth-borne crowns: metal-ceramic, zirconia, or all-ceramic",
        "Crown materials must be made of titanium to match the implant fixture",
        "Crown materials are limited to gold due to biocompatibility requirements",
      ],
      correct: "B"
    },
    {
      id: 23637,
      question: "You are preparing to probe an implant for the first time. You have not yet reviewed the radiograph to determine the implant diameter.\n\nWhy is it important to review radiographs BEFORE probing implants?",
      options: [
        "Radiographs show if the implant has failed and should not be probed",
        "Implant diameter varies and prosthesis size doesn't indicate implant width",
        "Radiographs determine whether plastic or metal probes should be used",
        "Probing is only necessary if radiographs show bone loss present",
      ],
      correct: "B"
    },
    {
      id: 23638,
      question: "A patient received their final implant crown 4 weeks ago. The office scheduler asks when they should return for their first maintenance visit.\n\nWhat is the MOST appropriate maintenance timing for initial visits?",
      options: [
        "First maintenance visit should be scheduled 6 months after crown placement",
        "First maintenance visit should be within 3 months to establish baseline and monitor healing",
        "First maintenance visit is not needed until the patient reports problems",
        "First maintenance visit should wait 1 year to allow complete tissue maturation",
      ],
      correct: "B"
    },
    {
      id: 23639,
      question: "A patient asks why their implants need more frequent maintenance than their natural teeth did before extraction.\n\nWhich statement MOST accurately explains the difference?",
      options: [
        "Implants have better blood supply than natural teeth from the surrounding bone",
        "Implants lack periodontal ligament attachment and have reduced blood supply",
        "Implants have exactly the same biological attachment as natural teeth",
        "Implants are stronger than natural teeth and resist bacterial infection better",
      ],
      correct: "B"
    },
    {
      id: 23640,
      question: "You are explaining to a student why certain instruments are contraindicated for use on titanium implants. You discuss the titanium oxide layer.\n\nWhat is the significance of the titanium dioxide surface layer?",
      options: [
        "The titanium dioxide layer makes implants completely immune to bacterial colonization",
        "The titanium dioxide layer provides biocompatibility and protects against corrosion",
        "The titanium dioxide layer must be removed annually to prevent implant failure",
        "The titanium dioxide layer prevents osseointegration and must be roughened",
      ],
      correct: "B"
    },
    {
      id: 23641,
      question: "A hygienist asks why scratching the titanium surface during instrumentation is problematic even if calculus is completely removed.\n\nWhat are the consequences of titanium surface alteration?",
      options: [
        "Surface scratching has no effect since titanium is harder than stainless steel",
        "Surface scratching creates areas retentive to biofilm and may disrupt the oxide layer",
        "Surface scratching improves the texture for better mechanical plaque removal",
        "Surface scratching prevents corrosion by exposing fresh titanium to oxygen",
      ],
      correct: "B"
    },
    {
      id: 23642,
      question: "A patient with peri-implant mucositis asks what causes inflammation around implants.\n\nWhat is the PRIMARY etiologic factor in peri-implant disease?",
      options: [
        "Occlusal trauma from excessive biting forces on the implant crown",
        "Bacterial biofilm accumulation similar to periodontitis pathogenesis",
        "Allergic reaction to the titanium metal of the implant fixture",
        "Normal aging process that occurs in all implants after 5 years",
      ],
      correct: "B"
    },
    {
      id: 23643,
      question: "A patient diagnosed with peri-implant mucositis is concerned about prognosis. You explain the difference between mucositis and peri-implantitis regarding reversibility.\n\nWhat statement is MOST accurate about reversibility?",
      options: [
        "Both mucositis and peri-implantitis are equally reversible with nonsurgical treatment",
        "Mucositis is reversible while peri-implantitis is more difficult to reverse",
        "Neither mucositis nor peri-implantitis can be reversed once diagnosed",
        "Peri-implantitis is easily reversed but mucositis requires surgical treatment",
      ],
      correct: "B"
    },
    {
      id: 23644,
      question: "A patient asks why their implant probing depths are 4-5mm when healthy teeth should have 1-3mm pockets.\n\nWhat is the MOST accurate explanation for deeper probing depths around implants?",
      options: [
        "All probing depths greater than 3mm around implants indicate disease",
        "Probing depths can be greater than 3mm initially due to implant placement depth",
        "Deeper probing around implants always indicates the implant is failing",
        "Probing depths around implants should never exceed 2mm in health",
      ],
      correct: "B"
    },
    {
      id: 23645,
      question: "A patient with history of peri-implantitis and smoking asks why annual radiographs are recommended when they feel fine.\n\nWhat is the PRIMARY justification for annual radiographs in high-risk patients?",
      options: [
        "To generate additional revenue for the dental practice through imaging fees",
        "To detect bone loss that may progress without symptoms before clinical detection",
        "To satisfy state dental board requirements for implant documentation",
        "To compare implant position changes since implants gradually migrate over time",
      ],
      correct: "B"
    }
  ],

  "2. Restorative Dental Care (Case Study)": [
    {
      id: 23646,
      question: "A dental hygienist recently moved from Washington to California and wants to provide restorative services. She completed her dental hygiene education in Washington, which includes restorative training as part of initial licensure requirements.\n\nWhat is the MOST appropriate action for this hygienist to take?",
      options: [
        "Begin providing restorative services immediately since she has prior training and experience",
        "Consult California's licensing agency to determine requirements for restorative function endorsement",
        "Only provide restorative services under direct supervision without additional credentials required",
        "Wait one year to establish residency before applying for restorative privileges",
      ],
      correct: "B"
    },
    {
      id: 23647,
      question: "A dental office is considering hiring an expanded functions dental auxiliary (EFDA) to help with the increased demand for restorative services in their underserved community.\n\nWhat is the PRIMARY purpose of creating midlevel provider roles like EFDAs?",
      options: [
        "To reduce costs by replacing dentists with less educated personnel",
        "To improve access to dental care for underserved populations",
        "To provide dentists with more time for complex surgical procedures",
        "To eliminate the need for dental hygienists in restorative procedures",
      ],
      correct: "B"
    },
    {
      id: 23648,
      question: "During a maintenance appointment, you notice a 15-year-old amalgam restoration on tooth #30 with visible marginal breakdown and wear at the contact area with tooth #31.\n\nWhat is the MOST likely cause of this breakdown?",
      options: [
        "Patient allergic reaction to mercury causing tissue inflammation around restoration",
        "Expansion over time combined with masticatory forces and tooth-to-tooth contact",
        "Inadequate oral hygiene leading to bacterial invasion of the amalgam",
        "Chemical reaction between amalgam and acidic foods in the diet",
      ],
      correct: "B"
    },
    {
      id: 23649,
      question: "A patient presents with a 6-month-old composite restoration on tooth #4-MO that has an open proximal contact and overhang at the gingival margin. The patient reports frequent food impaction.\n\nWhat is the PRIMARY cause of these defects?",
      options: [
        "Natural degradation of composite material due to oral cavity conditions",
        "Patient's inadequate oral hygiene causing restoration breakdown over time",
        "Improper placement technique and poor attention to detail during restoration",
        "Incompatibility between the bonding agent and composite material used",
      ],
      correct: "C"
    },
    {
      id: 23650,
      question: "A 28-year-old patient presents with intrinsic tetracycline staining on teeth #7-10. The patient desires an esthetic improvement and asks about treatment options.\n\nWhich restorative approach would be MOST appropriate for this situation?",
      options: [
        "Amalgam restorations are ideal due to their strength and longevity",
        "No treatment is needed since tetracycline staining is only cosmetic",
        "Composite, porcelain, or ceramic restorations can improve appearance",
        "Extraction and replacement with dentures provides the best esthetics",
      ],
      correct: "C"
    },
    {
      id: 23651,
      question: "A patient has several teeth that are misaligned due to loss of opposing molars. The patient reports difficulty chewing and wants to improve function.\n\nWhat is the PRIMARY goal of restorative treatment in this case?",
      options: [
        "Realign occlusal forces to be more parallel to the long axis of teeth",
        "Replace all missing teeth with implants regardless of occlusal relationship",
        "Extract misaligned teeth to create a more symmetric dental arch",
        "Wait for natural tooth movement to correct the occlusal discrepancies",
      ],
      correct: "A"
    },
    {
      id: 23652,
      question: "A patient with high caries risk is scheduled for multiple restorations. You are developing a comprehensive care plan that includes both restorative and preventive strategies.\n\nWhich preventive therapies should be integrated with restorative treatment?",
      options: [
        "Fluoride application and dietary counseling as the only preventive measures needed",
        "Sealants only, as other preventive measures interfere with restorative bonding",
        "Fluoride, silver diamine fluoride, sealants, xylitol products, and salivary aids",
        "No preventive therapies are needed once restorations are completed",
      ],
      correct: "C"
    },
    {
      id: 23653,
      question: "During the assessment phase, you identify multiple areas of tooth damage and early carious lesions in a patient who demonstrates poor oral hygiene habits.\n\nWhat is the dental hygienist's PRIMARY collaborative role at this stage?",
      options: [
        "Diagnose the dental caries and develop the complete restorative treatment plan",
        "Communicate findings to the dentist and plan disease prevention strategies",
        "Immediately schedule the patient for restorative procedures without consultation",
        "Refuse to treat the patient until oral hygiene improves significantly",
      ],
      correct: "B"
    },
    {
      id: 23654,
      question: "A dentist is explaining treatment options to a patient who needs restoration of tooth #3 with extensive decay involving the mesial-occlusal surfaces.\n\nWhat is the PRIMARY difference between direct and indirect restorations?",
      options: [
        "Direct restorations are placed and formed in the mouth; indirect are fabricated outside",
        "Direct restorations last longer than indirect restorations in all situations",
        "Indirect restorations are always less expensive than direct restorations",
        "Direct restorations require more appointments than indirect restorations",
      ],
      correct: "A"
    },
    {
      id: 23655,
      question: "A patient asks why the dentist recommended amalgam for a large restoration on tooth #18 instead of composite material.\n\nWhat is a PRIMARY advantage of amalgam for this situation?",
      options: [
        "Amalgam provides better esthetics and color matching than composite",
        "Amalgam has proven longevity, ease of placement, and lower cost",
        "Amalgam bonds chemically to tooth structure better than composite",
        "Amalgam requires less tooth structure removal than composite restorations",
      ],
      correct: "B"
    },
    {
      id: 23656,
      question: "A patient received a large Class II composite restoration 2 years ago and now presents with recurrent decay at the margins.\n\nWhat is a common disadvantage of composite restorations that may have contributed to this?",
      options: [
        "Composite has the longest longevity of all restorative materials available",
        "Composite is not affected by moisture contamination during placement",
        "Composite has higher rates of recurrent decay and is technique sensitive",
        "Composite costs less than amalgam and requires minimal placement time",
      ],
      correct: "C"
    },
    {
      id: 23657,
      question: "A patient wants to know which restorative material has the best track record for longevity based on decades of clinical use.\n\nWhich statement is MOST accurate regarding material longevity?",
      options: [
        "Composite restorations have proven to last longer than amalgam restorations",
        "Glass ionomer restorations are the most durable for all types of cavities",
        "Amalgam remains the longest-lasting restorative material in dentistry",
        "Gold restorations fail more quickly than all other restorative materials",
      ],
      correct: "C"
    },
    {
      id: 23658,
      question: "A dentist is preparing a tooth for an amalgam restoration and follows systematic steps based on GV Black's principles.\n\nWhat is the correct sequence of cavity preparation steps?",
      options: [
        "Remove caries, obtain convenience form, establish outline form, finish enamel",
        "Establish outline form, obtain retention, obtain convenience, remove caries",
        "Finish enamel first, then remove caries, establish outline, obtain retention",
        "Obtain convenience form, finish enamel, remove caries, establish outline form",
      ],
      correct: "B"
    },
    {
      id: 23659,
      question: "A dentist is preparing teeth for composite restorations and explains that the preparation differs from traditional GV Black preparations.\n\nWhat is the PRIMARY reason for modified preparations for composites?",
      options: [
        "Composites require more tooth structure removal than amalgam restorations",
        "Bonding agents eliminate need for retentive undercuts and mechanical retention",
        "Composites cannot bond to enamel surfaces and require dentin exposure",
        "All principles of GV Black preparations apply equally to composite restorations",
      ],
      correct: "B"
    },
    {
      id: 23660,
      question: "A patient asks why a dental dam is necessary for a composite restoration when it wasn't used for previous amalgam restorations.\n\nWhat is the PRIMARY reason for isolation during composite placement?",
      options: [
        "Composite materials are negatively affected by moisture, saliva, and blood",
        "Dental dams are only used for infection control and operator protection",
        "Isolation is optional for composite restorations based on patient preference",
        "Amalgam requires more stringent isolation than composite restorations",
      ],
      correct: "A"
    },
    {
      id: 23661,
      question: "You are educating a dental assistant about the multiple benefits of dental dam isolation for restorative procedures.\n\nWhich benefit is MOST related to patient and operator safety?",
      options: [
        "Dental dams provide color contrast that reduces glare from oral tissues",
        "Dental dams retract gingival tissue for better access and visibility",
        "Dental dams prevent aspiration of debris and protect from contaminated aerosols",
        "Dental dams make restorative procedures faster by eliminating moisture control steps",
      ],
      correct: "C"
    },
    {
      id: 23662,
      question: "A patient has severe claustrophobia and cannot tolerate a dental dam. The dentist needs to place a composite restoration.\n\nWhat is the MOST appropriate alternative isolation method?",
      options: [
        "Proceed without any isolation since the patient refuses dental dam placement",
        "Use alternative isolation systems like Isolite or OptraDam for moisture control",
        "Cancel the appointment and refuse treatment until patient accepts dental dam",
        "Place amalgam instead since it does not require any moisture control",
      ],
      correct: "B"
    },
    {
      id: 23663,
      question: "You are assessing a patient before placing a dental dam for a restorative procedure.\n\nWhich condition is a contraindication for dental dam placement?",
      options: [
        "Patient with well-controlled diabetes and good oral hygiene practices",
        "Patient with severe asthma experiencing acute respiratory congestion",
        "Patient who had a dental dam placed successfully at previous appointment",
        "Patient with multiple restorations needing treatment in the same quadrant",
      ],
      correct: "B"
    },
    {
      id: 23664,
      question: "A student hygienist asks about the purpose of matrix systems in restorative dentistry.\n\nWhat is the PRIMARY function of a matrix system?",
      options: [
        "To provide occlusal anatomy and pit and fissure patterns for restorations",
        "To reproduce the proximal wall removed during cavity preparation",
        "To protect adjacent teeth from damage during cavity preparation",
        "To provide a guide for selecting the appropriate shade of composite",
      ],
      correct: "B"
    },
    {
      id: 23665,
      question: "You are placing a matrix system for a Class II restoration and need to select and position wedges appropriately.\n\nWhat is the PRIMARY purpose of interproximal wedges?",
      options: [
        "Wedges provide the only method for achieving proper occlusal contacts",
        "Wedges separate teeth, aid in proximal contour and contact, and prevent overhangs",
        "Wedges are optional accessories that do not affect restoration quality",
        "Wedges damage interdental papilla and should be avoided whenever possible",
      ],
      correct: "B"
    },
    {
      id: 23666,
      question: "A patient needs a Class II amalgam restoration on tooth #19-MO. You are preparing to place a Tofflemire matrix system.\n\nWhat is the correct position for the convergent (smaller) opening of the matrix loop?",
      options: [
        "The convergent opening should be positioned toward the occlusal surface",
        "The convergent opening should be positioned toward the gingiva",
        "The convergent opening should be positioned toward the facial surface",
        "The convergent opening should be positioned toward the lingual surface",
      ],
      correct: "B"
    },
    {
      id: 23667,
      question: "A dentist is placing a Class II composite restoration and selects a sectional matrix system with a pressure ring.\n\nWhat is the PRIMARY advantage of this system for composite restorations?",
      options: [
        "Sectional matrices are made of metal which provides better strength than other materials",
        "Sectional matrices can only be used for amalgam restorations in posterior teeth",
        "Sectional matrices with pressure rings achieve better proximal contacts and contours",
        "Sectional matrices eliminate the need for any wedges in the interproximal space",
      ],
      correct: "C"
    },
    {
      id: 23668,
      question: "You need to place a matrix for a Class II restoration on tooth #14-MOD with a deep gingival preparation extending 2mm subgingivally.\n\nWhich matrix band would be MOST appropriate for this situation?",
      options: [
        "Standard matrix band that extends 1-2mm beyond adjacent marginal ridge",
        "Extension matrix band designed specifically for deep gingival preparations",
        "Any matrix band is acceptable since depth does not affect band selection",
        "No matrix band is needed for MOD restorations regardless of depth",
      ],
      correct: "B"
    },
    {
      id: 23669,
      question: "You are placing wedges for a Class II restoration. The tooth has narrow embrasures lingually and wide embrasures facially.\n\nFrom which direction should the wedge typically be placed?",
      options: [
        "Always from the facial embrasure regardless of size differences",
        "From the largest embrasure, typically the lingual, for complete adaptation",
        "Wedge direction does not matter as long as it fills the embrasure",
        "Wedges should be placed from both facial and lingual simultaneously",
      ],
      correct: "B"
    },
    {
      id: 23670,
      question: "A patient has a very deep cavity preparation approaching the pulp. The dentist wants to place a base material before the restoration.\n\nWhat is the PRIMARY purpose of base materials in deep preparations?",
      options: [
        "Bases provide color matching to make restorations more esthetic",
        "Bases provide pulp protection, thermal insulation, and support for restorations",
        "Bases are only used to increase the cost of restorative procedures",
        "Bases weaken restorations and should be avoided in all situations",
      ],
      correct: "B"
    },
    {
      id: 23671,
      question: "A dentist selects glass ionomer as a base material instead of zinc phosphate cement.\n\nWhat is a PRIMARY advantage of glass ionomer over zinc phosphate?",
      options: [
        "Glass ionomer is more acidic and provides better pulpal stimulation",
        "Glass ionomer releases fluoride, bonds to dentin, and is less acidic",
        "Glass ionomer has unlimited working time allowing for delayed placement",
        "Glass ionomer cannot be used as a base material for any restorations",
      ],
      correct: "B"
    },
    {
      id: 23672,
      question: "You are assisting with a restorative procedure and the dentist requests a cavity liner.\n\nWhat is the PRIMARY purpose of cavity liners?",
      options: [
        "Liners are thick materials placed to replace missing tooth structure in preparations",
        "Liners seal dentinal tubules and protect pulp from chemical irritation",
        "Liners are used only for esthetic purposes to match restoration color",
        "Liners increase microleakage and sensitivity after restoration placement",
      ],
      correct: "B"
    },
    {
      id: 23673,
      question: "A patient asks why the dentist applies multiple liquid materials before placing composite.\n\nWhat is the PRIMARY purpose of dentin bonding agents?",
      options: [
        "Bonding agents provide color matching between tooth and restoration",
        "Bonding agents create a hybrid layer that bonds restoration to tooth structure",
        "Bonding agents are optional and do not affect restoration longevity",
        "Bonding agents work best when applied to dry dentin surfaces only",
      ],
      correct: "B"
    },
    {
      id: 23674,
      question: "After cavity preparation, a microscopic layer of debris called the smear layer remains on tooth surfaces.\n\nHow is the smear layer typically managed before composite placement?",
      options: [
        "The smear layer should be left in place to protect the underlying dentin",
        "The smear layer is removed with acid etch before applying bonding agents",
        "The smear layer only forms on enamel and does not affect dentin bonding",
        "The smear layer enhances bonding and should be preserved whenever possible",
      ],
      correct: "B"
    },
    {
      id: 23675,
      question: "A patient expresses concern about the mercury content in amalgam restorations.\n\nWhat percentage of amalgam mixture is mercury?",
      options: [
        "Mercury makes up approximately 25% of the amalgam mixture",
        "Mercury makes up approximately 50% of the amalgam mixture",
        "Mercury makes up approximately 75% of the amalgam mixture",
        "Mercury makes up approximately 90% of the amalgam mixture",
      ],
      correct: "B"
    },
    {
      id: 23676,
      question: "A dental office is ordering amalgam capsules and sees options for spherical, lathe-cut, or admixed particle shapes.\n\nWhat is the PRIMARY benefit of spherical particle amalgam?",
      options: [
        "Spherical particles require more mercury for proper wetting and mixture",
        "Spherical particles decrease the mercury needed and provide adequate strength",
        "Spherical particles are outdated and no longer used in modern dentistry",
        "Spherical particles can only be used for anterior restorations",
      ],
      correct: "B"
    },
    {
      id: 23677,
      question: "You are preparing to triturate an amalgam capsule before placement.\n\nWhat is the purpose of trituration?",
      options: [
        "Trituration separates mercury from alloy particles for safer handling",
        "Trituration mixes amalgam to wet alloy particles causing metallurgic changes",
        "Trituration removes excess mercury to reduce the mercury content",
        "Trituration is an optional step that does not affect amalgam properties",
      ],
      correct: "B"
    },
    {
      id: 23678,
      question: "You are placing amalgam increments into a cavity preparation.\n\nWhat is the PRIMARY purpose of condensation?",
      options: [
        "Condensation removes excess mercury and adapts amalgam to cavity walls",
        "Condensation changes the color of amalgam to match adjacent teeth",
        "Condensation is not necessary if the amalgam was mixed properly",
        "Condensation weakens amalgam and should be avoided during placement",
      ],
      correct: "A"
    },
    {
      id: 23679,
      question: "You are carving an amalgam restoration and want to avoid overcarving the margins.\n\nWhat is the correct carving technique at the cavosurface margins?",
      options: [
        "Direct all cutting strokes perpendicular to margins to remove excess material",
        "Direct all cutting strokes parallel to margins to maintain seal and avoid overcarving",
        "Carving direction does not matter as long as excess is removed",
        "Avoid carving near margins completely to prevent any damage to enamel",
      ],
      correct: "B"
    },
    {
      id: 23680,
      question: "After placing an amalgam restoration, you remove the dental dam to check occlusion.\n\nWhat is the MOST appropriate patient instruction for checking occlusion?",
      options: [
        "Have the patient bite as hard as possible to test the strength",
        "Have the patient gently tap teeth together while marking with articulating paper",
        "Skip the occlusion check since patients cannot feel premature contacts",
        "Wait 24 hours before checking occlusion to allow complete amalgam set",
      ],
      correct: "B"
    },
    {
      id: 23681,
      question: "An amalgam mix was completed 4 minutes ago but has not been placed yet.\n\nWhat is the appropriate action at this point?",
      options: [
        "Continue placing the amalgam since it will set properly regardless of time",
        "The amalgam should have been placed within 3 minutes; discard and remix",
        "Amalgam can be used for up to 30 minutes after mixing without problems",
        "Heat the amalgam to extend the working time for placement",
      ],
      correct: "B"
    },
    {
      id: 23682,
      question: "You are training a new dental assistant on mercury hygiene practices.\n\nWhat is the PRIMARY method for protecting dental personnel from mercury exposure?",
      options: [
        "Mercury is completely safe and no protective measures are needed",
        "Use PPE, work over catch trays, ensure ventilation, and handle carefully",
        "Only dentists need protection since they handle mercury most frequently",
        "Protective measures are only needed when placing amalgam, not during removal",
      ],
      correct: "B"
    },
    {
      id: 23683,
      question: "A patient is concerned about mercury exposure during amalgam placement.\n\nWhich statement is MOST accurate about patient mercury exposure?",
      options: [
        "Patients receive dangerous levels of mercury from every amalgam placement",
        "Dental dam isolation and controlled placement minimize patient exposure significantly",
        "Patients should refuse all amalgam restorations due to severe health risks",
        "Mercury bonds immediately to alloy preventing any exposure to patients",
      ],
      correct: "B"
    },
    {
      id: 23684,
      question: "You notice small pieces of scrap amalgam in the operatory after a restoration procedure.\n\nWhat is the appropriate handling of scrap amalgam?",
      options: [
        "Scrap amalgam should be discarded in regular trash containers",
        "Scrap amalgam should be vacuumed up to vaporize and eliminate it",
        "Scrap amalgam should be recovered and stored according to environmental policies",
        "Scrap amalgam should be rinsed down the sink drain with large amounts of water",
      ],
      correct: "C"
    },
    {
      id: 23685,
      question: "A pregnant patient needs a restoration and asks about amalgam safety.\n\nWhat does the FDA recommend regarding amalgam for pregnant women?",
      options: [
        "Amalgam is recommended as the preferred material for all pregnant patients",
        "Amalgam use in pregnant women should be avoided due to potential risks",
        "Pregnant women can safely receive amalgam without any restrictions",
        "Amalgam should only be used in pregnant women with explicit consent forms",
      ],
      correct: "B"
    },
    {
      id: 23686,
      question: "A patient asks what composite resin is made of and why it can match tooth color.\n\nWhat are the PRIMARY components of composite resin?",
      options: [
        "Composite consists only of colored porcelain particles without any resin",
        "Composite consists of resin matrix, filler particles, and color pigments",
        "Composite consists entirely of metal alloys similar to amalgam material",
        "Composite consists of calcium and phosphate similar to natural enamel",
      ],
      correct: "B"
    },
    {
      id: 23687,
      question: "You are placing a composite restoration and preparing to cure it with a light.\n\nWhat is the purpose of the curing light?",
      options: [
        "The curing light removes bacteria from the tooth surface before restoration",
        "The curing light activates polymerization by linking monomers into a solid mass",
        "The curing light etches the tooth surface to prepare for bonding",
        "The curing light is optional and does not affect composite setting",
      ],
      correct: "B"
    },
    {
      id: 23688,
      question: "A manufacturer describes a composite as \"nanofilled\" with specific particle characteristics.\n\nWhat is the PRIMARY purpose of filler particles in composite?",
      options: [
        "Filler particles provide color and have no effect on strength or wear",
        "Filler particles weaken composites and should be minimized in formulations",
        "Filler particles increase strength, decrease wear, and improve polish retention",
        "Filler particles are only present in low-quality composite materials",
      ],
      correct: "C"
    },
    {
      id: 23689,
      question: "A patient expresses concern about bisphenol-A (BPA) exposure from composite restorations.\n\nWhat is the relationship between BPA and dental composites?",
      options: [
        "Composites contain no chemicals that have any relationship to BPA",
        "Some composites contain BisGMA which is associated with BPA concerns",
        "BPA is only present in amalgam restorations, not composite restorations",
        "BPA in composites has been proven to cause immediate systemic disease",
      ],
      correct: "B"
    },
    {
      id: 23690,
      question: "A dentist explains that composite preparations allow for more conservative tooth structure removal compared to amalgam.\n\nWhat principle of composite bonding allows for minimally invasive preparations?",
      options: [
        "Composites require large mechanical undercuts for retention like amalgam",
        "Composites bond micromechanically to enamel eliminating need for retention undercuts",
        "Composites cannot bond to tooth structure and require maximum tooth removal",
        "Composites only work on dentin and require complete enamel removal",
      ],
      correct: "B"
    },
    {
      id: 23691,
      question: "You are preparing enamel for composite bonding and apply 37% phosphoric acid.\n\nWhat is the PRIMARY purpose of acid etching enamel?",
      options: [
        "Acid etching smooths the enamel surface for better esthetic appearance",
        "Acid etching roughens enamel creating a frosty appearance for bonding",
        "Acid etching removes all enamel and exposes the underlying dentin",
        "Acid etching is harmful and should never be used on tooth structure",
      ],
      correct: "B"
    },
    {
      id: 23692,
      question: "After etching and drying enamel, you inspect the surface before bonding.\n\nWhat appearance indicates properly etched enamel ready for bonding?",
      options: [
        "Etched enamel appears shiny and wet with a glazed surface",
        "Etched enamel appears frosty or chalky white indicating surface roughness",
        "Etched enamel appears yellow indicating removal of outer enamel layer",
        "Etched enamel appears dark brown indicating proper acid penetration",
      ],
      correct: "B"
    },
    {
      id: 23693,
      question: "A dentist explains that bonding to dentin is more challenging than bonding to enamel.\n\nWhat is the PRIMARY reason dentin bonding is less predictable?",
      options: [
        "Dentin is more inorganic than enamel providing stronger bond sites",
        "Dentin is more organic with less inorganic structure resulting in weaker bonds",
        "Dentin bonding is actually easier and more predictable than enamel bonding",
        "Dentin bonding and enamel bonding have identical success rates and techniques",
      ],
      correct: "B"
    },
    {
      id: 23694,
      question: "You are learning about bonding agents and their interaction with tooth moisture.\n\nWhy are hydrophilic bonding agents important for dentin bonding?",
      options: [
        "Dentin is always completely dry so hydrophobic materials work best",
        "Trace moisture from dentinal tubules requires bonding agents that tolerate moisture",
        "Hydrophilic bonding agents are weaker and should be avoided always",
        "Hydrophilic bonding agents are only used for enamel bonding procedures",
      ],
      correct: "B"
    },
    {
      id: 23695,
      question: "You are using a curing light and notice it produces blue wavelength light.\n\nWhat safety precaution is MOST important when using curing lights?",
      options: [
        "Curing lights are completely safe and require no protective measures",
        "Curing light wavelengths can damage the retina and require protective shields",
        "Only patients need eye protection from curing lights, not operators",
        "Curing lights should be used without any barriers for maximum effectiveness",
      ],
      correct: "B"
    },
    {
      id: 23696,
      question: "A dental office is purchasing a new curing light system.\n\nWhat intensity is considered adequate for proper composite polymerization?",
      options: [
        "100 mW/cm² or higher provides adequate depth of cure up to 5mm",
        "400 mW/cm² or higher provides adequate depth of cure up to 2mm",
        "1000 mW/cm² is the minimum required for any composite curing",
        "Light intensity does not affect polymerization depth or quality",
      ],
      correct: "B"
    },
    {
      id: 23697,
      question: "You are selecting instruments for composite placement.\n\nWhat is the PRIMARY characteristic of composite placement instruments?",
      options: [
        "Composite instruments should be sharp and bladed for carving material",
        "Composite instruments should be flat or smooth-ended for shaping soft material",
        "Composite instruments should be identical to amalgam condensers",
        "Composite instruments should be made only of stainless steel",
      ],
      correct: "B"
    },
    {
      id: 23698,
      question: "You are placing composite in a deep Class II preparation.\n\nWhat is the maximum thickness recommended for each composite increment?",
      options: [
        "Each composite increment should be no more than 1mm thick for adequate curing",
        "Each composite increment should be no more than 2mm thick for adequate curing",
        "Each composite increment should be no more than 5mm thick for adequate curing",
        "Composite thickness does not matter and can be placed in one full increment",
      ],
      correct: "B"
    },
    {
      id: 23699,
      question: "A patient asks why the dentist places composite in multiple layers instead of all at once.\n\nWhat is the PRIMARY benefit of incremental placement?",
      options: [
        "Incremental placement allows faster completion of restorations overall",
        "Incremental placement reduces gaps and voids from polymerization shrinkage",
        "Incremental placement is only done to increase the cost of procedures",
        "Incremental placement weakens composite and should be avoided",
      ],
      correct: "B"
    },
    {
      id: 23700,
      question: "A dentist is using a bulk fill composite material for a large Class II restoration.\n\nWhat is the PRIMARY advantage of bulk fill composites?",
      options: [
        "Bulk fill composites can be placed up to 10mm depth in single increment",
        "Bulk fill composites allow placement up to 5mm depth in single increment",
        "Bulk fill composites eliminate the need for any bonding agents",
        "Bulk fill composites cannot be used for any posterior restorations",
      ],
      correct: "B"
    },
    {
      id: 23701,
      question: "You are completing a composite restoration and need to finish and polish it.\n\nWhat is the PRIMARY difference between finishing and polishing?",
      options: [
        "Finishing produces final shape and contour; polishing creates smooth shiny surface",
        "Finishing and polishing are identical terms with no difference between them",
        "Finishing is done months after placement; polishing is done immediately",
        "Finishing applies only to amalgam; polishing applies only to composite",
      ],
      correct: "A"
    },
    {
      id: 23702,
      question: "Immediately after curing a composite restoration, you notice flash (overextension) at the margins.\n\nWhat instrument is MOST appropriate for removing flash?",
      options: [
        "Amalgam condensers are ideal for removing composite flash",
        "Flame-shaped finishing burs or diamonds remove flash effectively",
        "Composite flash should never be removed to avoid damaging margins",
        "Only polishing paste can remove flash from composite restorations",
      ],
      correct: "B"
    },
    {
      id: 23703,
      question: "You need to finish the interproximal area of a composite restoration that is slightly rough.\n\nWhat is the MOST appropriate method for finishing this area?",
      options: [
        "Use a flame-shaped finishing bur on the interproximal surface",
        "Use finishing strips designed for interproximal access and smoothing",
        "Leave the rough surface since interproximal areas cannot be finished",
        "Use a large polishing disc which will easily access interproximal areas",
      ],
      correct: "B"
    },
    {
      id: 23704,
      question: "You are ready to polish a composite restoration after finishing is complete.\n\nWhat is the correct sequence for polishing abrasives?",
      options: [
        "Progress from fine to coarse abrasives for best results",
        "Progress from coarse to fine abrasives for best results",
        "Use only one grit of abrasive for the entire polishing procedure",
        "Polishing sequence does not matter as long as surface is shiny",
      ],
      correct: "B"
    },
    {
      id: 23705,
      question: "After polishing a composite restoration, the dentist suggests applying a composite sealer.\n\nWhat is the PRIMARY purpose of composite sealers?",
      options: [
        "Composite sealers fill surface irregularities to minimize staining and wear",
        "Composite sealers remove surface defects by chemically etching the restoration",
        "Composite sealers are applied before bonding to prepare tooth surface",
        "Composite sealers weaken the restoration surface and should be avoided",
      ],
      correct: "A"
    },
    {
      id: 23706,
      question: "You are placing a Class III composite restoration on tooth #8 with lingual access.\n\nWhy is lingual access preferred for anterior interproximal restorations?",
      options: [
        "Lingual access allows easier instrumentation but compromises esthetics significantly",
        "Lingual access preserves the marginal ridge whenever possible maintaining esthetics",
        "Lingual access is actually contraindicated and facial access should always be used",
        "Lingual access is only used when the cavity extends to the incisal edge",
      ],
      correct: "B"
    },
    {
      id: 23707,
      question: "A patient needs a Class V composite restoration that extends into the gingival sulcus.\n\nWhat makes Class V restorations particularly challenging?",
      options: [
        "Class V restorations always have strong bond strength due to enamel location",
        "Class V restorations have weak bond strength being primarily in dentin",
        "Class V restorations are the easiest restorations to place in dentistry",
        "Class V restorations never require any special isolation or matrix techniques",
      ],
      correct: "B"
    },
    {
      id: 23708,
      question: "You are placing a Class IV composite restoration on tooth #9.\n\nWhat type of matrix is typically used for Class III and IV restorations?",
      options: [
        "Tofflemire metal matrix bands are standard for all anterior restorations",
        "Mylar matrix strips are typically used for Class III and IV restorations",
        "No matrix is ever needed for anterior composite restorations",
        "Sectional metal matrix with pressure rings is required for Class IV",
      ],
      correct: "B"
    },
    {
      id: 23709,
      question: "A patient who uses bleaching products regularly needs a composite restoration.\n\nWhat precaution should be taken regarding bonding for this patient?",
      options: [
        "Bleaching products do not affect bonding and treatment can proceed immediately",
        "Patient should stop bleaching 1-2 weeks before restorative treatment for optimal bonding",
        "Patient should increase bleaching frequency before restorative procedures",
        "Bleaching products improve bond strength and should be continued during treatment",
      ],
      correct: "B"
    },
    {
      id: 23710,
      question: "A patient asks about the resin-modified glass ionomer material being used for a restoration.\n\nWhat is the PRIMARY difference between glass ionomer and resin-modified glass ionomer?",
      options: [
        "RMGI sets only through acid-base reaction without any light curing",
        "RMGI sets through acid-base reaction AND photopolymerization",
        "RMGI contains no fluoride unlike traditional glass ionomer materials",
        "RMGI cannot bond to tooth structure unlike traditional glass ionomer",
      ],
      correct: "B"
    },
    {
      id: 23711,
      question: "A patient with high caries risk is receiving RMGI restorations.\n\nWhat is a PRIMARY benefit of RMGI for this patient?",
      options: [
        "RMGI restorations are the strongest materials available for any cavity",
        "RMGI releases fluoride ions helping to prevent recurrent caries at margins",
        "RMGI restorations have no benefit for high caries risk patients",
        "RMGI restorations last longer than any other restorative material",
      ],
      correct: "B"
    },
    {
      id: 23712,
      question: "A dentist is selecting the appropriate material for various restorations.\n\nFor which situation is RMGI particularly indicated?",
      options: [
        "Large Class II restorations on permanent molars with heavy occlusion",
        "Root caries, Class V lesions, and Class I and II on primary teeth",
        "Anterior esthetic restorations on maxillary incisors",
        "RMGI should never be used for any restorative procedures",
      ],
      correct: "B"
    },
    {
      id: 23713,
      question: "After placing an RMGI restoration, you prepare to apply a protective coating.\n\nWhat is the purpose of the protective varnish or bonding resin coating?",
      options: [
        "The coating provides color matching between restoration and tooth",
        "The coating protects the RMGI surface from moisture during initial setting",
        "The coating is purely decorative and serves no functional purpose",
        "The coating prevents fluoride release which would weaken the restoration",
      ],
      correct: "B"
    },
    {
      id: 23714,
      question: "A student asks about the differences between RMGI and traditional glass ionomer.\n\nWhat is a PRIMARY advantage of RMGI over traditional glass ionomer?",
      options: [
        "RMGI is more soluble and less durable than traditional glass ionomer",
        "RMGI has improved strength, less solubility, and better esthetics",
        "RMGI releases less fluoride than traditional glass ionomer materials",
        "RMGI cannot be used as a restorative material, only as liner",
      ],
      correct: "B"
    },
    {
      id: 23715,
      question: "A parent asks why stainless steel crowns are recommended for their child's primary molars.\n\nWhat is the PRIMARY indication for SSCs in pediatric dentistry?",
      options: [
        "SSCs are only used for cosmetic improvement of anterior teeth",
        "SSCs are used when teeth can no longer support direct restorations",
        "SSCs are placed on all primary teeth regardless of condition",
        "SSCs are only used on permanent teeth, never on primary teeth",
      ],
      correct: "B"
    },
    {
      id: 23716,
      question: "A parent wants the most esthetic option for their child's anterior primary teeth.\n\nWhat is the PRIMARY advantage of preformed zirconia crowns?",
      options: [
        "Zirconia crowns cost less than all other pediatric crown options",
        "Zirconia crowns provide excellent esthetics for anterior teeth",
        "Zirconia crowns are temporary and fall out within weeks",
        "Zirconia crowns can only be used on permanent teeth",
      ],
      correct: "B"
    },
    {
      id: 23717,
      question: "A dentist is deciding between SSC and composite strip crowns for primary anterior teeth with extensive caries.\n\nWhat should be considered when making this decision?",
      options: [
        "SSCs provide better longevity but compromise esthetics compared to composite",
        "SSCs provide better esthetics but compromise durability compared to composite",
        "Both options have identical esthetics, longevity, and cost considerations",
        "Neither option is appropriate for primary anterior teeth with extensive caries",
      ],
      correct: "A"
    },
    {
      id: 23718,
      question: "You are fitting a stainless steel crown and find that the margins extend too far subgingivally causing excessive blanching.\n\nWhat is the appropriate action?",
      options: [
        "Force the crown further onto the tooth until blanching reduces",
        "Trim the crown margins with scissors or abrasive wheel and re-fit",
        "Select a larger crown size to reduce the amount of blanching",
        "Leave the crown as is since blanching is normal and acceptable",
      ],
      correct: "B"
    },
    {
      id: 23719,
      question: "After trimming and fitting an SSC, you need to adapt the margins for proper fit.\n\nWhat is the correct sequence for margin adaptation?",
      options: [
        "Crimping pliers only are needed; contouring pliers are never used",
        "Contouring pliers followed by crimping pliers adapt the crown margins",
        "No pliers are needed; crowns are used exactly as received from manufacturer",
        "Crimping and contouring are only done after crown is permanently cemented",
      ],
      correct: "B"
    },
    {
      id: 23720,
      question: "A dentist is preparing to take a final impression for a crown and requests gingival retraction cord.\n\nWhat is the PRIMARY purpose of gingival retraction cord?",
      options: [
        "Retraction cord provides anesthesia to the gingival tissues during preparation",
        "Retraction cord expands the sulcus allowing impression material to capture margins",
        "Retraction cord permanently removes gingival tissue for better esthetics",
        "Retraction cord is purely decorative and serves no functional purpose",
      ],
      correct: "B"
    },
    {
      id: 23721,
      question: "You are placing retraction cord using a dual-cord technique for a crown impression.\n\nWhat is the correct relationship between the bottom and top cords?",
      options: [
        "Bottom cord is thicker and longer than the top cord",
        "Top cord is thicker and longer than the bottom cord",
        "Both cords are identical in diameter and length",
        "Only one cord is ever needed; dual-cord technique is obsolete",
      ],
      correct: "B"
    },
    {
      id: 23722,
      question: "Before placing retraction cord, you soak it in a hemostatic agent.\n\nWhat is the PRIMARY purpose of the hemostatic agent?",
      options: [
        "Hemostatic agents provide permanent tissue removal for better impressions",
        "Hemostatic agents control bleeding and aid in tissue displacement",
        "Hemostatic agents cause tissue to swell making cord placement easier",
        "Hemostatic agents are toxic and should never be used in dentistry",
      ],
      correct: "B"
    },
    {
      id: 23723,
      question: "You are inserting retraction cord into the gingival sulcus around a prepared tooth.\n\nWhat is the correct placement technique?",
      options: [
        "Use forceful apical pressure to push cord deep into sulcus",
        "Gently roll cord into sulcus below gingival margin without forceful pressure",
        "Place cord on top of gingival margin without entering sulcus",
        "Wrap cord around tooth without attempting to enter sulcus",
      ],
      correct: "B"
    },
    {
      id: 23724,
      question: "A patient asks why a temporary restoration is necessary while waiting for a permanent crown.\n\nWhat is a PRIMARY purpose of temporary restorations?",
      options: [
        "Temporary restorations are purely cosmetic and serve no protective function",
        "Temporary restorations protect exposed dentin and prevent tooth movement",
        "Temporary restorations are not necessary and patients can wait without them",
        "Temporary restorations are only used to increase treatment costs",
      ],
      correct: "B"
    },
    {
      id: 23725,
      question: "You are preparing to place a temporary restoration using reinforced zinc oxide and eugenol.\n\nWhat is a PRIMARY advantage of reinforced ZOE for temporary restorations?",
      options: [
        "ZOE is the best material to use before bonded permanent restorations",
        "ZOE has insulating properties and sedative effect protecting the vital pulp",
        "ZOE is radiolucent making it invisible on radiographs for diagnostics",
        "ZOE bonds permanently to tooth structure and cannot be removed",
      ],
      correct: "B"
    },
    {
      id: 23726,
      question: "A patient needs a temporary restoration before receiving a bonded porcelain veneer.\n\nWhy should ZOE temporary material be avoided in this case?",
      options: [
        "ZOE is too strong and will prevent removal before permanent placement",
        "Eugenol penetrates dentinal tubules and affects bond strength of permanent restoration",
        "ZOE is radiopaque and will interfere with taking radiographs",
        "ZOE cannot be used for anterior teeth under any circumstances",
      ],
      correct: "B"
    },
    {
      id: 23727,
      question: "You have mixed reinforced ZOE and are ready to place it.\n\nWhat consistency indicates properly mixed ZOE ready for placement?",
      options: [
        "ZOE should be very fluid and runny like water",
        "ZOE should be thick and claylike that can be rolled into a ball",
        "ZOE should be powdery and dry without any cohesion",
        "ZOE consistency does not matter for successful placement",
      ],
      correct: "B"
    },
    {
      id: 23728,
      question: "A dentist recommends a custom-made acrylic resin temporary crown for a complex preparation.\n\nFor which situations are custom acrylic temporaries MOST appropriate?",
      options: [
        "Simple Class I restorations that require no coverage",
        "Complex restorations like inlays, onlays, veneers, and crowns",
        "Acrylic temporaries cannot be used for any dental restorations",
        "Acrylic temporaries are only used in pediatric dentistry",
      ],
      correct: "B"
    },
    {
      id: 23729,
      question: "A patient asks how long different temporary crown materials last.\n\nWhich temporary crown type is MOST durable for extended wear?",
      options: [
        "Reinforced ZOE temporary restorations last longest for extended periods",
        "Custom acrylic temporary crowns can last several weeks to months",
        "Temporary crowns cannot last more than 24 hours regardless of material",
        "All temporary crown materials have identical durability and longevity",
      ],
      correct: "B"
    },
    {
      id: 23730,
      question: "A patient asks why cement is needed when placing a permanent crown.\n\nWhat is the PRIMARY purpose of luting agents (cements)?",
      options: [
        "Luting agents provide the color match between crown and tooth",
        "Luting agents fill the space between restoration and tooth preventing loosening",
        "Luting agents dissolve tooth structure to make space for the crown",
        "Luting agents are not necessary for permanent restorations",
      ],
      correct: "B"
    },
    {
      id: 23731,
      question: "A dentist selects glass ionomer cement for luting a permanent crown.\n\nWhat is a PRIMARY advantage of glass ionomer luting cement?",
      options: [
        "Glass ionomer is highly acidic making it compatible with vital pulps",
        "Glass ionomer chemically adheres to tooth structure and releases fluoride",
        "Glass ionomer has unlimited working time for extended procedures",
        "Glass ionomer cannot be used for cementing any permanent restorations",
      ],
      correct: "B"
    },
    {
      id: 23732,
      question: "A dentist selects resin cement for luting a porcelain veneer.\n\nWhen is resin cement particularly indicated?",
      options: [
        "Resin cement is only used for temporary restorations, never permanent",
        "Resin cement is indicated when maximum bond strength is needed",
        "Resin cement has the weakest bond strength of all luting agents",
        "Resin cement should be avoided for all bonded restorations",
      ],
      correct: "B"
    },
    {
      id: 23733,
      question: "You need to cement a temporary crown and want to ensure easy removal later.\n\nWhat is the MOST appropriate cement for this purpose?",
      options: [
        "Use permanent resin cement for maximum retention of temporary",
        "Use temporary cement with appropriate retention but allowing removal",
        "Use no cement; temporary crowns should never be cemented",
        "Use super glue to permanently bond temporary crowns",
      ],
      correct: "B"
    },
    {
      id: 23734,
      question: "A patient needs a temporary crown before a final bonded restoration.\n\nWhy should non-eugenol temporary cement be used?",
      options: [
        "Non-eugenol cements are stronger and prevent temporary crown loss",
        "Non-eugenol cements avoid oils that interfere with bonding of final restoration",
        "Non-eugenol cements are not appropriate for any temporary restorations",
        "Non-eugenol cements are only used for pediatric restorations",
      ],
      correct: "B"
    },
    {
      id: 23735,
      question: "A patient received an amalgam restoration yesterday and wants it polished today.\n\nWhat is the MOST appropriate recommendation regarding polishing timing?",
      options: [
        "Amalgam can be polished immediately within hours of placement",
        "Amalgam should be allowed to set at least 24 hours before polishing",
        "Amalgam should never be polished under any circumstances",
        "Amalgam polishing timing has no effect on restoration quality",
      ],
      correct: "B"
    },
    {
      id: 23736,
      question: "A patient asks why amalgam restorations should be polished.\n\nWhat is a PRIMARY benefit of polished amalgam?",
      options: [
        "Polished amalgam changes color to match adjacent natural teeth",
        "Polished amalgam retains less biofilm and resists tarnish better",
        "Polished amalgam becomes transparent and invisible in the mouth",
        "Polished amalgam is weakened and more likely to fracture",
      ],
      correct: "B"
    },
    {
      id: 23737,
      question: "You are polishing an amalgam restoration and notice the tooth surface becoming hot.\n\nWhat is the MOST appropriate action?",
      options: [
        "Continue polishing with heavy pressure to complete the procedure quickly",
        "Use water coolant and intermittent light strokes to minimize heat generation",
        "Heat generation is beneficial and should be maximized during polishing",
        "Stop polishing permanently since any heat indicates irreversible damage",
      ],
      correct: "B"
    },
    {
      id: 23738,
      question: "You are polishing an amalgam restoration using rubber cups and points.\n\nWhat is the correct sequence for using color-coded polishing materials?",
      options: [
        "Use yellow, then green, then brown color-coded polishing materials",
        "Use brown, then green, then yellow color-coded polishing materials",
        "Use only one color throughout; sequence does not matter for amalgam",
        "Use only paste; rubber cups and points should never be used",
      ],
      correct: "B"
    },
    {
      id: 23739,
      question: "You have just completed placing a Class II composite restoration.\n\nWhat information is MOST important to document in the patient record?",
      options: [
        "Only the tooth number needs to be documented for restorative procedures",
        "Tooth number, surfaces, materials used, anesthetic, and patient education",
        "Documentation is not necessary since the patient received a restoration",
        "Only document complications; routine procedures do not require documentation",
      ],
      correct: "B"
    },
    {
      id: 23740,
      question: "During a maintenance appointment, you are evaluating previously placed restorations.\n\nWhat is the dental hygienist's role in the restorative care cycle?",
      options: [
        "Dental hygienists should ignore existing restorations during maintenance visits",
        "Dental hygienists assess restoration quality and provide ongoing maintenance",
        "Only dentists can evaluate restorations; hygienists have no role",
        "Dental hygienists replace defective restorations without dentist diagnosis",
      ],
      correct: "B"
    },
    {
      id: 23741,
      question: "A patient returns for a follow-up appointment after receiving multiple restorations.\n\nWhat aspects should be evaluated from the PATIENT'S perspective?",
      options: [
        "Only the technical quality of margins and contours matter for evaluation",
        "Comfort, function, and appearance from patient's perspective are important",
        "Patient perspective is irrelevant; only clinical assessment matters",
        "Patients cannot provide useful information about restoration quality",
      ],
      correct: "B"
    },
    {
      id: 23742,
      question: "During a maintenance appointment, you notice an amalgam restoration with an overhang at the gingival margin.\n\nWhat is the MOST appropriate action?",
      options: [
        "Ignore the overhang since it is not causing any current problems",
        "Document findings and communicate to dentist for evaluation and treatment",
        "Remove the overhang immediately without consulting the dentist",
        "Wait until the patient reports symptoms before taking any action",
      ],
      correct: "B"
    },
    {
      id: 23743,
      question: "A patient asks about same-day crowns made with a computer at the dental office.\n\nWhat technology allows for chairside fabrication of indirect restorations?",
      options: [
        "Traditional lost-wax casting technique performed chairside by dentist",
        "Computer-aided design and computer-aided manufacture (CAD-CAM)",
        "Hand-carved crowns made directly from composite material",
        "Crowns cannot be made at the dental office under any circumstances",
      ],
      correct: "B"
    },
    {
      id: 23744,
      question: "A dentist explains that cavity preparation design differs based on restorative material.\n\nWhat is a KEY difference in preparation design for composite vs amalgam?",
      options: [
        "Both materials require identical preparation designs without any differences",
        "Composite bonding allows minimally invasive preparations; amalgam requires retention",
        "Composite requires more tooth structure removal than amalgam preparations",
        "Amalgam preparations are always smaller than composite preparations",
      ],
      correct: "B"
    },
    {
      id: 23745,
      question: "A dental hygienist is interested in expanding their scope of practice to include restorative procedures.\n\nWhat is the MOST appropriate first step?",
      options: [
        "Begin placing restorations immediately based on education in hygiene school",
        "Research state requirements and pursue additional education and credentials needed",
        "Restorative procedures can never be performed by dental hygienists anywhere",
        "No additional training is needed; all hygienists can place restorations",
      ],
      correct: "B"
    }
  ],

  "3. Orthodontic Care (Case Study)": [
    {
      id: 23746,
      question: "A 7-year-old patient presents for their first dental hygiene appointment. The parent asks why their orthodontist wants to see the child at this young age since most baby teeth are still present. What is the MOST appropriate rationale for early orthodontic evaluation at age 7?",
      options: [
        "Primary teeth are easier to move than permanent teeth during treatment",
        "First permanent molars have erupted allowing evaluation of posterior occlusion",
        "All permanent incisors have fully erupted by this developmental stage",
        "Skeletal growth patterns cannot be assessed until adolescence begins",
      ],
      correct: "B"
    },
    {
      id: 23747,
      question: "During an oral assessment of a 9-year-old patient, you observe that the buccal cusps of the maxillary posterior teeth occlude lingual to the buccal cusps of the mandibular teeth. The patient's mother reports the child is a chronic mouth breather due to asthma. Which malocclusion is present?",
      options: [
        "Anterior open bite in the sagittal plane",
        "Posterior crossbite in the transverse plane",
        "Class II Division 1 in the occlusal plane",
        "Deep overbite with skeletal discrepancy",
      ],
      correct: "B"
    },
    {
      id: 23748,
      question: "A 12-year-old patient presents with fixed orthodontic appliances placed 6 months ago. Clinical examination reveals moderate gingival inflammation and biofilm accumulation around brackets. What is the PRIMARY area of difficulty for plaque control in orthodontic patients?",
      options: [
        "Interproximal surfaces between adjacent teeth",
        "Occlusal surfaces of posterior teeth",
        "Area from bracket to gingival margin",
        "Lingual surfaces of mandibular incisors",
      ],
      correct: "C"
    },
    {
      id: 23749,
      question: "You are reviewing a panoramic radiograph for an 11-year-old orthodontic patient. The radiograph shows all permanent teeth developing normally except the maxillary right lateral incisor, which is absent. What is the MOST likely management approach for this congenitally missing tooth?",
      options: [
        "Immediate placement of a pediatric dental implant",
        "Orthodontic space closure, bridge placement, or implant after growth",
        "Serial extraction of the contralateral lateral incisor",
        "Palatal expansion to create space for prosthetic replacement",
      ],
      correct: "B"
    },
    {
      id: 23750,
      question: "A patient's lateral cephalometric radiograph shows a steep mandibular plane angle and increased lower facial height. Which malocclusion is MOST commonly associated with these cephalometric findings?",
      options: [
        "Class III occlusion with mandibular prognathism",
        "Deep overbite with short facial height",
        "Anterior open bite with long face pattern",
        "Class I occlusion with normal vertical proportions",
      ],
      correct: "C"
    },
    {
      id: 23751,
      question: "During orthodontic assessment, you note spacing between a 5-year-old patient's maxillary lateral incisors and canines and between mandibular canines and first molars. The parent is concerned about these spaces. What should you explain about these findings?",
      options: [
        "Immediate orthodontic intervention is required to close spaces",
        "These are primate spaces that provide room for permanent teeth",
        "Spacing indicates abnormal alveolar bone development patterns",
        "Primary teeth should always contact without any spacing present",
      ],
      correct: "B"
    },
    {
      id: 23752,
      question: "A 14-year-old patient with fixed braces presents reporting tooth sensitivity and difficulty chewing for 3 days following their last orthodontic adjustment. What is the MOST likely cause of these symptoms?",
      options: [
        "Severe apical root resorption from excessive force application",
        "Acute pulpitis requiring endodontic evaluation and treatment",
        "Mild transient pulpitis from appropriate orthodontic force",
        "Periodontal abscess formation from inadequate oral hygiene",
      ],
      correct: "C"
    },
    {
      id: 23753,
      question: "You observe that a 10-year-old patient's permanent mandibular central incisors have erupted lingual to the primary incisors, which are still present. What is the MOST appropriate recommendation?",
      options: [
        "This represents abnormal development requiring immediate extraction",
        "This is normal eruption pattern that may self-correct",
        "Permanent incisors must be extracted and reimplanted correctly",
        "Fixed orthodontic appliances are required at this stage",
      ],
      correct: "B"
    },
    {
      id: 23754,
      question: "A patient's treatment plan includes maxillary expansion using a palatal expander. At what developmental stage is skeletal expansion MOST effective for achieving stable results?",
      options: [
        "After complete fusion of the midpalatal suture",
        "During late adolescence when growth is minimal",
        "Prior to midpalatal suture fusion in mixed dentition",
        "Only in adults with surgically assisted expansion",
      ],
      correct: "C"
    },
    {
      id: 23755,
      question: "An 8-year-old patient presents with severe crowding and early loss of primary canines due to resorption by erupting lateral incisors. What treatment approach is MOST appropriate for this clinical presentation?",
      options: [
        "Immediate full fixed appliances in primary dentition",
        "Expansion of dental arches or serial extraction therapy",
        "Extraction of permanent lateral incisors to create space",
        "No treatment until all permanent teeth have erupted",
      ],
      correct: "B"
    },
    {
      id: 23756,
      question: "During a dental hygiene visit, you detect that an orthodontic bracket on tooth #9 is mobile when gently rocked with instrument handles. What is the PRIMARY significance of this finding?",
      options: [
        "Normal mobility expected during active tooth movement",
        "Indication that tooth movement is occurring too rapidly",
        "Failed cement seal allowing potential caries under bracket",
        "Sign of successful completion of orthodontic movement",
      ],
      correct: "C"
    },
    {
      id: 23757,
      question: "A patient with a maxillary midline diastema of 3 mm is 9 years old with unerupted permanent canines. What is the expected outcome for this diastema?",
      options: [
        "Complete spontaneous closure by age 16 without intervention",
        "Diastema will likely persist requiring orthodontic closure",
        "Surgical frenectomy is required before any tooth eruption",
        "Immediate bonding is indicated to prevent further widening",
      ],
      correct: "B"
    },
    {
      id: 23758,
      question: "You are examining an orthodontic patient and notice the lips are separated by 5 mm at rest. What term describes this condition, and what is a likely cause?",
      options: [
        "Mentalis strain caused by excessive mandibular growth",
        "Lip incompetence potentially from protrusive incisors",
        "Normal lip posture for this developmental stage",
        "Skeletal open bite from vertical maxillary excess",
      ],
      correct: "B"
    },
    {
      id: 23759,
      question: "A 13-year-old patient's radiograph shows the maxillary left canine is impacted and positioned palatally. The primary canine has been extracted but the permanent canine has not erupted after 8 months. What is the MOST likely next treatment step?",
      options: [
        "Continued observation for 12 additional months",
        "Extraction of impacted canine and prosthetic replacement",
        "Surgical exposure, bonding, and orthodontic traction",
        "Autotransplantation of mandibular premolar to canine site",
      ],
      correct: "C"
    },
    {
      id: 23760,
      question: "During tooth movement, what is the PRIMARY cellular process that removes bone on the pressure side ahead of the moving tooth?",
      options: [
        "Osteoblastic deposition of new mineralized tissue",
        "Osteoclastic frontal resorption of the lamina dura",
        "Cementoblast activity remodeling root surface",
        "Fibroblast proliferation within periodontal ligament space",
      ],
      correct: "B"
    },
    {
      id: 23761,
      question: "A patient asks why their orthodontic appointments are scheduled every 6 weeks rather than more frequently. What is the MOST accurate explanation for this appointment interval?",
      options: [
        "Archwires maintain constant force for exactly 6-week periods",
        "Insurance reimbursement policies require 6-week intervals between visits",
        "PDL requires 10-14 days repair time after undermining resorption",
        "Brackets and bands loosen predictably at 6-week intervals",
      ],
      correct: "C"
    },
    {
      id: 23762,
      question: "An orthodontic patient presents with white spot lesions visible on dried enamel around brackets. The lesions have intact smooth surfaces. What is the MOST appropriate initial management?",
      options: [
        "Immediate restoration with composite resin materials",
        "Sharp explorer examination to assess lesion depth",
        "Aggressive scaling to remove demineralized enamel",
        "Fluoride varnish application and improved oral hygiene",
      ],
      correct: "D"
    },
    {
      id: 23763,
      question: "You note apical root resorption on a periapical radiograph of an orthodontic patient's maxillary central incisor showing 2 mm of root length loss. What is the clinical significance of this finding?",
      options: [
        "Severe root loss requiring immediate treatment discontinuation",
        "Normal finding with minimal clinical significance",
        "Indication of improper force application needing correction",
        "Sign of acute periapical infection requiring endodontics",
      ],
      correct: "B"
    },
    {
      id: 23764,
      question: "A patient with fixed orthodontic appliances reports difficulty maintaining oral hygiene with manual brushing. Which recommendation provides the MOST effective biofilm control for this patient?",
      options: [
        "Increase brushing frequency to 5 times daily",
        "Use powered toothbrush with orthodontic head",
        "Rinse with water immediately after meals only",
        "Replace toothbrush every 2 weeks during treatment",
      ],
      correct: "B"
    },
    {
      id: 23765,
      question: "An orthodontic patient is prescribed 5000 ppm fluoride toothpaste for daily use. What is the PRIMARY indication for this high-concentration fluoride?",
      options: [
        "Treatment of existing cavitated carious lesions",
        "Prevention of demineralization and white spot lesions",
        "Reduction of tooth sensitivity during movement",
        "Strengthening of orthodontic bracket bond strength",
      ],
      correct: "B"
    },
    {
      id: 23766,
      question: "During examination of a patient who completed orthodontic treatment 2 years ago, you notice relapse of mandibular incisor crowding. What is the PRIMARY reason teeth may relapse after orthodontic treatment?",
      options: [
        "Inadequate fluoride supplementation during retention phase",
        "Failure to extract third molars before eruption",
        "Elastic gingival fibers pulling teeth toward original positions",
        "Excessive calcium intake causing rapid bone formation",
      ],
      correct: "C"
    },
    {
      id: 23767,
      question: "A 16-year-old patient with Class II malocclusion is prescribed headgear to wear 12-14 hours daily, preferably at night. What is the physiologic rationale for nighttime wear?",
      options: [
        "Teeth move faster during sleep due to reduced muscle activity",
        "More growth hormone is secreted at night than during daytime",
        "Saliva production increases at night enhancing tooth movement",
        "Headgear forces are more effective when patient is recumbent",
      ],
      correct: "B"
    },
    {
      id: 23768,
      question: "You are providing dietary counseling to an orthodontic patient. What is the PRIMARY reason to minimize sugar and sticky carbohydrate intake during treatment?",
      options: [
        "Sugar causes direct demineralization of bracket bonding material",
        "Orthodontic tooth movement is slowed by high sugar consumption",
        "Plaque biofilm control is more difficult with fixed appliances present",
        "Sticky foods always cause immediate bracket debonding",
      ],
      correct: "C"
    },
    {
      id: 23769,
      question: "A patient presents 3 months after appliance placement with 2 mm of widened PDL space visible on radiographs and moderate tooth mobility. What do these findings indicate?",
      options: [
        "Excessive force application requiring treatment discontinuation",
        "Normal expected findings during active orthodontic treatment",
        "Severe periodontal disease requiring immediate referral",
        "Complete ankylosis of tooth to surrounding alveolar bone",
      ],
      correct: "B"
    },
    {
      id: 23770,
      question: "An orthodontic patient reports severe pain when chewing firm foods 2 days after adjustment. What is the MOST effective method to relieve this discomfort?",
      options: [
        "Prescribe narcotic analgesics for pain management",
        "Have patient chew gum during first 8 hours after adjustment",
        "Remove all orthodontic forces for 2-week healing period",
        "Apply topical anesthetic gel to tooth surfaces",
      ],
      correct: "B"
    },
    {
      id: 23771,
      question: "You are educating a patient about retainer wear after active treatment completion. For how long should retainers be worn full-time initially after appliance removal?",
      options: [
        "2 weeks until initial tooth mobility resolves",
        "3-4 months to allow PDL reorganization",
        "12 months to ensure complete bone remodeling",
        "24 months matching the duration of active treatment",
      ],
      correct: "B"
    },
    {
      id: 23772,
      question: "A 15-year-old orthodontic patient with a history of periodontal disease asks about tooth movement risks. What complication is MOST likely if active periodontal infection is present during treatment?",
      options: [
        "Accelerated tooth movement requiring frequent adjustments",
        "Exacerbated bone loss during orthodontic movement",
        "Increased enamel strength from inflammation",
        "Enhanced periodontal regeneration and attachment",
      ],
      correct: "B"
    },
    {
      id: 23773,
      question: "During oral hygiene instruction, an orthodontic patient asks about flossing technique. What is the MOST effective interdental cleaning method for patients with fixed appliances?",
      options: [
        "Traditional floss without any threading devices",
        "Superfloss, floss threaders, or orthodontic flossers",
        "Interdental cleaning is not possible with braces",
        "Toothpicks are superior to all flossing methods",
      ],
      correct: "B"
    },
    {
      id: 23774,
      question: "A patient with fixed orthodontic appliances is at high risk for caries. According to ADA guidelines, which professionally applied fluoride is recommended every 6 weeks during treatment?",
      options: [
        "1.23% APF gel applied in custom trays",
        "0.5% fluoride gel for home application",
        "2.26% fluoride varnish applied in office",
        "0.09% sodium fluoride mouth rinse",
      ],
      correct: "C"
    },
    {
      id: 23775,
      question: "You observe gingival overgrowth and severe erythema in an orthodontic patient despite good plaque control. What is the FIRST line of intervention before considering surgical treatment?",
      options: [
        "Immediate gingivectomy to remove overgrown tissue",
        "Intensive periodontal therapy targeting bacterial biofilm",
        "Systemic antibiotics for 3 months duration",
        "Removal of all orthodontic appliances permanently",
      ],
      correct: "B"
    },
    {
      id: 23776,
      question: "A patient taking phenytoin for seizure control is beginning orthodontic treatment. How might this medication affect orthodontic outcomes?",
      options: [
        "Accelerates tooth movement reducing treatment time",
        "May cause gingival hyperplasia slowing movement",
        "Increases risk of bracket bond failure",
        "Enhances bone remodeling and stability",
      ],
      correct: "B"
    },
    {
      id: 23777,
      question: "An adult orthodontic patient asks about the difference between their treatment and adolescent treatment. What is an important consideration for adult orthodontic patients?",
      options: [
        "Adults cannot achieve any tooth movement due to age",
        "Skeletal growth continues allowing jaw modification",
        "Growth patterns contributing to malocclusion continue into adulthood",
        "Adult bone remodels faster than adolescent bone",
      ],
      correct: "C"
    },
    {
      id: 23778,
      question: "During assessment, you note a patient's permanent tooth is erupting when three-fourths of its root is complete, but the primary tooth has significant remaining root structure. What is indicated?",
      options: [
        "This represents normal exfoliation timing",
        "Primary tooth extraction is indicated if permanent tooth present",
        "Surgical exposure of permanent tooth is required",
        "Orthodontic eruption acceleration with elastics",
      ],
      correct: "B"
    },
    {
      id: 23779,
      question: "A patient with fixed appliances presents with an acute mucosal reaction and lichenoid plaque on buccal mucosa adjacent to brackets. What is the MOST likely cause?",
      options: [
        "Viral infection from immunosuppression during treatment",
        "Hypersensitivity or allergy to nickel in brackets",
        "Normal tissue response to orthodontic movement",
        "Candidiasis from inadequate oral hygiene practices",
      ],
      correct: "B"
    },
    {
      id: 23780,
      question: "You are reviewing treatment phases with an orthodontic patient. What is the PRIMARY goal of Phase I (interceptive) orthodontic treatment?",
      options: [
        "Complete all tooth alignment with permanent retention",
        "Achieve final ideal occlusion in permanent dentition",
        "Correct early problems making future treatment easier",
        "Extract primary teeth to prevent future crowding",
      ],
      correct: "C"
    },
    {
      id: 23781,
      question: "A patient has a band and loop space maintainer following premature loss of a primary second molar. What is the PRIMARY purpose of this appliance?",
      options: [
        "Move adjacent teeth into the space of missing tooth",
        "Prevent drifting of adjacent teeth and maintain space",
        "Stimulate eruption of permanent successor tooth",
        "Provide temporary chewing function in missing area",
      ],
      correct: "B"
    },
    {
      id: 23782,
      question: "An orthodontic patient asks about clear aligner treatment versus traditional braces. What is an advantage of clear aligners compared to fixed appliances?",
      options: [
        "Can treat all types of complex orthodontic problems",
        "More effective for difficult tooth movements and torque control",
        "Better for patients with excellent compliance wearing 20 hours daily",
        "Superior stability of results after treatment completion",
      ],
      correct: "C"
    },
    {
      id: 23783,
      question: "During examination, you note elastic separators between a patient's molars. What is the PRIMARY function of these separators?",
      options: [
        "Apply direct force to move teeth mesially or distally",
        "Create space to allow placement of molar bands",
        "Prevent food impaction between posterior teeth",
        "Maintain arch width during expansion treatment",
      ],
      correct: "B"
    },
    {
      id: 23784,
      question: "A patient with a transpalatal appliance (TPA) asks about its purpose. What is the PRIMARY function of a passive TPA?",
      options: [
        "Rapidly expand the maxillary arch width",
        "Correct anterior crossbite relationships",
        "Stabilize molar position or rotate molars",
        "Retract maxillary anterior teeth posteriorly",
      ],
      correct: "C"
    },
    {
      id: 23785,
      question: "You are assessing a patient who had a temporary anchorage device (TAD) placed. What is the PRIMARY advantage of using TADs in orthodontic treatment?",
      options: [
        "Eliminate need for any patient compliance",
        "Correct open bite and vertical problems reducing need for surgery",
        "Accelerate treatment time by 50% compared to traditional methods",
        "Provide temporary tooth replacement during treatment",
      ],
      correct: "B"
    },
    {
      id: 23786,
      question: "A patient presents with a Herbst appliance connecting the mandible to maxilla. What is the PRIMARY treatment goal of this appliance?",
      options: [
        "Restrict excessive maxillary skeletal growth",
        "Help mandible develop in forward direction controlling position",
        "Expand narrow maxillary arch transversely",
        "Correct Class III skeletal relationships",
      ],
      correct: "B"
    },
    {
      id: 23787,
      question: "During oral assessment, you observe a tongue thrust habit in a young patient. Which orthodontic appliance is specifically designed to address this parafunctional habit?",
      options: [
        "Nance holding appliance for space maintenance",
        "Palatal expander for maxillary width increase",
        "Bluegrass or tongue crib appliance",
        "Lip bumper for mandibular arch expansion",
      ],
      correct: "C"
    },
    {
      id: 23788,
      question: "A patient asks why self-ligating brackets are being used instead of traditional brackets with elastic ligatures. What is the PRIMARY advantage of self-ligating brackets?",
      options: [
        "Significantly reduce total treatment time by 12 months",
        "Eliminate all need for periodic orthodontic adjustments",
        "Reduce friction and require no additional ligatures",
        "Provide better esthetics than ceramic bracket options",
      ],
      correct: "C"
    },
    {
      id: 23789,
      question: "An orthodontic patient has Class III malocclusion with deficient maxillary growth. Which removable appliance is designed to accelerate maxillary growth using chin and forehead for support?",
      options: [
        "Standard headgear for maxillary restraint",
        "Reverse headgear or protraction facemask",
        "Chin cup to restrict mandibular growth",
        "Hawley retainer for tooth stabilization",
      ],
      correct: "B"
    },
    {
      id: 23790,
      question: "You are instructing a patient on care of a new Hawley retainer. What is an important characteristic of this appliance?",
      options: [
        "Covers all teeth with thin clear plastic material",
        "Bonded permanently to lingual surfaces of anterior teeth",
        "Has acrylic palatal component with labial wire and adjustment bows",
        "Consists of sequential trays worn 20 hours daily",
      ],
      correct: "C"
    },
    {
      id: 23791,
      question: "A patient with fixed appliances asks about using a water flosser. What is the correct technique for irrigating around orthodontic brackets?",
      options: [
        "Direct stream into gingival sulcus at 45-degree angle",
        "Direct stream perpendicular to long axis of tooth",
        "Use highest pressure setting for maximum effectiveness",
        "Irrigate only once weekly to avoid tissue damage",
      ],
      correct: "B"
    },
    {
      id: 23792,
      question: "During a dental hygiene visit, you notice an orthodontic patient has excellent oral hygiene but moderate gingivitis. Which dentifrice provides antimicrobial benefits beyond fluoride for reducing gingival inflammation?",
      options: [
        "Sodium fluoride with silica abrasive formulation",
        "Stabilized stannous fluoride with stannous ion",
        "Calcium carbonate with sodium monofluorophosphate",
        "Any fluoride dentifrice provides equal benefits",
      ],
      correct: "B"
    },
    {
      id: 23793,
      question: "A patient is concerned about tooth whitening while wearing braces. What is the MOST appropriate recommendation regarding whitening during orthodontic treatment?",
      options: [
        "Professional whitening is recommended every 3 months",
        "Home whitening trays should be used nightly",
        "Whitening should be postponed until after treatment completion",
        "Whitening is most effective during active tooth movement",
      ],
      correct: "C"
    },
    {
      id: 23794,
      question: "You observe severe crowding in a patient's primary dentition. What does this finding predict about the permanent dentition?",
      options: [
        "Permanent teeth will have adequate space due to larger jaw size",
        "Crowding is almost certain in the permanent dentition",
        "Serial extraction in primary dentition prevents permanent crowding",
        "Primary crowding has no relationship to permanent dentition",
      ],
      correct: "B"
    },
    {
      id: 23795,
      question: "A patient with Class I malocclusion and severe crowding is treatment planned for serial extraction. What is the PRIMARY goal of this approach?",
      options: [
        "Eliminate need for any Phase II orthodontic treatment",
        "Reduce crowding during primary to permanent transition",
        "Prevent eruption of permanent second molars",
        "Create space for immediate implant placement",
      ],
      correct: "B"
    },
    {
      id: 23796,
      question: "During examination, you note a patient's primary second molars are in an end-to-end relationship. What does this indicate about future permanent occlusion?",
      options: [
        "Guaranteed Class I occlusion in permanent dentition",
        "Definite Class III malocclusion requiring surgery",
        "Possible lack of leeway space for premolar eruption",
        "Excess space requiring orthodontic space closure",
      ],
      correct: "C"
    },
    {
      id: 23797,
      question: "A patient lost a primary second molar prematurely and the first permanent molar has tipped mesially, closing space for the premolar. What amount of leeway space is typically available in the mandibular arch that has been lost?",
      options: [
        "1 mm average per quadrant",
        "3 mm average per quadrant",
        "5 mm average per quadrant",
        "10 mm average per quadrant",
      ],
      correct: "C"
    },
    {
      id: 23798,
      question: "You are educating a parent about a child's slight mandibular incisor crowding at age 8. What natural process may help resolve mild crowding as canines erupt?",
      options: [
        "Primary molars become larger creating more space",
        "Mandibular canines move distally into primate spaces",
        "Alveolar bone resorbs allowing incisor repositioning",
        "Incisors naturally become smaller through attrition",
      ],
      correct: "B"
    },
    {
      id: 23799,
      question: "An orthodontic patient presents with labial gingival recession on tooth #24 following arch expansion. What is the MOST likely cause of this recession?",
      options: [
        "Excessive force from tongue pressure during treatment",
        "Dehiscence in bone from labial tooth movement",
        "Normal physiologic response to tooth movement",
        "Bacterial infection from inadequate oral hygiene",
      ],
      correct: "B"
    },
    {
      id: 23800,
      question: "A patient asks how teeth actually move during orthodontic treatment. For how many hours per day must force be applied to affect tooth position?",
      options: [
        "At least 2 hours per day",
        "At least 6 hours per day",
        "At least 12 hours per day",
        "Continuous 24 hours per day",
      ],
      correct: "B"
    },
    {
      id: 23801,
      question: "You are reviewing biomechanics with an orthodontic resident. What structure contains undifferentiated mesenchymal cells that differentiate into fibroblasts and osteoblasts during tooth movement?",
      options: [
        "Enamel matrix surrounding clinical crown",
        "Dental pulp within root canal space",
        "Cementum layer covering root surface",
        "Periodontal ligament surrounding root",
      ],
      correct: "D"
    },
    {
      id: 23802,
      question: "A patient completed orthodontic treatment but returns 5 years later with relapse. What factor contributes to long-term orthodontic relapse in adults?",
      options: [
        "Facial skeletal growth patterns cease completely at age 18",
        "Adult skeletal growth continues with same patterns as adolescence",
        "Bone remodeling stops after age 25 preventing relapse",
        "Soft tissue forces have no effect on adult tooth position",
      ],
      correct: "B"
    },
    {
      id: 23803,
      question: "An orthodontist is collaborating with a periodontist for a patient with osseous defects. How can orthodontic tooth movement benefit periodontal outcomes?",
      options: [
        "Orthodontics always worsens existing periodontal defects",
        "Uprighting molars can improve osseous contours and bone levels",
        "Tooth movement has no effect on periodontal tissues",
        "Only surgical intervention improves periodontal conditions",
      ],
      correct: "B"
    },
    {
      id: 23804,
      question: "A patient asks about orthodontic site development for a future implant in the anterior region. What is an advantage of orthodontic forces for implant site preparation?",
      options: [
        "Implants can be placed during active tooth movement",
        "Orthodontics can generate bone creating more ideal recipient site",
        "Orthodontic site preparation is only for posterior sites",
        "Bone grafting is always superior to orthodontic site development",
      ],
      correct: "B"
    },
    {
      id: 23805,
      question: "You note a patient has a hopeless maxillary central incisor planned for extraction and implant placement. What orthodontic procedure before extraction can improve esthetics of the final implant restoration?",
      options: [
        "Intrusion of the tooth to reduce bone height",
        "Rotation of the tooth to change bone contours",
        "Extrusion of the tooth to improve marginal bone levels",
        "Immediate extraction without orthodontic preparation",
      ],
      correct: "C"
    },
    {
      id: 23806,
      question: "A young patient with severe impaction of a permanent first molar is referred for autotransplantation. At what stage of root development is this procedure MOST successful?",
      options: [
        "Complete root formation with closed apex",
        "Incomplete root development with open apex",
        "Root development is irrelevant to success",
        "Only after full crown formation is complete",
      ],
      correct: "B"
    },
    {
      id: 23807,
      question: "An orthodontic patient is referred to an orofacial myologist. What is a PRIMARY goal of orofacial myofunctional therapy (OMT)?",
      options: [
        "Accelerate orthodontic tooth movement rate",
        "Correct improper orofacial muscle movements and postures",
        "Prevent need for any orthodontic treatment",
        "Strengthen muscles to resist orthodontic forces",
      ],
      correct: "B"
    },
    {
      id: 23808,
      question: "You are coordinating care between the orthodontist and general dentist. What information should be communicated about a mutual orthodontic patient at each dental hygiene visit?",
      options: [
        "Only the patient's appointment attendance record",
        "Date of last visit, health history changes, oral health status, and appliance problems",
        "No communication is necessary between offices",
        "Only communicate if patient reports concerns",
      ],
      correct: "B"
    },
    {
      id: 23809,
      question: "A patient with fixed appliances is scheduled for dental hygiene visit the same day as an orthodontic adjustment. What is the MOST appropriate timing?",
      options: [
        "Schedule dental hygiene immediately after orthodontic adjustment",
        "Schedule dental hygiene before orthodontic adjustment when possible",
        "Timing makes no difference to patient comfort",
        "Delay dental hygiene visit for 2 weeks after adjustment",
      ],
      correct: "B"
    },
    {
      id: 23810,
      question: "During scaling procedures, you note a patient is experiencing significant discomfort 1 day after orthodontic adjustment. What explains this increased sensitivity?",
      options: [
        "Teeth are already painful from recent activation",
        "Local anesthetic is contraindicated during orthodontic treatment",
        "Scaling causes bracket debonding requiring replacement",
        "Pain perception is eliminated during active treatment",
      ],
      correct: "A"
    },
    {
      id: 23811,
      question: "An orthodontic patient asks about the force applied by the archwire. What unique property of orthodontic archwire metal creates constant light pressure?",
      options: [
        "Becomes more malleable when warmed in the mouth",
        "Tries to revert to its original shape when deflected",
        "Dissolves slowly releasing mineral ions for movement",
        "Attracts teeth through magnetic field generation",
      ],
      correct: "B"
    },
    {
      id: 23812,
      question: "You are explaining equilibrium theory to a patient. What forces maintain teeth in stable position without orthodontic appliances?",
      options: [
        "Heavy forces applied during chewing and mastication",
        "Light forces of tongue, cheeks, and lips at rest",
        "Periodontal ligament pulls teeth into bone",
        "Enamel matrix proteins prevent tooth movement",
      ],
      correct: "B"
    },
    {
      id: 23813,
      question: "A patient asks how long the periodontal ligament needs to reorganize after appliances are removed. What is the appropriate timeframe before retainers can be worn part-time?",
      options: [
        "2 weeks for complete PDL reorganization",
        "3-4 months for PDL reorganization and mobility reduction",
        "12 months before any retainer adjustments",
        "24 months matching active treatment duration",
      ],
      correct: "B"
    },
    {
      id: 23814,
      question: "During retention phase evaluation, you notice slight relapse of alignment. What component of the periodontium contributes MOST to orthodontic relapse after treatment?",
      options: [
        "Alveolar bone pulls teeth through magnetic attraction",
        "Elastic gingival fibers, especially transseptal fibers",
        "Cementum regeneration on pressure side of movement",
        "Pulpal tissue expansion within root canal",
      ],
      correct: "B"
    },
    {
      id: 23815,
      question: "A patient has a bonded lingual retainer from canine to canine. What is the PRIMARY purpose of this permanent retention?",
      options: [
        "Temporary stabilization for 3 months only",
        "Long-term control of alignment during late growth ages 16-20",
        "Correction of remaining malocclusion after treatment",
        "Replacement for removable retainer patient lost",
      ],
      correct: "B"
    },
    {
      id: 23816,
      question: "An adult patient with previous orthodontic treatment shows significant relapse 15 years later. What should you explain about adult facial growth?",
      options: [
        "All facial growth stops completely at age 18",
        "Small yearly changes accumulate significantly over decades",
        "Relapse only occurs if retainers were never worn",
        "Adult bone does not remodel after treatment",
      ],
      correct: "B"
    },
    {
      id: 23817,
      question: "You observe white spot lesions on an orthodontic patient's maxillary incisors. The lesions are visible without drying. What does this indicate about demineralization depth?",
      options: [
        "Lesion limited to outer enamel surface only",
        "Demineralization has progressed deeper within enamel",
        "Dentin is exposed and lesion is cavitated",
        "Lesion extends into pulp requiring endodontics",
      ],
      correct: "B"
    },
    {
      id: 23818,
      question: "A patient has extensive white spot lesions after debonding. What treatment approach combines fluoride varnish with another remineralization agent?",
      options: [
        "Chlorhexidine gluconate 0.12% rinse",
        "Casein phosphopeptide-amorphous calcium phosphate (CPP-ACP)",
        "Sodium fluoride 0.05% daily rinse",
        "Stannous fluoride 0.63% gel application",
      ],
      correct: "B"
    },
    {
      id: 23819,
      question: "An orthodontic patient asks if they should use an antimicrobial mouth rinse. Which rinse has strong evidence supporting antiplaque efficacy?",
      options: [
        "Hydrogen peroxide 1.5% rinse",
        "Essential oils with antiseptic formulation",
        "Sodium bicarbonate solution rinse",
        "Plain water rinse after meals",
      ],
      correct: "B"
    },
    {
      id: 23820,
      question: "You are instructing a patient on mechanical biofilm control with an interdental brush. For what clinical situation is an interdental brush MOST effective around orthodontic appliances?",
      options: [
        "Tight contacts between anterior teeth",
        "Large cervical embrasures or history of periodontal disease",
        "Normal healthy papillae filling embrasures",
        "Primary dentition with small tooth size",
      ],
      correct: "B"
    },
    {
      id: 23821,
      question: "A patient reports difficulty flossing under the archwire. What is an effective alternative aid that patients often find easier to use than floss?",
      options: [
        "Wooden toothpicks in holders only",
        "Dental water jet with orthodontic tip",
        "Proxy brushes are ineffective alternatives",
        "Cotton swabs for biofilm removal",
      ],
      correct: "B"
    },
    {
      id: 23822,
      question: "An orthodontic patient with high caries risk asks about daily fluoride use. What concentration of fluoride toothpaste may be prescribed for daily home use during treatment?",
      options: [
        "1000 ppm standard over-the-counter formulation",
        "1450 ppm European formulation concentration",
        "5000 ppm prescription strength formulation",
        "22,600 ppm professional varnish concentration",
      ],
      correct: "C"
    },
    {
      id: 23823,
      question: "You notice an interdental tip attachment on a patient's powered toothbrush. What is the PRIMARY benefit of this specialized tip during orthodontic treatment?",
      options: [
        "Replaces need for all interdental cleaning",
        "Removes brackets more effectively than manual brushing",
        "Disrupts interproximal plaque and stimulates papillae",
        "Whitens teeth while patient wears braces",
      ],
      correct: "C"
    },
    {
      id: 23824,
      question: "A parent asks if they should help their young child with oral hygiene around orthodontic appliances. What is the MOST appropriate recommendation?",
      options: [
        "Children should independently manage all oral care",
        "Parents should assist with oral hygiene around appliances",
        "Professional cleaning eliminates need for home care",
        "Oral hygiene is unnecessary until treatment completion",
      ],
      correct: "B"
    },
    {
      id: 23825,
      question: "An orthodontic patient presents with severe gingivitis despite good home care. Gingival tissue appears fibrotic rather than edematous. What is the MOST likely diagnosis?",
      options: [
        "Acute necrotizing ulcerative gingivitis requiring antibiotics",
        "Drug-influenced gingival overgrowth from phenytoin",
        "Normal tissue response to bracket placement",
        "Chronic periodontitis with bone loss present",
      ],
      correct: "B"
    },
    {
      id: 23826,
      question: "You are providing nutritional counseling to an orthodontic patient. What is the PRIMARY reason to eat sweets only as part of meals rather than between meals?",
      options: [
        "Meals provide buffering capacity neutralizing acids",
        "Limits number of acid attacks throughout the day",
        "Meal timing enhances bracket bond strength",
        "Between-meal snacks cause immediate bracket debonding",
      ],
      correct: "B"
    },
    {
      id: 23827,
      question: "A patient asks about the difference between orthodontic expansion and orthopedic expansion. What is achieved through orthopedic expansion during mixed dentition?",
      options: [
        "Tipping tooth crowns facially within alveolar bone",
        "Expanding underlying skeletal structures without tipping teeth",
        "Moving teeth without any skeletal changes",
        "Surgical separation of maxillary bones in adults",
      ],
      correct: "B"
    },
    {
      id: 23828,
      question: "An orthodontic patient has a posterior crossbite. The palate width is adequate, but maxillary posterior teeth incline lingually. What is the origin of this malocclusion?",
      options: [
        "Skeletal cause from narrow maxilla",
        "Dental cause from tooth inclination",
        "Combined skeletal and dental origin",
        "Functional cause from parafunctional habits",
      ],
      correct: "B"
    },
    {
      id: 23829,
      question: "You observe vertical facial proportions on a patient's profile photograph by dividing the face into three zones. The mandibular plane shows minimal incline. What malocclusion is typically associated with this finding?",
      options: [
        "Anterior open bite and long facial height",
        "Deep overbite and short facial height",
        "Class III with normal vertical proportions",
        "Posterior crossbite in transverse plane",
      ],
      correct: "B"
    },
    {
      id: 23830,
      question: "A patient's photographs show lip separation of 5 mm at rest with prominent lips in profile. What dental relationship may be contributing to this presentation?",
      options: [
        "Retruded maxillary and mandibular incisors",
        "Protrusive maxillary and mandibular incisors",
        "Normal incisor position and angulation",
        "Missing maxillary lateral incisors bilaterally",
      ],
      correct: "B"
    },
    {
      id: 23831,
      question: "During cephalometric analysis, you note the maxillary central incisor position needs evaluation. What radiographic image is specifically designed for this assessment?",
      options: [
        "Panoramic radiograph for full dentition view",
        "Lateral cephalometric radiograph for skeletal analysis",
        "Periapical radiograph for individual tooth detail",
        "Bitewing radiograph for interproximal assessment",
      ],
      correct: "B"
    },
    {
      id: 23832,
      question: "A patient presents with supernumerary teeth and narrow jaw. What is the origin of this malocclusion?",
      options: [
        "Environmental factors from parafunctional habits only",
        "Genetic discrepancies affecting skeletal or dental development",
        "Traumatic injury during tooth development",
        "Nutritional deficiency during childhood growth",
      ],
      correct: "B"
    },
    {
      id: 23833,
      question: "You are educating a patient about cone beam computed tomography (CBCT). What is a PRIMARY advantage of CBCT over conventional radiographs for orthodontic diagnosis?",
      options: [
        "Significantly lower radiation exposure to patient",
        "Produces 3D images of teeth, soft tissues, and bone",
        "Less expensive than panoramic radiographs",
        "Can be taken in general dental office easily",
      ],
      correct: "B"
    },
    {
      id: 23834,
      question: "An orthodontic patient has asthma and is a chronic mouth breather. Research correlates mouth breathing in children with which orthodontic findings?",
      options: [
        "Lower palatal vaults and decreased overjets",
        "Higher palatal vaults, greater overjets, and posterior crossbite",
        "Class III malocclusion with anterior crossbite",
        "Deep overbite with short facial height",
      ],
      correct: "B"
    },
    {
      id: 23835,
      question: "During TMJ assessment, you note clicking, restricted range of motion, and muscle tenderness. What should be documented during orthodontic evaluation?",
      options: [
        "These findings are normal and require no documentation",
        "Document all TMD signs and symptoms for evaluation",
        "TMJ assessment is not relevant to orthodontics",
        "Only document if patient reports severe pain",
      ],
      correct: "B"
    },
    {
      id: 23836,
      question: "A patient is beginning Phase II orthodontic treatment in permanent dentition after completing Phase I. What is the PRIMARY goal of Phase II treatment?",
      options: [
        "Correct initial structural skeletal problems only",
        "Active treatment with full braces for dental corrections",
        "Maintain space with retainers between phases",
        "Extract primary teeth to facilitate eruption",
      ],
      correct: "B"
    },
    {
      id: 23837,
      question: "You note a patient's treatment plan includes extraction of four first premolars. In the context of serial extraction, what is the intended eruption pattern?",
      options: [
        "Second premolars erupt into first premolar positions",
        "Canines erupt into first premolar extraction sites",
        "Second molars move mesially into premolar sites",
        "Lateral incisors drift distally into extraction spaces",
      ],
      correct: "B"
    },
    {
      id: 23838,
      question: "An 18-year-old patient asks about jaw surgery combined with orthodontics. What is the term for this combined surgical-orthodontic approach?",
      options: [
        "Interceptive orthodontics for early intervention",
        "Orthognathic surgery for severe skeletal discrepancies",
        "Serial extraction for crowding management",
        "Growth modification during development",
      ],
      correct: "B"
    },
    {
      id: 23839,
      question: "A patient has bisphosphonate medication history. How might this affect orthodontic treatment outcomes?",
      options: [
        "Accelerates bone turnover and tooth movement",
        "May slow bone turnover affecting movement",
        "No effect on orthodontic outcomes whatsoever",
        "Prevents any orthodontic treatment possibility",
      ],
      correct: "B"
    },
    {
      id: 23840,
      question: "You observe a patient is experiencing mentalis strain when closing lips over protrusive incisors. What does this clinical finding indicate?",
      options: [
        "Normal lip function and muscle activity",
        "Muscle strain from effort required to close lips",
        "Paralysis of mentalis muscle from nerve damage",
        "Excessive mandibular growth causing strain",
      ],
      correct: "B"
    },
    {
      id: 23841,
      question: "An orthodontic patient asks why temporary anchorage devices (TADs) might be recommended. What orthodontic problem can TADs help correct, potentially reducing need for surgery?",
      options: [
        "Simple tooth rotations and minor spacing",
        "Mild to moderate anterior open bite and vertical excess",
        "Congenitally missing teeth requiring space closure",
        "Class I malocclusion with normal skeletal relationships",
      ],
      correct: "B"
    },
    {
      id: 23842,
      question: "During assessment, you note a patient has both skeletal and dental components contributing to malocclusion. The maxilla is narrow AND the posterior teeth incline lingually, creating a crossbite. What is the origin classification?",
      options: [
        "Purely skeletal origin from jaw relationship",
        "Combined skeletal and dental origin malocclusion",
        "Purely dental origin from tooth positions",
        "Functional origin from parafunctional habits only",
      ],
      correct: "B"
    },
    {
      id: 23843,
      question: "A patient with completed orthodontic treatment returns for maintenance. What is a key responsibility of the dental hygienist during these visits?",
      options: [
        "Adjust orthodontic retainers and appliances",
        "Continually evaluate dentition for retention or relapse",
        "Provide new retainers when old ones are lost",
        "Determine if additional tooth movement is needed",
      ],
      correct: "B"
    },
    {
      id: 23844,
      question: "You are explaining the three developmental ages important in orthodontic treatment planning. What does dental age specifically refer to?",
      options: [
        "Patient's chronologic age in years and months",
        "Maturation of teeth including clinical eruption",
        "Development of the skeletal system structures",
        "Social and emotional development of patient",
      ],
      correct: "B"
    },
    {
      id: 23845,
      question: "An 11-year-old patient asks when their growth spurt will occur. Why is identifying the timing of the adolescent growth spurt important for orthodontic treatment?",
      options: [
        "Growth spurts have no relevance to treatment",
        "Allows planning to take advantage of rapid growth for modification",
        "Treatment must be delayed until after growth spurt",
        "Growth spurts only affect dental age, not skeletal",
      ],
      correct: "B"
    },
    {
      id: 23846,
      question: "A patient presents with thumbsucking habit affecting anterior tooth position. What is the etiologic classification of this malocclusion?",
      options: [
        "Genetic skeletal discrepancy from inheritance",
        "Trauma or parafunctional habit affecting development",
        "Dental malocclusion from tooth size discrepancy",
        "Normal developmental variation requiring no treatment",
      ],
      correct: "B"
    },
    {
      id: 23847,
      question: "You observe spacing in a 5-year-old patient's primary dentition. What is the significance of this finding for future orthodontic needs?",
      options: [
        "Spacing in primary dentition indicates severe crowding in permanent dentition",
        "Spacing is preferred in primary dentition providing room for larger permanent teeth",
        "Primary spacing always requires immediate orthodontic intervention",
        "Spacing means permanent teeth will be congenitally missing",
      ],
      correct: "B"
    }
  ],

  "4. Dental Prostheses (Case Study)": [
    {
      id: 23848,
      question: "A 68-year-old patient presents for a dental hygiene appointment wearing maxillary and mandibular complete dentures fabricated 12 years ago. She reports the dentures \"have never fit right\" and often cannot eat with them. What is the MOST appropriate continued-care interval recommendation for this patient?",
      options: [
        "Every 6 months for assessment and denture evaluation",
        "Annual visits only since she has no natural teeth",
        "Every 3 months until new dentures are fabricated",
        "No regular visits needed for edentulous patients",
      ],
      correct: "A"
    },
    {
      id: 23849,
      question: "During assessment of a 72-year-old edentulous patient, you note severe mandibular alveolar ridge resorption. The patient complains of pain and paresthesia in the lower lip and chin when wearing the denture. What is the MOST likely cause of these symptoms?",
      options: [
        "Acute allergic reaction to denture base material",
        "Compression of exposed mental nerve at ridge crest",
        "Chronic candidiasis infection under the denture",
        "Temporomandibular joint dysfunction from overclosure",
      ],
      correct: "B"
    },
    {
      id: 23850,
      question: "A 65-year-old patient with a maxillary complete denture presents with generalized redness of the palatal mucosa confined within the denture border. The tissue has a velvet-like appearance. What is the MOST likely diagnosis?",
      options: [
        "Acute traumatic ulceration from new denture",
        "Allergic reaction to denture adhesive material",
        "Denture stomatitis from chronic Candida infection",
        "Focal frictional hyperkeratosis from chronic rubbing",
      ],
      correct: "C"
    },
    {
      id: 23851,
      question: "You are assessing a patient with a mandibular removable partial denture that has metal clasps. The patient asks about cleaning methods. Which cleanser should be AVOIDED for this prosthesis?",
      options: [
        "Alkaline peroxide tablet soaked for 15 minutes",
        "Mild soap solution with soft denture brush",
        "Sodium hypochlorite solution for 10 minutes",
        "Commercial nonabrasive denture paste with brushing",
      ],
      correct: "C"
    },
    {
      id: 23852,
      question: "A 59-year-old patient who has been edentulous for 15 years presents with severely worn denture teeth and heavy calculus, biofilm, and stain accumulation. He stores dentures on the kitchen counter at night. What is the PRIMARY risk associated with leaving dentures out of water overnight?",
      options: [
        "Increased bacterial and fungal growth on dentures",
        "Warping and dimensional changes to acrylic base",
        "Faster deterioration of artificial tooth materials",
        "Loss of retention and stability when reinserted",
      ],
      correct: "B"
    },
    {
      id: 23853,
      question: "During oral assessment of a denture wearer, you observe folds of fibrous connective tissue on the vestibular mucosa at the denture flange contact. The tissue is asymptomatic with varying color. What condition is present?",
      options: [
        "Acute ulceration requiring immediate treatment",
        "Papillary hyperplasia needing antifungal therapy",
        "Denture-induced fibrous hyperplasia (epulis fissuratum)",
        "Focal hyperkeratosis that will resolve spontaneously",
      ],
      correct: "C"
    },
    {
      id: 23854,
      question: "A 75-year-old patient presents 6 months after receiving new complete dentures. She reports difficulty with speech that has persisted since denture delivery. What is the MOST appropriate recommendation?",
      options: [
        "This is normal and will resolve with more practice",
        "Refer to dentist for denture fit evaluation",
        "Recommend speech therapy consultation immediately",
        "Advise patient to wear dentures less frequently",
      ],
      correct: "B"
    },
    {
      id: 23855,
      question: "You are providing dietary counseling to an 80-year-old edentulous patient with ill-fitting dentures. The patient reports avoiding meat, vegetables, and fruits. What nutritional deficiency is MOST likely to develop?",
      options: [
        "Vitamin C deficiency affecting wound healing",
        "Iron deficiency causing generalized anemia",
        "Protein deficiency leading to tissue fragility",
        "Carbohydrate deficiency reducing energy levels",
      ],
      correct: "C"
    },
    {
      id: 23856,
      question: "A patient with a maxillary complete denture asks about proper overnight care. What is the MOST evidence-based recommendation for denture storage?",
      options: [
        "Store dry in a clean container",
        "Soak in diluted household bleach solution",
        "Keep in mouth during sleep for retention",
        "Submerge in hot water to sanitize",
      ],
      correct: "A"
    },
    {
      id: 23857,
      question: "During examination, you note cracked, eroded, and encrusted commissural folds in a denture-wearing patient with reduced vertical dimension. What is the MOST likely diagnosis?",
      options: [
        "Herpes simplex virus infection",
        "Angular cheilitis from mixed infection",
        "Traumatic ulceration from denture flange",
        "Allergic contact dermatitis from acrylic",
      ],
      correct: "B"
    },
    {
      id: 23858,
      question: "A 70-year-old patient reports that her maxillary complete denture becomes easily displaced when eating. On assessment, you evaluate retention by attempting to pull the anterior teeth forward. What structure provides the primary posterior seal?",
      options: [
        "Hard palate and maxillary tuberosities",
        "Posterior border seal of maxillary denture",
        "Buccal vestibule and labial flange",
        "Alveolar ridge and residual bone height",
      ],
      correct: "B"
    },
    {
      id: 23859,
      question: "You are educating a new denture wearer about masticatory efficiency. Compared to individuals with natural dentition, what percentage of masticatory efficiency can be expected with removable partial dentures?",
      options: [
        "Approximately 20% of natural dentition",
        "Approximately 50% of natural dentition",
        "Approximately 75% of natural dentition",
        "Equal to 100% of natural dentition",
      ],
      correct: "A"
    },
    {
      id: 23860,
      question: "A patient taking diuretics, antihypertensives, and antidepressants complains of difficulty with denture retention and burning sensations. What condition is MOST likely contributing to these symptoms?",
      options: [
        "Denture stomatitis from poor oral hygiene",
        "Xerostomia from medication side effects",
        "Allergic reaction to denture base materials",
        "Temporomandibular dysfunction from malocclusion",
      ],
      correct: "B"
    },
    {
      id: 23861,
      question: "During assessment of an edentulous patient, you palpate freely movable tissue over the mandibular ridge. The tissue appears nearly normal in color and texture. What condition is present?",
      options: [
        "Acute inflammatory response to trauma",
        "Denture-induced fibrous hyperplasia",
        "Normal healthy keratinized mucosa",
        "Early signs of oral squamous cell carcinoma",
      ],
      correct: "B"
    },
    {
      id: 23862,
      question: "A patient with Sjögren syndrome and severe xerostomia wears complete dentures. Which treatment option may help increase salivary flow for this patient?",
      options: [
        "Over-the-counter artificial saliva substitutes only",
        "Frequent sips of water throughout the day",
        "Prescription oral pilocarpine medication",
        "Application of petroleum jelly to oral tissues",
      ],
      correct: "C"
    },
    {
      id: 23863,
      question: "You are instructing a patient on cleaning a maxillary complete denture with a soft liner. Which cleaning method is MOST appropriate for this prosthesis?",
      options: [
        "Soft brush with soap and water or nonabrasive cleanser",
        "Alkaline peroxide tablet soaked overnight",
        "Sodium hypochlorite solution for 10 minutes",
        "Abrasive denture paste with vigorous scrubbing",
      ],
      correct: "A"
    },
    {
      id: 23864,
      question: "A 65-year-old patient presents with a maxillary removable partial denture and natural mandibular dentition. She has 4-5 mm loss of attachment and bleeding on probing. What is the recommended continued-care interval?",
      options: [
        "Annual visits only for denture evaluation",
        "Every 6 months for routine maintenance",
        "More frequent than 6 months due to periodontal condition",
        "Every 3 years when denture replacement needed",
      ],
      correct: "C"
    },
    {
      id: 23865,
      question: "During assessment, you observe multiple round-to-ovoid nodules with a cobblestone appearance on red mucosa under a maxillary denture. What condition is present?",
      options: [
        "Denture stomatitis requiring antifungal treatment",
        "Acute traumatic ulceration needing immediate care",
        "Papillary hyperplasia from mixed reactive and infectious causes",
        "Focal hyperkeratosis that will resolve with rest",
      ],
      correct: "C"
    },
    {
      id: 23866,
      question: "A patient with an implant-supported overdenture asks about cleaning methods. Which cleanser should be specifically AVOIDED for this prosthesis?",
      options: [
        "Mild soap with soft denture brush",
        "Alkaline peroxide commercial tablets",
        "Sodium hypochlorite solution damaging nylon attachments",
        "Nonabrasive denture paste with gentle brushing",
      ],
      correct: "C"
    },
    {
      id: 23867,
      question: "You are assessing a patient who underwent oral cancer surgery. The prosthesis closes an opening between the nasal and oral cavity. What type of prosthesis is this?",
      options: [
        "Conventional removable complete denture",
        "Implant-supported fixed partial denture",
        "Obturator prosthesis for defect closure",
        "Immediate denture placed after extraction",
      ],
      correct: "C"
    },
    {
      id: 23868,
      question: "A 55-year-old patient has a fixed partial denture (bridge) replacing the mandibular left second premolar and first molar. Which teeth serve as abutments for this prosthesis?",
      options: [
        "The missing second premolar and first molar",
        "The first premolar and second molar supporting the bridge",
        "The canine and third molar if present",
        "All remaining mandibular teeth bilaterally",
      ],
      correct: "B"
    },
    {
      id: 23869,
      question: "During patient education, you explain the components of a fixed partial denture. What term describes the artificial teeth that replace the missing teeth?",
      options: [
        "Abutments anchoring the prosthesis",
        "Retainers cementing the bridge",
        "Pontics occupying the edentulous space",
        "Connectors joining the components",
      ],
      correct: "C"
    },
    {
      id: 23870,
      question: "A new denture wearer asks about adapting to eating with dentures. What is the MOST important instruction for successful mastication?",
      options: [
        "Use anterior teeth for all biting and cutting",
        "Consume foods in smaller pieces and chew longer",
        "Eat only soft foods permanently after denture insertion",
        "Remove dentures for all meals initially",
      ],
      correct: "B"
    },
    {
      id: 23871,
      question: "You observe a white patch on the edentulous ridge of a denture wearer. The lesion is asymptomatic and appears to result from chronic rubbing. What is the MOST likely diagnosis?",
      options: [
        "Early oral squamous cell carcinoma",
        "Chronic candidiasis requiring antifungal treatment",
        "Focal (frictional) hyperkeratosis from denture",
        "Denture stomatitis with velvet-like appearance",
      ],
      correct: "C"
    },
    {
      id: 23872,
      question: "A patient reports continuous denture wear including overnight. What is the PRIMARY reason to recommend removing dentures for 8 hours every 24 hours?",
      options: [
        "Allow denture materials to rest and maintain shape",
        "Permit denture-bearing tissues to rest and recover",
        "Enable thorough cleaning of denture surfaces",
        "Prevent staining and calculus accumulation",
      ],
      correct: "B"
    },
    {
      id: 23873,
      question: "During assessment of a denture wearer, you note exposure of the mandibular canal contents due to severe ridge resorption. What symptom is the patient MOST likely experiencing?",
      options: [
        "Improved denture stability and retention",
        "Increased comfort when wearing denture",
        "Increased discomfort and pain from compression",
        "No symptoms since nerves are not exposed",
      ],
      correct: "C"
    },
    {
      id: 23874,
      question: "A patient asks about the resorption rate between maxillary and mandibular alveolar ridges. What is the accurate comparison?",
      options: [
        "Maxillary ridge resorbs faster than mandibular",
        "Mandibular ridge resorbs faster than maxillary",
        "Both ridges resorb at equal rates",
        "Neither ridge experiences significant resorption",
      ],
      correct: "B"
    },
    {
      id: 23875,
      question: "You are counseling an edentulous patient about factors contributing to alveolar bone resorption. Which systemic condition accelerates bone loss?",
      options: [
        "Well-controlled type 2 diabetes mellitus",
        "Postmenopausal osteoporosis and calcium-poor diet",
        "Hypothyroidism with hormone replacement therapy",
        "Controlled hypertension with medication compliance",
      ],
      correct: "B"
    },
    {
      id: 23876,
      question: "A patient with palatal and mandibular tori is being evaluated for complete dentures. What is the recommended treatment for these bony irregularities before prosthesis construction?",
      options: [
        "No treatment needed as tori do not affect dentures",
        "Surgical removal to prevent mucosal irritation",
        "Relining dentures annually to accommodate tori",
        "Using soft liners permanently over tori areas",
      ],
      correct: "B"
    },
    {
      id: 23877,
      question: "During denture assessment, you note the patient has difficulty displacing the prosthesis away from supporting tissues. What does successful posterior seal evaluation indicate?",
      options: [
        "Poor retention requiring denture replacement",
        "Adequate retention and proper posterior seal",
        "Need for immediate denture adhesive use",
        "Presence of inflammatory tissue changes",
      ],
      correct: "B"
    },
    {
      id: 23878,
      question: "A patient presents with a traumatic ulcer from an elongated buccal flange of the maxillary denture. The lesion has a yellow-white exudate with a red halo. What is the MOST appropriate initial management?",
      options: [
        "Prescribe systemic antibiotics for infection",
        "Apply topical antifungal cream to lesion",
        "Refer to dentist for denture adjustment",
        "Recommend over-the-counter pain medication only",
      ],
      correct: "C"
    },
    {
      id: 23879,
      question: "You are educating a patient about denture-related nutritional considerations. Which nutrient deficiency can manifest as angular cheilitis?",
      options: [
        "Vitamin A (retinol) deficiency",
        "Vitamin B (riboflavin) deficiency",
        "Vitamin D (calciferol) deficiency",
        "Vitamin K (phylloquinone) deficiency",
      ],
      correct: "B"
    },
    {
      id: 23880,
      question: "A 70-year-old edentulous patient shows signs of dehydration including xerostomia and smooth atrophic tongue. What is the BEST dietary recommendation?",
      options: [
        "Increase intake of coffee and caffeinated beverages",
        "Consume vegetable soup for water and nutrients",
        "Drink only fruit juices throughout the day",
        "Avoid all liquids with meals to prevent aspiration",
      ],
      correct: "B"
    },
    {
      id: 23881,
      question: "During assessment of denture stability, you observe movement during normal oral functions. What aspect of the prosthesis is being evaluated?",
      options: [
        "Retention or resistance to vertical displacement",
        "Stability or resistance to lateral movement",
        "Support from underlying hard and soft tissues",
        "Occlusion or contact between maxillary and mandibular teeth",
      ],
      correct: "B"
    },
    {
      id: 23882,
      question: "A patient asks about the longevity of complete dentures. What is the typical timeframe for denture replacement?",
      options: [
        "Every 1-2 years due to wear and tear",
        "Every 4-8 years with annual adjustments",
        "Every 10-15 years if well maintained",
        "Dentures last lifetime without replacement",
      ],
      correct: "B"
    },
    {
      id: 23883,
      question: "You observe irregular sharp bony spikes on the mylohyoid ridge of an edentulous patient. What symptom is MOST likely if mucous membrane becomes trapped?",
      options: [
        "Improved denture retention and stability",
        "Enhanced comfort during mastication",
        "Considerable pain from tissue compression",
        "No symptoms as tissue adapts quickly",
      ],
      correct: "C"
    },
    {
      id: 23884,
      question: "A denture wearer presents with large maxillary tuberosities. What problem can these bony irregularities cause?",
      options: [
        "Improved denture retention and stability",
        "Enhanced posterior seal of maxillary denture",
        "Uncomfortable undercuts and unsatisfactory fit",
        "Better distribution of masticatory forces",
      ],
      correct: "C"
    },
    {
      id: 23885,
      question: "During patient education about denture care, what is the PRIMARY rationale for daily mechanical cleansing?",
      options: [
        "Prevent denture material deterioration and discoloration",
        "Remove biofilm, stain, and calculus preventing mucosal irritation",
        "Maintain denture aesthetics for social acceptance",
        "Reduce frequency of professional dental visits",
      ],
      correct: "B"
    },
    {
      id: 23886,
      question: "A patient with denture stomatitis is prescribed nystatin cream. What is the correct application method for MAXIMUM effectiveness?",
      options: [
        "Apply only to affected oral tissues",
        "Apply only to denture tissue surface",
        "Apply to both affected tissues and dentures",
        "Apply to dentures only during overnight soaking",
      ],
      correct: "C"
    },
    {
      id: 23887,
      question: "You are instructing a patient on use of topical antifungal agents for chronic candidiasis. How long should treatment continue after symptom resolution?",
      options: [
        "Stop immediately when symptoms disappear",
        "Continue approximately 1 week after symptoms resolve",
        "Continue for exactly 2 weeks regardless of symptoms",
        "Continue indefinitely to prevent recurrence",
      ],
      correct: "B"
    },
    {
      id: 23888,
      question: "A 62-year-old patient reports her removable partial denture with metal clasps has a broken supporting clasp. What is the MOST appropriate recommendation?",
      options: [
        "Use denture adhesive to stabilize the prosthesis",
        "Apply denture repair kit at home immediately",
        "Return to dentist for professional repair",
        "Continue wearing denture until next annual visit",
      ],
      correct: "C"
    },
    {
      id: 23889,
      question: "During assessment, you note a patient's complete denture has soft liner material with debris accumulation. Which problem is MOST associated with poorly cleaned soft liners?",
      options: [
        "Improved tissue health and comfort",
        "Enhanced denture retention and stability",
        "Halitosis and Candida albicans growth",
        "Reduced need for denture replacement",
      ],
      correct: "C"
    },
    {
      id: 23890,
      question: "A patient asks about nutritional goals for maintaining oral health with dentures. Which recommendation is MOST important for alveolar bone maintenance?",
      options: [
        "Limit intake of all dairy products",
        "Obtain adequate calcium from dairy or nondairy sources",
        "Consume high amounts of simple sugars",
        "Avoid all protein-rich meat and fish",
      ],
      correct: "B"
    },
    {
      id: 23891,
      question: "You observe that an edentulous patient prefers soft foods high in carbohydrates and refined sugar while avoiding protein-rich foods. What is the PRIMARY concern?",
      options: [
        "This diet promotes optimal oral and systemic health",
        "This pattern leads to nutritional imbalances and deficiencies",
        "Soft diet is ideal for all denture wearers",
        "High carbohydrate intake strengthens alveolar bone",
      ],
      correct: "B"
    },
    {
      id: 23892,
      question: "A patient with removable partial denture asks about denture adhesive use. When is adhesive use appropriate?",
      options: [
        "Routinely with all stable and retentive prostheses",
        "Never under any circumstances",
        "Small amount under dentist's supervision if needed",
        "Large amounts daily to ensure retention",
      ],
      correct: "C"
    },
    {
      id: 23893,
      question: "During denture cleaning instruction, you demonstrate proper brushing technique. Why must the denture be held firmly over a water-filled basin?",
      options: [
        "Water activates the cleaning solution chemically",
        "Prevents damage if denture is accidentally dropped",
        "Ensures even distribution of cleanser on surfaces",
        "Allows visualization of all denture surfaces",
      ],
      correct: "B"
    },
    {
      id: 23894,
      question: "A patient taking cortisone, thyroid hormone, and estrogen complains of chronic mucosal tissue soreness under dentures. What is the MOST likely cause?",
      options: [
        "Acute allergic reaction to denture base",
        "Chronic medication effects perpetuating soreness",
        "Traumatic ulceration from ill-fitting denture",
        "Candida infection requiring antifungal treatment",
      ],
      correct: "B"
    },
    {
      id: 23895,
      question: "You are assessing a patient who wears dentures continuously overnight. What oral condition is MOST commonly associated with this practice?",
      options: [
        "Improved tissue health from constant stimulation",
        "Enhanced bone density and ridge height",
        "Increased risk for denture stomatitis development",
        "Better denture adaptation and retention",
      ],
      correct: "C"
    },
    {
      id: 23896,
      question: "A denture wearer presents with a yellow membrane covering a chronic ulcer with an elevated margin and little pain. What is the MOST likely diagnosis?",
      options: [
        "Acute traumatic ulcer requiring immediate treatment",
        "Chronic ulcer from ill-fitting prosthesis or chemical irritation",
        "Denture stomatitis with generalized redness",
        "Papillary hyperplasia with cobblestone appearance",
      ],
      correct: "B"
    },
    {
      id: 23897,
      question: "During patient education, you explain masticatory force differences with complete dentures. Compared to natural dentition, biting forces with complete dentures are typically how much less?",
      options: [
        "Equal to natural dentition forces",
        "Two times less than natural forces",
        "Nearly five times less than natural forces",
        "Ten times less than natural forces",
      ],
      correct: "C"
    },
    {
      id: 23898,
      question: "A patient asks why chewing ability declines with complete dentures. What is the PRIMARY reason beyond loss of periodontal support?",
      options: [
        "Denture teeth are made of softer materials",
        "Loss of periodontal proprioception feedback",
        "Masticatory muscles become paralyzed",
        "Tongue function is completely eliminated",
      ],
      correct: "B"
    },
    {
      id: 23899,
      question: "You are counseling a new denture wearer about foods to avoid. Which recommendation is MOST important initially?",
      options: [
        "Consume only liquid diet permanently",
        "Avoid repeated anterior incisal biting, gum chewing, sticky foods",
        "Eat all foods normally without modifications",
        "Use only anterior teeth for all biting",
      ],
      correct: "B"
    },
    {
      id: 23900,
      question: "A patient with complete dentures complains of difficulty swallowing. What is a potential contributing factor related to tooth loss?",
      options: [
        "Increased saliva production improving swallowing",
        "Loss of teeth and structures affecting oral function",
        "Enhanced tongue mobility aiding deglutition",
        "Improved pharyngeal muscle coordination",
      ],
      correct: "B"
    },
    {
      id: 23901,
      question: "During assessment of edentulous oral tissues, you note a smooth, atrophic tongue and cracked lips. What condition should be considered?",
      options: [
        "Excessive vitamin supplementation toxicity",
        "B-complex vitamin deficiency requiring evaluation",
        "Normal age-related changes needing no treatment",
        "Acute viral infection requiring antibiotics",
      ],
      correct: "B"
    },
    {
      id: 23902,
      question: "A patient asks about the relationship between denture wearing and oral cancer. What is the MOST accurate statement?",
      options: [
        "Dentures directly cause oral squamous cell carcinoma",
        "Denture irritation may be cocarcinogenic in predisposed individuals",
        "Denture wearers never develop oral cancer",
        "All denture-related lesions are malignant",
      ],
      correct: "B"
    },
    {
      id: 23903,
      question: "You observe signs of atrophic glossitis in a denture-wearing patient. What should be included in the differential diagnosis?",
      options: [
        "Excessive protein intake causing tissue changes",
        "Either B-complex vitamin deficiency or Candida infection",
        "Normal finding in all denture wearers",
        "Acute bacterial infection requiring antibiotics",
      ],
      correct: "B"
    },
    {
      id: 23904,
      question: "A patient presents with uncontrollable tongue and facial movements. Which medication type is MOST likely responsible?",
      options: [
        "Antihypertensive medications for blood pressure",
        "Psychotropic medications for mental health",
        "Antibiotic medications for infections",
        "Analgesic medications for pain relief",
      ],
      correct: "B"
    },
    {
      id: 23905,
      question: "During nutritional counseling for an edentulous older adult, you recommend protein-rich foods. What is the PRIMARY reason for this recommendation?",
      options: [
        "Prevent tissue fragility and maintain muscle mass",
        "Increase rate of alveolar bone resorption",
        "Enhance xerostomia and dry mouth symptoms",
        "Reduce calcium absorption from diet",
      ],
      correct: "A"
    },
    {
      id: 23906,
      question: "A patient asks about preparing meat and fish to maximize nutrition with dentures. What cooking method is MOST beneficial?",
      options: [
        "Deep frying to seal in nutrients",
        "Broiling or boiling to break down proteins",
        "Raw consumption for maximum nutrition",
        "Grilling at high temperatures exclusively",
      ],
      correct: "B"
    },
    {
      id: 23907,
      question: "You are assessing a patient with reduced vertical dimension wearing complete dentures. What facial change is MOST likely visible?",
      options: [
        "Increased facial height and lip support",
        "Loss of facial height and sunken appearance",
        "No change in facial appearance",
        "Enhanced chin prominence only",
      ],
      correct: "B"
    },
    {
      id: 23908,
      question: "A denture wearer reports difficulty with speech articulation. How long should transient speech problems typically last before indicating prosthesis evaluation?",
      options: [
        "Immediate resolution within 24 hours",
        "Resolution within a few weeks with practice",
        "Permanent speech impairment is expected",
        "Six months minimum before evaluation",
      ],
      correct: "B"
    },
    {
      id: 23909,
      question: "During patient education, you recommend reading aloud and articulating in front of a mirror. What is the purpose of this exercise?",
      options: [
        "Strengthen masticatory muscles for chewing",
        "Facilitate adaptation to speaking with dentures",
        "Improve tongue muscle tone and coordination",
        "Prevent temporomandibular joint dysfunction",
      ],
      correct: "B"
    },
    {
      id: 23910,
      question: "A patient with dentures asks about water intake recommendations. How many glasses of water should be consumed daily?",
      options: [
        "Two glasses to prevent overhydration",
        "Four glasses for adequate hydration",
        "Eight glasses essential for body functions",
        "Twelve glasses to compensate for dentures",
      ],
      correct: "C"
    },
    {
      id: 23911,
      question: "You observe wrinkled skin, dry eyes, xerostomia, and smooth atrophic tongue in an edentulous older adult. What condition is present?",
      options: [
        "Normal healthy aging process",
        "Tissue dehydration requiring intervention",
        "Excessive fluid intake causing edema",
        "Acute infectious disease process",
      ],
      correct: "B"
    },
    {
      id: 23912,
      question: "A patient taking digitalis, nitroglycerin, and Valium wears complete dentures. What should be assessed regarding these medications?",
      options: [
        "No oral effects from these medications",
        "Potential effects on oral environment and tissues",
        "Only Valium affects denture wearing ability",
        "Medications improve denture retention significantly",
      ],
      correct: "B"
    },
    {
      id: 23913,
      question: "During assessment, you note severe biofilm and calculus on a denture cleaned with diluted household bleach occasionally. What is the PRIMARY problem with this cleaning method?",
      options: [
        "Bleach is too effective removing all deposits",
        "Infrequent cleaning allows heavy accumulation",
        "Bleach concentration is always correct",
        "Method is ideal for all dentures",
      ],
      correct: "B"
    },
    {
      id: 23914,
      question: "A patient asks about using an ultrasonic cleaning device for dentures. What is the PRIMARY advantage of this method?",
      options: [
        "Completely replaces need for brushing",
        "Enhances effectiveness of chemical cleansers",
        "Damages denture materials beneficially",
        "Works only without any cleaning solution",
      ],
      correct: "B"
    },
    {
      id: 23915,
      question: "You are recommending denture cleansers to a patient. What is the PRIMARY mechanism of alkaline peroxide cleansers?",
      options: [
        "Chemical dissolution of all organic matter",
        "Mechanical effect from oxygen release bubbling",
        "Abrasive action removing surface layers",
        "Acid etching of denture surfaces",
      ],
      correct: "B"
    },
    {
      id: 23916,
      question: "A patient with a metal partial denture used sodium hypochlorite solution for cleaning. What problem is MOST likely to occur?",
      options: [
        "Enhanced appearance and cleanliness",
        "Metal corrosion and damage to framework",
        "Improved denture retention and fit",
        "No effects on metal components",
      ],
      correct: "B"
    },
    {
      id: 23917,
      question: "During patient education about denture cleaning, what is the PRIMARY disadvantage of alkaline peroxide cleansers?",
      options: [
        "Too effective at removing all deposits",
        "Not very effective removing calculus deposits",
        "Damage to all types of denture materials",
        "Stain denture teeth permanently",
      ],
      correct: "B"
    },
    {
      id: 23918,
      question: "A patient asks about microwave radiation for denture disinfection. What is the PRIMARY concern with this method?",
      options: [
        "No antimicrobial effect whatsoever",
        "High temperatures may affect dimensional stability",
        "Enhances denture retention significantly",
        "Recommended for daily home use",
      ],
      correct: "B"
    },
    {
      id: 23919,
      question: "You observe an edentulous patient using a soft toothbrush to clean oral mucosa. What is the correct brushing direction for tissue cleansing?",
      options: [
        "Circular motions in all areas",
        "Long strokes posterior-to-anterior direction",
        "Horizontal strokes side-to-side",
        "Short vertical strokes only",
      ],
      correct: "B"
    },
    {
      id: 23920,
      question: "A patient asks about massaging edentulous tissues daily. What is the proper technique using fingers?",
      options: [
        "Continuous firm pressure without releasing",
        "Applying pressure then releasing continually along ridge",
        "Massaging only with abrasive materials",
        "Avoiding all tissue contact completely",
      ],
      correct: "B"
    },
    {
      id: 23921,
      question: "During denture assessment, you evaluate the impression (inner) surface. What aspect of the denture is being examined?",
      options: [
        "External polished surface visible to others",
        "Internal tissue-bearing surface contacting mucosa",
        "Occlusal surface contacting opposing teeth",
        "Denture border extensions into vestibule",
      ],
      correct: "B"
    },
    {
      id: 23922,
      question: "A patient with a maxillary complete denture asks about the palatal coverage. Which surface is examined when assessing denture cleanliness?",
      options: [
        "Cameo or polished outer surface only",
        "Both intaglio (impression) and cameo surfaces",
        "Only occlusal surfaces of teeth",
        "Border areas exclusively",
      ],
      correct: "B"
    },
    {
      id: 23923,
      question: "You are instructing a patient on removing complete dentures. What should the patient do FIRST before attempting removal?",
      options: [
        "Apply denture adhesive for grip",
        "Rinse mouth with hot water",
        "Gently displace denture away from tissues",
        "Use sharp instruments to pry denture",
      ],
      correct: "C"
    },
    {
      id: 23924,
      question: "A patient with an athletic mouth guard asks about cleaning methods. Which cleanser is appropriate for this oral appliance?",
      options: [
        "Only hot water and soap",
        "Same methods as denture cleaning",
        "No cleaning ever required",
        "Abrasive powders exclusively",
      ],
      correct: "B"
    },
    {
      id: 23925,
      question: "During patient education, you discuss care of an orthodontic retainer. What cleaning method is MOST appropriate?",
      options: [
        "Boiling in water for sterilization",
        "Brushing with nonabrasive cleanser",
        "Soaking in concentrated bleach",
        "No cleaning necessary",
      ],
      correct: "B"
    },
    {
      id: 23926,
      question: "A patient with a bruxing nightguard reports bad taste and odor. What is the MOST likely cause?",
      options: [
        "Inadequate cleaning allowing debris accumulation",
        "Normal characteristic of acrylic materials",
        "Too frequent cleaning damaging materials",
        "Appropriate cleaning is occurring",
      ],
      correct: "A"
    },
    {
      id: 23927,
      question: "You are assessing a patient with a sleep apnea appliance. What is the PRIMARY purpose of this oral device?",
      options: [
        "Prevent tooth grinding during sleep",
        "Open the airway and prevent snoring",
        "Deliver fluoride during sleep",
        "Maintain teeth whitening results",
      ],
      correct: "B"
    },
    {
      id: 23928,
      question: "A patient asks about care of a custom fluoride tray. What is the PRIMARY purpose of this appliance?",
      options: [
        "Prevent tooth grinding at night",
        "Hold prescription fluoride against teeth",
        "Support tissues after surgery",
        "Reposition teeth orthodontically",
      ],
      correct: "B"
    },
    {
      id: 23929,
      question: "During assessment, you note a patient has a fixed space maintainer. What is the PRIMARY purpose of this appliance?",
      options: [
        "Replace missing teeth functionally",
        "Maintain space until permanent tooth erupts",
        "Prevent tongue thrusting habits",
        "Deliver medications to tissues",
      ],
      correct: "B"
    },
    {
      id: 23930,
      question: "A patient with a stent after periodontal surgery asks about its purpose. What is the PRIMARY function of this device?",
      options: [
        "Replace missing teeth esthetically",
        "Stabilize tissues and hold medicinal agents",
        "Prevent grinding during healing",
        "Whiten teeth during recovery",
      ],
      correct: "B"
    },
    {
      id: 23931,
      question: "You observe a patient wearing bleaching trays. What precaution should be emphasized about cleaning these appliances?",
      options: [
        "Use abrasive cleansers for thorough cleaning",
        "Clean gently to avoid damaging thin material",
        "Never clean to preserve whitening agent",
        "Boil daily for sterilization",
      ],
      correct: "B"
    },
    {
      id: 23932,
      question: "A patient asks about the difference between an immediate denture and a conventional complete denture. What is the PRIMARY characteristic of an immediate denture?",
      options: [
        "Placed several months after extractions",
        "Placed immediately after tooth extraction",
        "Never requires relining or adjustment",
        "Lasts longer than conventional dentures",
      ],
      correct: "B"
    },
    {
      id: 23933,
      question: "During assessment of a patient's oral hygiene status with a fixed partial denture, you note heavy biofilm under the pontic. What interdental aid is MOST appropriate?",
      options: [
        "Traditional dental floss only",
        "Floss threaders or variable-diameter floss",
        "No cleaning possible under pontics",
        "Wooden toothpicks exclusively",
      ],
      correct: "B"
    },
    {
      id: 23934,
      question: "A patient with a fixed bridge asks about daily care. What is the MOST important instruction for maintaining oral health?",
      options: [
        "Avoid brushing to prevent damage",
        "Brush and floss bridge and natural teeth daily",
        "Use only mouth rinse without brushing",
        "Clean professionally only, no home care",
      ],
      correct: "B"
    },
    {
      id: 23935,
      question: "You are educating a patient about periodontal health with a fixed partial denture. What structure requires meticulous cleaning to prevent disease?",
      options: [
        "Only the pontic artificial teeth",
        "Abutment teeth and areas under pontic",
        "No cleaning needed for fixed prostheses",
        "Only opposing natural teeth",
      ],
      correct: "B"
    },
    {
      id: 23936,
      question: "A patient presents with a 6 mm pocket on the mesial surface of an abutment tooth supporting a bridge. What is the significance of this finding?",
      options: [
        "Normal and healthy finding",
        "Indicates potential periodontal disease requiring treatment",
        "Expected with all fixed bridges",
        "Requires no intervention or monitoring",
      ],
      correct: "B"
    },
    {
      id: 23937,
      question: "During assessment, you measure 2 mm of generalized recession in a patient with a fixed partial denture. What does this finding indicate?",
      options: [
        "Excellent oral hygiene and health",
        "Potential periodontal tissue loss requiring monitoring",
        "Normal expected change with bridges",
        "Need for immediate bridge removal",
      ],
      correct: "B"
    },
    {
      id: 23938,
      question: "A patient with a removable partial denture retains mandibular anterior teeth from canine to canine. What type of prosthesis does this patient have?",
      options: [
        "Complete denture replacing all teeth",
        "Partial denture replacing some teeth",
        "Fixed bridge cemented permanently",
        "Implant-supported overdenture",
      ],
      correct: "B"
    },
    {
      id: 23939,
      question: "You observe retainer clasps around natural teeth supporting a removable prosthesis. What component of the partial denture is visible?",
      options: [
        "Pontics replacing missing teeth",
        "Clasps providing retention on abutments",
        "Denture base covering ridge",
        "Major connector joining sides",
      ],
      correct: "B"
    },
    {
      id: 23940,
      question: "A patient asks about the major connector of a removable partial denture. What is the PRIMARY function of this component?",
      options: [
        "Replace individual missing teeth",
        "Join the right and left sides of prosthesis",
        "Provide retention around teeth",
        "Cover the edentulous ridge",
      ],
      correct: "B"
    },
    {
      id: 23941,
      question: "During prosthesis assessment, you examine the denture base. What structure does this component replace?",
      options: [
        "Only the missing teeth",
        "Missing teeth and surrounding alveolar bone",
        "Only the gingival tissues",
        "The entire palate exclusively",
      ],
      correct: "B"
    },
    {
      id: 23942,
      question: "A newly edentulous patient asks about adjustment needs in the first year. What is the typical timeframe for initial denture adjustment?",
      options: [
        "Never requires any adjustments",
        "Commonly requires adjustment within 6-12 months",
        "Wait minimum 5 years before adjustment",
        "Daily adjustments needed indefinitely",
      ],
      correct: "B"
    },
    {
      id: 23943,
      question: "You are discussing continued care with an edentulous patient. What is the PRIMARY reason for annual professional assessment?",
      options: [
        "Dentures last forever without changes",
        "Identify tissue changes, prosthesis wear, and needed modifications",
        "Only for denture cleaning services",
        "No professional care needed",
      ],
      correct: "B"
    }
  ],

  "5. Tooth Sensitivity (Case Study)": [
    {
      id: 23944,
      question: "A 28-year-old patient complains of sharp, transient pain when drinking cold beverages. Clinical examination reveals exposed dentin on the buccal surfaces of teeth #6 and #11 with no caries present. What type of nerve fibers are primarily responsible for this sharp, well-localized pain?",
      options: [
        "Myelinated A-delta fibers responding to peripheral stimuli",
        "Unmyelinated C-fibers transmitting dull aching pain",
        "A-beta fibers responding only to electrical stimulation",
        "Parasympathetic fibers regulating salivary flow",
      ],
      correct: "A"
    },
    {
      id: 23945,
      question: "A dental hygienist is examining a patient who reports sensitivity to cold and sweet foods on tooth #22. Microscopic analysis would reveal what characteristic difference between this sensitive dentin and nonsensitive dentin?",
      options: [
        "Sensitive dentin has fewer tubules with smaller diameter openings",
        "Sensitive dentin has eight times more open tubules with twice the diameter",
        "Sensitive dentin has completely calcified smear layer coverage",
        "Sensitive dentin has tubules occluded by mineral compounds",
      ],
      correct: "B"
    },
    {
      id: 23946,
      question: "During a patient assessment, you observe gingival recession on teeth #6, #7, and #11. According to the hydrodynamic theory, what mechanism explains the transmission of pain stimuli in dentinal hypersensitivity?",
      options: [
        "Direct nerve ending exposure to oral cavity stimuli",
        "Chemical dissolution of enamel exposing nerve endings",
        "Fluid movement within dentinal tubules acting as transducing medium",
        "Bacterial invasion into pulp chamber causing inflammation",
      ],
      correct: "C"
    },
    {
      id: 23947,
      question: "A 45-year-old patient presents with localized gingival recession on the buccal surfaces of maxillary premolars. Which factor is MOST commonly associated with gingival recession leading to dentinal hypersensitivity?",
      options: [
        "Excessive fluoride intake causing enamel hypoplasia",
        "Genetic predisposition to thin enamel formation",
        "Systemic diseases affecting immune system function",
        "Bacterial plaque biofilm and inadequate oral hygiene",
      ],
      correct: "D"
    },
    {
      id: 23948,
      question: "You are assessing a 35-year-old patient who complains of tooth sensitivity. The patient brushes vigorously three times daily with a hard-bristled toothbrush using horizontal strokes. What type of tooth structure loss is MOST likely occurring?",
      options: [
        "Abrasion from mechanical wear by brushing",
        "Erosion from chemical acid dissolution process",
        "Attrition from tooth-to-tooth contact during mastication",
        "Abfraction from occlusal compression forces only",
      ],
      correct: "A"
    },
    {
      id: 23949,
      question: "A patient presents with cervical tooth structure loss in a wedge-shaped pattern on teeth #6 and #27. The patient reports grinding teeth at night. What is the PRIMARY cause of this tooth structure loss?",
      options: [
        "Erosion from frequent consumption of acidic beverages",
        "Abfraction from flexion and compression forces",
        "Attrition from normal masticatory forces alone",
        "Abrasion from improper flossing technique",
      ],
      correct: "B"
    },
    {
      id: 23950,
      question: "During examination, you note that when teeth are brushed, enamel abrades how much more slowly compared to cementum?",
      options: [
        "Enamel abrades 10 times slower than cementum",
        "Enamel abrades 20 times slower than cementum",
        "Enamel abrades 35 times slower than cementum",
        "Enamel abrades 50 times slower than cementum",
      ],
      correct: "C"
    },
    {
      id: 23951,
      question: "A 52-year-old patient with bulimia presents with significant enamel loss on the lingual surfaces of maxillary anterior teeth. What type of tissue loss is occurring?",
      options: [
        "Abrasion from mechanical forces of toothbrushing",
        "Attrition from excessive masticatory forces",
        "Abfraction from occlusal trauma and bruxism",
        "Intrinsic erosion from acid regurgitation",
      ],
      correct: "D"
    },
    {
      id: 23952,
      question: "A patient reports sensitivity following scaling and root planing performed two weeks ago. What is the MOST likely explanation for this post-treatment sensitivity?",
      options: [
        "Removal of protective cementum exposing tubular dentin",
        "Permanent damage to pulpal nerve tissue",
        "Development of acute periapical abscess",
        "Allergic reaction to anesthetic agent used",
      ],
      correct: "A"
    },
    {
      id: 23953,
      question: "A 25-year-old patient who recently completed at-home tooth whitening treatment complains of increased tooth sensitivity. What should you recommend to minimize this side effect?",
      options: [
        "Discontinue all oral hygiene practices temporarily",
        "Use concurrent fluoride therapy and follow usage instructions",
        "Increase bleaching frequency to accelerate adaptation",
        "Switch to higher concentration bleaching products",
      ],
      correct: "B"
    },
    {
      id: 23954,
      question: "According to epidemiologic data, what is the reported prevalence range of dentinal hypersensitivity in the general population?",
      options: [
        "1.0% to 10.5% of the population",
        "70.0% to 85.0% of the population",
        "4.8% to 62.3% of the population",
        "90.0% to 100% of older adults",
      ],
      correct: "C"
    },
    {
      id: 23955,
      question: "A 60-year-old patient reports decreased tooth sensitivity compared to when they were younger. What physiologic change BEST explains this reduction in hypersensitivity with age?",
      options: [
        "Expansion of pulpal chamber with age",
        "Increased number of open dentinal tubules",
        "Enhanced nerve fiber density in pulp",
        "Increased secondary and tertiary dentin formation",
      ],
      correct: "D"
    },
    {
      id: 23956,
      question: "During patient assessment, you identify that a right-handed patient exhibits hypersensitivity primarily on the left side of the mouth. What is the MOST likely explanation?",
      options: [
        "More vigorous cleaning of left-sided teeth",
        "Genetic predisposition affects only one side",
        "Decreased salivary flow on the left side",
        "Previous trauma only to left-sided teeth",
      ],
      correct: "A"
    },
    {
      id: 23957,
      question: "A patient complains of tooth pain. To diagnose dentinal hypersensitivity, you must first rule out other conditions. What is dentinal hypersensitivity considered in the diagnostic process?",
      options: [
        "Primary diagnosis based on patient complaint",
        "Diagnosis of exclusion after eliminating other causes",
        "Secondary diagnosis to periodontal disease",
        "Presumptive diagnosis requiring no examination",
      ],
      correct: "B"
    },
    {
      id: 23958,
      question: "During clinical examination for suspected dentinal hypersensitivity, what finding must be present at the site of sensitivity?",
      options: [
        "Deep periodontal pockets exceeding 5 mm",
        "Radiographic evidence of periapical pathology",
        "Exposed dentin with no clinical caries",
        "Multiple fractured restorations present",
      ],
      correct: "C"
    },
    {
      id: 23959,
      question: "A patient reports tooth sensitivity to cold. On the radiograph, you observe radiolucency at the cervical third of tooth #6. What must be confirmed clinically to support a diagnosis of dentinal hypersensitivity?",
      options: [
        "Presence of large carious lesion",
        "Evidence of periapical abscess formation",
        "Deep periodontal bone loss present",
        "Absence of pulpal inflammation or fracture lines",
      ],
      correct: "D"
    },
    {
      id: 23960,
      question: "You are conducting a teledentistry consultation for a patient with tooth sensitivity during COVID-19 pandemic. What is an important limitation to emphasize?",
      options: [
        "Teledentistry completely replaces in-person visits for all conditions",
        "Virtual assessment allows definitive diagnosis without examination",
        "All treatment can be completed remotely",
        "Telehealth visit does not replace in-person visit for pain",
      ],
      correct: "D"
    },
    {
      id: 23961,
      question: "A patient presents with suspected dentinal hypersensitivity. Before recommending treatment, what should be completed to evaluate remineralization capacity?",
      options: [
        "Complete blood count and chemistry panel",
        "Salivary flow and buffering capacity tests",
        "Urinalysis and kidney function tests",
        "Liver enzymes and coagulation studies",
      ],
      correct: "B"
    },
    {
      id: 23962,
      question: "When developing a care plan for dentinal hypersensitivity, what is the FIRST step in management?",
      options: [
        "Immediate application of bonding agents",
        "Prescription of systemic pain medications",
        "Identification of condition's cause and risk factors",
        "Referral for periodontal surgery consultation",
      ],
      correct: "C"
    },
    {
      id: 23963,
      question: "A patient with dentinal hypersensitivity asks about dietary modifications. Which recommendation is MOST appropriate for behavior modification?",
      options: [
        "Increase consumption of carbonated acidic beverages",
        "Consume more sugary foods between meals",
        "Drink hot coffee immediately followed by ice water",
        "Avoid acidic foods and extremes in temperature",
      ],
      correct: "D"
    },
    {
      id: 23964,
      question: "According to current evidence, what mechanism describes how potassium nitrate works as a desensitizing agent?",
      options: [
        "Physically blocks dentinal tubules with particles",
        "Chemically precipitates minerals at tubule entrances",
        "Increases metabolism of odontoblasts forming dentin",
        "Depolarizes nerves making them unresponsive to stimulus",
      ],
      correct: "D"
    },
    {
      id: 23965,
      question: "A patient asks about over-the-counter desensitizing toothpaste containing 5% potassium nitrate. What instruction is MOST important for effectiveness?",
      options: [
        "Use once weekly for maximum benefit",
        "Apply only when experiencing sensitivity episodes",
        "Alternate with regular toothpaste every other day",
        "Regular and continuous applications are needed",
      ],
      correct: "D"
    },
    {
      id: 23966,
      question: "You recommend a desensitizing dentifrice containing 0.454% stannous fluoride to a patient. What is the PRIMARY mechanism of action?",
      options: [
        "Depolarizes neural synapses blocking transmission",
        "Increases pulpal blood flow reducing sensitivity",
        "Stimulates odontoblasts to produce tertiary dentin",
        "Forms protective smear layer and precipitates calcium fluoride",
      ],
      correct: "D"
    },
    {
      id: 23967,
      question: "A patient is using a dentifrice with 8% arginine and calcium carbonate. How does this product reduce dentinal hypersensitivity?",
      options: [
        "Chemically etches enamel to remove stains",
        "Physically blocks tubules by sealing them",
        "Increases salivary flow to buffer acids",
        "Systemically strengthens dentin structure formation",
      ],
      correct: "B"
    },
    {
      id: 23968,
      question: "What is an important side effect to discuss with patients using stannous fluoride formulations for desensitivity?",
      options: [
        "Severe allergic reactions occur frequently",
        "Permanent tooth mobility develops over time",
        "Tooth staining can occur with use",
        "Enamel erosion accelerates significantly",
      ],
      correct: "C"
    },
    {
      id: 23969,
      question: "A patient asks how often to apply desensitizing dentifrice for optimal results. What is the recommended frequency?",
      options: [
        "Once monthly for maintenance only",
        "Only when pain occurs occasionally",
        "Once weekly on weekends only",
        "Twice daily during routine brushing",
      ],
      correct: "D"
    },
    {
      id: 23970,
      question: "Before applying a professionally applied desensitizing agent, what must be completed first?",
      options: [
        "Application of topical fluoride varnish",
        "Placement of rubber dam isolation",
        "Administration of local anesthetic always",
        "Removal of hard and soft deposits",
      ],
      correct: "D"
    },
    {
      id: 23971,
      question: "A dental hygienist plans to apply 5% sodium fluoride varnish for a patient with dentinal hypersensitivity. What is the PRIMARY limitation of this treatment?",
      options: [
        "Strong evidence supports long-term hypersensitivity relief",
        "Varnish is contraindicated in all adult patients",
        "Evidence is weak for dentinal hypersensitivity relief",
        "Permanent pulpal damage occurs with application",
      ],
      correct: "C"
    },
    {
      id: 23972,
      question: "You are applying an in-office desensitizing paste containing 8% arginine and calcium carbonate after scaling. How should this paste be applied?",
      options: [
        "Hand application with gentle finger pressure",
        "Air abrasion technique with aluminum oxide",
        "Ultrasonic scaler with water irrigation",
        "Prophylaxis cup on prophy angle with moderate pressure",
      ],
      correct: "D"
    },
    {
      id: 23973,
      question: "A patient asks about the mechanism of CPP-ACP (casein phosphopeptide-amorphous calcium phosphate) for desensitization. What is the proposed mechanism?",
      options: [
        "Depolarizes nerves blocking pain transmission",
        "Dissolves enamel exposing fresh surface",
        "Increases dentin porosity enhancing remineralization",
        "Ion release leads to precipitate plugging tubules",
      ],
      correct: "D"
    },
    {
      id: 23974,
      question: "What is the PRIMARY limitation of using HEMA-containing primers (5% glutaraldehyde and 35% HEMA) for dentinal hypersensitivity?",
      options: [
        "Immediate permanent desensitization guaranteed",
        "FDA approval for all applications established",
        "No side effects reported in literature",
        "Mixed results and more evidence needed",
      ],
      correct: "D"
    },
    {
      id: 23975,
      question: "A dentist is considering glass ionomer cement for treating dentinal hypersensitivity in cervical abrasions. Under what condition is this treatment effective?",
      options: [
        "When applied to any tooth surface",
        "If it covers the affected area",
        "Only when combined with amalgam",
        "When placed subgingivally exclusively",
      ],
      correct: "B"
    },
    {
      id: 23976,
      question: "According to current research, what is the PRIMARY advantage of laser therapy for dentinal hypersensitivity?",
      options: [
        "Guaranteed permanent elimination of all sensitivity",
        "Works slower than all other modalities",
        "Requires multiple treatments over years",
        "One treatment can reduce or eliminate sensitivity",
      ],
      correct: "D"
    },
    {
      id: 23977,
      question: "A patient with severe dentinal hypersensitivity has failed conservative treatment. What is the MOST common and predictable surgical procedure for Miller Class I and II defects?",
      options: [
        "Guided tissue regeneration with membranes",
        "Subepithelial connective tissue graft procedure",
        "Free gingival graft from palate",
        "Coronally advanced flap without grafting",
      ],
      correct: "B"
    },
    {
      id: 23978,
      question: "In what percentage of tooth development does cementum overlap enamel at the cementoenamel junction?",
      options: [
        "30% to 35% of the time",
        "45% to 50% of the time",
        "60% to 65% of the time",
        "80% to 85% of the time",
      ],
      correct: "C"
    },
    {
      id: 23979,
      question: "Sensory nerve fibers extend what percentage of the distance from the pulpal side of the dentinal tubule to the dentinoenamel junction?",
      options: [
        "5% to 8% of the distance",
        "25% to 30% of the distance",
        "10% to 15% of the distance",
        "40% to 50% of the distance",
      ],
      correct: "C"
    },
    {
      id: 23980,
      question: "A patient presents with stimulation of C-fibers. What type of pain would this patient MOST likely experience?",
      options: [
        "Sharp, well-localized pain lasting seconds",
        "Intermittent stabbing pain with movement",
        "Electric shock-like pain with touch",
        "Dull, poorly localized aching pain",
      ],
      correct: "D"
    },
    {
      id: 23981,
      question: "Which tooth type and surface location is MOST commonly affected by localized gingival recession?",
      options: [
        "Molars on lingual surfaces primarily",
        "Incisors on palatal surfaces only",
        "All teeth equally on all surfaces",
        "Canines and premolars on buccal surfaces",
      ],
      correct: "D"
    },
    {
      id: 23982,
      question: "A 70-year-old patient presents with gingival recession. Which factor contributes to the increased recession prevalence with age?",
      options: [
        "Single acute traumatic event",
        "Cumulative effect of etiologic factors",
        "Sudden onset of systemic disease",
        "Improved oral hygiene practices",
      ],
      correct: "B"
    },
    {
      id: 23983,
      question: "What is the relationship between manual and powered toothbrushes regarding their contribution to gingival recession?",
      options: [
        "Powered toothbrushes cause significantly more recession",
        "Manual toothbrushes cause significantly more recession",
        "No evidence substantiates a difference between them",
        "Both are equally contraindicated for all patients",
      ],
      correct: "C"
    },
    {
      id: 23984,
      question: "A patient with evidence of bruxism presents with gingival recession. What is the MOST likely relationship between these findings?",
      options: [
        "No correlation exists between bruxism and recession",
        "Bruxism prevents recession by strengthening tissues",
        "Recession causes bruxism through nerve stimulation",
        "Occlusal forces may exacerbate preexisting periodontal lesions",
      ],
      correct: "D"
    },
    {
      id: 23985,
      question: "A patient has a restoration with margins placed subgingivally. What is the MOST likely relationship to gingival recession?",
      options: [
        "Subgingival margins always prevent recession",
        "Only defective restorations cause recession",
        "Restoration margins have no effect on tissues",
        "Sound fillings with subgingival margins can cause recession",
      ],
      correct: "D"
    },
    {
      id: 23986,
      question: "Compared to nonsmokers, what effect does cigarette smoking have on gingival recession?",
      options: [
        "Smoking prevents recession through increased blood flow",
        "Smoking has no effect on recession rates",
        "Smoking only affects recession in older adults",
        "Smoking causes recession due to decreased blood flow",
      ],
      correct: "D"
    },
    {
      id: 23987,
      question: "A patient has an oral tongue piercing. What risk does this pose for oral tissues?",
      options: [
        "Enhanced tissue health through stimulation",
        "Improved salivary flow and remineralization",
        "No risks associated with oral piercings",
        "Trauma to teeth and gingival recession",
      ],
      correct: "D"
    },
    {
      id: 23988,
      question: "Where is attrition from masticatory forces MOST commonly observed?",
      options: [
        "Buccal cervical surfaces of all teeth",
        "Lingual surfaces of maxillary molars",
        "Palatal surfaces of anterior teeth",
        "Incisal or occlusal surfaces of teeth",
      ],
      correct: "D"
    },
    {
      id: 23989,
      question: "A patient with acid reflux disease presents with tooth structure loss on lingual surfaces. What type of erosion is occurring?",
      options: [
        "Extrinsic erosion from dietary acids",
        "Intrinsic erosion from acid regurgitation",
        "Abrasion from mechanical forces",
        "Attrition from tooth-to-tooth contact",
      ],
      correct: "B"
    },
    {
      id: 23990,
      question: "What percentage of tooth sensitivity sufferers do NOT report their pain to dental professionals?",
      options: [
        "Approximately 10% of sufferers",
        "Approximately 25% of sufferers",
        "Approximately 50% of sufferers",
        "Approximately 75% of sufferers",
      ],
      correct: "C"
    },
    {
      id: 23991,
      question: "When screening patients for dentinal hypersensitivity, which question is MOST appropriate to identify the condition?",
      options: [
        "\"Do you brush your teeth daily?\"",
        "\"Do you avoid foods due to tooth sensitivity?\"",
        "\"How many dental visits do you have yearly?\"",
        "\"What type of toothbrush do you use?\"",
      ],
      correct: "B"
    },
    {
      id: 23992,
      question: "According to patient surveys, what percentage of sensitive tooth patients report cold as a triggering stimulus?",
      options: [
        "Cold triggers sensitivity in 40% of patients",
        "Cold triggers sensitivity in 60% of patients",
        "Cold triggers sensitivity in 80% of patients",
        "Cold triggers sensitivity in 95% of patients",
      ],
      correct: "C"
    },
    {
      id: 23993,
      question: "A patient reports spontaneous or lingering pain rather than short, sharp, transient pain. What should be included in the differential diagnosis?",
      options: [
        "Confirmed diagnosis of dentinal hypersensitivity",
        "Normal tooth response requiring no treatment",
        "Psychological pain disorder only",
        "Other dental defects like caries or pulpitis",
      ],
      correct: "D"
    },
    {
      id: 23994,
      question: "On which surfaces of teeth is dentinal hypersensitivity MOST prevalent?",
      options: [
        "Lingual surfaces of mandibular molars",
        "Buccal cervical regions of teeth",
        "Occlusal surfaces of posterior teeth",
        "Palatal surfaces of maxillary incisors",
      ],
      correct: "B"
    },
    {
      id: 23995,
      question: "What radiographic finding might be confused with pathologic radiolucency when diagnosing dentinal hypersensitivity?",
      options: [
        "Periapical granuloma at apex",
        "Cervical burnout artifact",
        "Internal root resorption",
        "External root resorption",
      ],
      correct: "B"
    },
    {
      id: 23996,
      question: "A patient's dentinal hypersensitivity fails to respond to self-applied desensitizing agents. What is the NEXT appropriate step?",
      options: [
        "Discontinue all treatment permanently",
        "Immediate tooth extraction",
        "No further options are available",
        "Professionally applied desensitizing agents",
      ],
      correct: "D"
    },
    {
      id: 23997,
      question: "When applying professionally applied desensitizing agents, what is legally and ethically required before treatment?",
      options: [
        "Written consent from family members",
        "No consent needed for topical agents",
        "Verbal consent from dental assistant",
        "Discussion of side effects and informed consent",
      ],
      correct: "D"
    },
    {
      id: 23998,
      question: "How long should desensitizing agents containing HEMA be rubbed on hypersensitive dentin before air-drying?",
      options: [
        "Approximately 5 seconds only",
        "Approximately 30 seconds duration",
        "Approximately 60 seconds duration",
        "Approximately 10 seconds duration",
      ],
      correct: "D"
    },
    {
      id: 23999,
      question: "A patient asks about the ADA Seal of Acceptance for desensitizing products. What does this seal indicate?",
      options: [
        "Product is FDA-approved medication",
        "Product works better than all alternatives",
        "Product requires prescription from dentist",
        "Product meets ADA criteria for treatment claims",
      ],
      correct: "D"
    },
    {
      id: 24000,
      question: "What is a PRIMARY characteristic distinguishing hypersensitive dentin from nonsensitive dentin?",
      options: [
        "Thick, heavily calcified smear layer present",
        "Fewer dentinal tubules at surface",
        "Complete tubular occlusion by minerals",
        "Dentinal tubules open to oral cavity",
      ],
      correct: "D"
    },
    {
      id: 24001,
      question: "A patient with orthodontic treatment history presents with recession. What is the relationship between orthodontic treatment and recession?",
      options: [
        "Orthodontics always prevents recession completely",
        "Orthodontics has no effect on gingival tissues",
        "Recession only occurs with improper appliance use",
        "Moving teeth through buccal plate may predispose to recession",
      ],
      correct: "D"
    },
    {
      id: 24002,
      question: "When evaluating a patient for dentinal hypersensitivity, what finding indicates the need for further diagnostic testing?",
      options: [
        "Short, sharp pain to cold stimulus",
        "Exposed dentin at cervical areas",
        "Gingival recession on buccal surfaces",
        "Severe lingering pain suggesting pulpal pathology",
      ],
      correct: "D"
    },
    {
      id: 24003,
      question: "A patient using home bleaching reports sensitivity. What concentration adjustment might help reduce symptoms?",
      options: [
        "Increase concentration for faster desensitization",
        "Use maximum concentration for shortest time",
        "Bleach continuously without interruption",
        "Reduce frequency or concentration of bleaching",
      ],
      correct: "D"
    },
    {
      id: 24004,
      question: "What is the PRIMARY advantage of self-applied desensitizing agents over professionally applied treatments?",
      options: [
        "Self-applied agents work faster permanently",
        "Self-applied agents are more effective always",
        "No need for regular applications",
        "Cost effective, safe, noninvasive, and convenient",
      ],
      correct: "D"
    },
    {
      id: 24005,
      question: "According to the hydrodynamic theory, where are free A-delta nerve endings located?",
      options: [
        "At the outer enamel surface",
        "Within the periodontal ligament space",
        "At the cementoenamel junction exclusively",
        "Near the odontoblastic layer of pulp-dentin interface",
      ],
      correct: "D"
    },
    {
      id: 24006,
      question: "A patient asks why their dentist recommended waiting before treating sensitivity after periodontal surgery. What is the BEST explanation?",
      options: [
        "Sensitivity after surgery is imaginary",
        "Surgery permanently damages all nerves",
        "Treatment is never appropriate after surgery",
        "Many patients experience temporary post-surgical sensitivity",
      ],
      correct: "D"
    },
    {
      id: 24007,
      question: "What percentage of strontium acetate is found in dentifrices shown to be effective for desensitivity?",
      options: [
        "2% strontium acetate concentration",
        "5% strontium acetate concentration",
        "10% strontium acetate concentration",
        "20% strontium acetate concentration",
      ],
      correct: "C"
    },
    {
      id: 24008,
      question: "When is 38% silver diamine fluoride indicated for dentinal hypersensitivity treatment?",
      options: [
        "As first-line treatment for all patients",
        "Only for children under age 12",
        "Never indicated for sensitivity treatment",
        "For desensitization, caries prevention, and arrest",
      ],
      correct: "D"
    },
    {
      id: 24009,
      question: "What is an important consideration when using 38% silver diamine fluoride?",
      options: [
        "It whitens teeth permanently",
        "It will stain active caries lesions black",
        "It requires multiple applications daily",
        "It is contraindicated in all adults",
      ],
      correct: "B"
    },
    {
      id: 24010,
      question: "A patient asks about the mechanism of action for calcium sodium phosphosilicate (NovaMin). What occurs when this bioactive glass contacts saliva?",
      options: [
        "Immediate nerve depolarization and blockade",
        "Enamel dissolution exposing fresh surface",
        "Pulpal tissue stimulation increasing blood flow",
        "Calcium and phosphate ion release forming hydroxyapatite",
      ],
      correct: "D"
    },
    {
      id: 24011,
      question: "What is the PRIMARY limitation of using sodium fluoride varnish specifically for dentinal hypersensitivity?",
      options: [
        "Strong evidence for hypersensitivity relief",
        "Permanent damage to dental pulp",
        "Complete contraindication in all patients",
        "Indicated for caries prevention but limited evidence for sensitivity",
      ],
      correct: "D"
    },
    {
      id: 24012,
      question: "According to evidence, how do adhesive resin bonding primers reduce dentinal hypersensitivity?",
      options: [
        "Increasing dentin permeability for better flow",
        "Occluding open dentinal tubules decreasing permeability",
        "Dissolving dentin to expose nerve endings",
        "Stimulating inflammation to activate healing",
      ],
      correct: "B"
    },
    {
      id: 24013,
      question: "In Case Study 42.1, patient CM had VAS (Visual Analog Scale) of 10 before connective tissue graft. What was the VAS value 6 weeks post-surgery?",
      options: [
        "VAS value remained at 10",
        "VAS value worsened to 15",
        "VAS value improved to 0",
        "VAS value improved to 5",
      ],
      correct: "D"
    },
    {
      id: 24014,
      question: "What type of graft procedure is described in Case Study 42.1 for treating dentinal hypersensitivity?",
      options: [
        "Free gingival graft from palate",
        "Subepithelial connective tissue graft",
        "Acellular dermal matrix allograft",
        "Synthetic membrane barrier technique",
      ],
      correct: "B"
    },
    {
      id: 24015,
      question: "A patient asks about expected timeline for dentinal hypersensitivity relief with desensitizing dentifrice. What is the MOST accurate response?",
      options: [
        "Immediate relief within 24 hours",
        "No relief expected from any product",
        "Results occur only after one application",
        "Several days to weeks with regular use",
      ],
      correct: "D"
    },
    {
      id: 24016,
      question: "What instruction should be given to patients about applying desensitizing dentifrice for maximum effectiveness?",
      options: [
        "Rinse mouth immediately after application",
        "Apply only to toothbrush bristles",
        "Use only in the morning before breakfast",
        "Dab dentifrice on sensitive areas at bedtime",
      ],
      correct: "D"
    },
    {
      id: 24017,
      question: "A patient using at-home bleaching asks about preventing sensitivity. What should be recommended BEFORE in-office bleaching?",
      options: [
        "Take systemic antibiotics prophylactically",
        "Avoid all oral hygiene practices",
        "Increase bleaching agent concentration",
        "Use concurrent fluoride therapy",
      ],
      correct: "D"
    },
    {
      id: 24018,
      question: "What is the recommended approach when dental hygienists encounter patients with dentinal hypersensitivity?",
      options: [
        "Refer all patients immediately for surgery",
        "Ignore patient complaints about sensitivity",
        "Recommend only the most expensive treatments",
        "Stay informed of evidence, select appropriate treatments, educate patients",
      ],
      correct: "D"
    },
    {
      id: 24019,
      question: "A patient with dentinal hypersensitivity asks about the role of dental hygienists in treatment. What is the MOST appropriate response?",
      options: [
        "Hygienists have no role in managing sensitivity",
        "Hygienists can only educate but not treat",
        "Hygienists must refer all cases immediately",
        "Hygienists can recommend and apply treatments within scope",
      ],
      correct: "D"
    },
    {
      id: 24020,
      question: "When periodontal debridement causes considerable discomfort in areas with dentinal hypersensitivity, what should be done?",
      options: [
        "Proceed without anesthesia to toughen tissues",
        "Avoid debridement permanently in these areas",
        "Use only hand instruments without power",
        "Anesthetize teeth before mechanical treatment",
      ],
      correct: "D"
    },
    {
      id: 24021,
      question: "According to Box 42.3, which factor may expose dentin or open already blocked tubules?",
      options: [
        "Excessive calcium supplementation",
        "Regular prophylaxis with rubber cup",
        "Daily use of non-abrasive toothpaste",
        "Cosmetic tooth whitening procedures",
      ],
      correct: "D"
    },
    {
      id: 24022,
      question: "What should be documented in the dental record after applying desensitizing agents?",
      options: [
        "Only the date of treatment",
        "Only the type of agent used",
        "Only the patient's insurance information",
        "Tooth number, region, agent used, and patient response",
      ],
      correct: "D"
    },
    {
      id: 24023,
      question: "A patient asks about using an ultrasoft toothbrush for dentinal hypersensitivity. What additional instruction should be provided?",
      options: [
        "Apply maximum pressure for effectiveness",
        "Use only once weekly for benefit",
        "Brush only occlusal surfaces",
        "Consider use without toothpaste application",
      ],
      correct: "D"
    },
    {
      id: 24024,
      question: "What must be explained to patients regarding the multifaceted nature of dentinal hypersensitivity?",
      options: [
        "Only one cause exists for all patients",
        "Sensitivity is imaginary with no real causes",
        "Treatment is never successful for anyone",
        "Multiple causes and modifiable risk factors exist",
      ],
      correct: "D"
    },
    {
      id: 24025,
      question: "According to Box 42.4, what dietary information should be discussed with patients experiencing dentinal hypersensitivity?",
      options: [
        "Increase consumption of citrus fruits",
        "Consume more carbonated beverages daily",
        "Eat ice cream frequently to desensitize",
        "Monitor acidic and sugary foods that contribute to hypersensitivity",
      ],
      correct: "D"
    },
    {
      id: 24026,
      question: "What is the significance of effective toothbrushing and interdental cleaning for patients with dentinal hypersensitivity?",
      options: [
        "Oral biofilm control has no effect on sensitivity",
        "Patients should stop all oral hygiene",
        "Only professional cleaning is effective",
        "Effective biofilm control is essential using low-abrasive fluoride dentifrices",
      ],
      correct: "D"
    }
  ],
};
